export let cardData = [
  {
    info: {
      id: "570170",
      name: "Gianis - Ice Cream, Shakes & Sundaes",
      cloudinaryImageId: "2365e2117e199c2b9a2cfa643c31b05c",
      locality: "Charmwood Village",
      areaName: "Charmwood Village",
      costForTwo: "₹250 for two",
      cuisines: ["Ice Cream", "Desserts", "Beverages"],
      avgRating: 4.6,
      veg: true,
      parentId: "427371",
      avgRatingString: "4.6",
      totalRatingsString: "100+",
      promoted: true,
      adTrackingId:
        "cid=11367948~p=3~eid=0000018d-e6da-9519-7de6-c9bc005a035a~srvts=1708975101209~45995",
      sla: {
        deliveryTime: 37,
        lastMileTravel: 3.7,
        serviceability: "SERVICEABLE",
        slaString: "35-40 mins",
        lastMileTravelString: "3.7 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 01:00:00",
        opened: true,
      },
      badges: {
        textExtendedBadges: [
          {
            iconId: "guiltfree/GF_Logo_android_3x",
            shortDescription: "options available",
            fontColor: "#7E808C",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {},
          textExtendedBadges: {
            badgeObject: [
              {
                attributes: {
                  fontColor: "#7E808C",
                  iconId: "guiltfree/GF_Logo_android_3x",
                  description: "",
                  shortDescription: "options available",
                },
              },
            ],
          },
        },
      },
      aggregatedDiscountInfoV3: {},
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=570170",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "543889",
      name: "Kwality Walls Frozen Dessert and Ice Cream Shop",
      cloudinaryImageId: "erypfb2cluupyteh91id",
      locality: "Sarita Vihar",
      areaName: "Badarpur",
      costForTwo: "₹200 for two",
      cuisines: ["Desserts", "Ice Cream", "Ice Cream Cakes"],
      avgRating: 4.4,
      veg: true,
      parentId: "582",
      avgRatingString: "4.4",
      totalRatingsString: "100+",
      sla: {
        deliveryTime: 36,
        lastMileTravel: 4,
        serviceability: "SERVICEABLE",
        slaString: "35-40 mins",
        lastMileTravelString: "4.0 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 05:30:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textExtendedBadges: {},
          textBased: {},
          imageBased: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "40% OFF",
        subHeader: "UPTO ₹80",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=543889",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "655871",
      name: "Big Bowl",
      cloudinaryImageId: "c99751d54e4e1847186c62b3309c1327",
      locality: "KALKAJI",
      areaName: "Badarpur Metro Station",
      costForTwo: "₹250 for two",
      cuisines: ["North Indian", "Chinese", "Tibetan", "Desserts"],
      avgRating: 4,
      parentId: "434792",
      avgRatingString: "4.0",
      totalRatingsString: "100+",
      sla: {
        deliveryTime: 34,
        lastMileTravel: 2.9,
        serviceability: "SERVICEABLE",
        slaString: "30-35 mins",
        lastMileTravelString: "2.9 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 01:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "50% OFF",
        subHeader: "UPTO ₹100",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=655871",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "574330",
      name: "NOTO - Ice Creams & Desserts",
      cloudinaryImageId: "81ac87e5c89c16adc867be38ce5a1ba3",
      locality: "Sector 4",
      areaName: "Madangir",
      costForTwo: "₹250 for two",
      cuisines: ["Ice Cream", "Desserts"],
      avgRating: 4.3,
      veg: true,
      parentId: "468478",
      avgRatingString: "4.3",
      totalRatingsString: "100+",
      sla: {
        deliveryTime: 33,
        lastMileTravel: 9.9,
        serviceability: "SERVICEABLE",
        slaString: "30-35 mins",
        lastMileTravelString: "9.9 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 02:00:00",
        opened: true,
      },
      badges: {
        textExtendedBadges: [
          {
            iconId: "guiltfree/GF_Logo_android_3x",
            shortDescription: "brand",
            fontColor: "#7E808C",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {},
          textExtendedBadges: {
            badgeObject: [
              {
                attributes: {
                  iconId: "guiltfree/GF_Logo_android_3x",
                  description: "",
                  shortDescription: "brand",
                  fontColor: "#7E808C",
                },
              },
            ],
          },
        },
      },
      aggregatedDiscountInfoV3: {
        header: "60% OFF",
        subHeader: "UPTO ₹120",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=574330",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "39265",
      name: "KFC",
      cloudinaryImageId: "f01666ac73626461d7455d9c24005cd4",
      locality: "Crown Interiorz Mall",
      areaName: "Sector 35",
      costForTwo: "₹450 for two",
      cuisines: ["Burgers", "Biryani", "American", "Snacks", "Fast Food"],
      avgRating: 4.1,
      parentId: "547",
      avgRatingString: "4.1",
      totalRatingsString: "5K+",
      sla: {
        deliveryTime: 49,
        lastMileTravel: 6.2,
        serviceability: "SERVICEABLE",
        slaString: "45-50 mins",
        lastMileTravelString: "6.2 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 03:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textExtendedBadges: {},
          textBased: {},
          imageBased: {},
        },
      },
      aggregatedDiscountInfoV3: {},
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=39265",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "655870",
      name: "Chinese Wok",
      cloudinaryImageId: "e0839ff574213e6f35b3899ebf1fc597",
      locality: "KALKAJI",
      areaName: "Badarpur Metro Station",
      costForTwo: "₹250 for two",
      cuisines: ["Chinese", "Asian", "Tibetan", "Desserts"],
      avgRating: 4,
      parentId: "61955",
      avgRatingString: "4.0",
      totalRatingsString: "100+",
      sla: {
        deliveryTime: 34,
        lastMileTravel: 2.9,
        serviceability: "SERVICEABLE",
        slaString: "30-35 mins",
        lastMileTravelString: "2.9 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 01:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "50% OFF",
        subHeader: "UPTO ₹100",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=655870",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "736173",
      name: "Olio - The Wood Fired Pizzeria",
      cloudinaryImageId: "7e651e00dbf998af59ae7c5e3296c982",
      locality: "Neelam Bata Chowk",
      areaName: "Sector 31",
      costForTwo: "₹300 for two",
      cuisines: ["Pizzas", "Pastas", "Fast Food", "Snacks", "Beverages"],
      avgRating: 4.3,
      parentId: "11633",
      avgRatingString: "4.3",
      totalRatingsString: "100+",
      sla: {
        deliveryTime: 51,
        lastMileTravel: 9.2,
        serviceability: "SERVICEABLE",
        slaString: "50-55 mins",
        lastMileTravelString: "9.2 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 05:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "newg.png",
            description: "Gourmet",
          },
        ],
        textExtendedBadges: [
          {
            iconId: "guiltfree/GF_Logo_android_3x",
            shortDescription: "options available",
            fontColor: "#7E808C",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "Gourmet",
                  imageId: "newg.png",
                },
              },
            ],
          },
          textExtendedBadges: {
            badgeObject: [
              {
                attributes: {
                  iconId: "guiltfree/GF_Logo_android_3x",
                  description: "",
                  shortDescription: "options available",
                  fontColor: "#7E808C",
                },
              },
            ],
          },
        },
      },
      aggregatedDiscountInfoV3: {
        header: "ITEMS",
        subHeader: "AT ₹179",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=736173",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "342847",
      name: "Aromas Of Biryani",
      cloudinaryImageId: "szsru4s2q7tcm2psvjqy",
      locality: "Huda Market",
      areaName: "Sector 37",
      costForTwo: "₹300 for two",
      cuisines: ["Biryani", "Beverages"],
      avgRating: 4.3,
      parentId: "36155",
      avgRatingString: "4.3",
      totalRatingsString: "20+",
      sla: {
        deliveryTime: 51,
        lastMileTravel: 4.9,
        serviceability: "SERVICEABLE",
        slaString: "50-55 mins",
        lastMileTravelString: "4.9 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 02:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textExtendedBadges: {},
          textBased: {},
          imageBased: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "20% OFF",
        subHeader: "UPTO ₹100",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=342847",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "327586",
      name: "Delights by INOX",
      cloudinaryImageId: "b857fcf611707fedd3773eb02688f925",
      locality: "Interiorz Mall",
      areaName: "Sector 35",
      costForTwo: "₹400 for two",
      cuisines: ["Fast Food", "Biryani"],
      avgRating: 2.5,
      veg: true,
      parentId: "385095",
      avgRatingString: "2.5",
      totalRatingsString: "10+",
      sla: {
        deliveryTime: 54,
        lastMileTravel: 6.3,
        serviceability: "SERVICEABLE",
        slaString: "50-55 mins",
        lastMileTravelString: "6.3 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 01:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "v1695133679/badges/Pure_Veg111.png",
            description: "pureveg",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  imageId: "v1695133679/badges/Pure_Veg111.png",
                  description: "pureveg",
                },
              },
            ],
          },
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "60% OFF",
        subHeader: "UPTO ₹120",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=327586",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "729306",
      name: "Baap Of rolls",
      cloudinaryImageId: "76ec5cd6480589bec2976d76eb68180c",
      locality: "Gautam Budh Nagar",
      areaName: "Badarpur Border",
      costForTwo: "₹300 for two",
      cuisines: ["Fast Food", "Beverages"],
      avgRating: 3.8,
      parentId: "14310",
      avgRatingString: "3.8",
      totalRatingsString: "50+",
      sla: {
        deliveryTime: 47,
        lastMileTravel: 3,
        serviceability: "SERVICEABLE",
        slaString: "45-50 mins",
        lastMileTravelString: "3.0 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 05:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textExtendedBadges: {},
          textBased: {},
          imageBased: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "50% OFF",
        subHeader: "UPTO ₹100",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=729306",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "655872",
      name: "The Momo Co.",
      cloudinaryImageId: "9668a5819fcba35364dcff30d5f5cfbb",
      locality: "KALKAJI",
      areaName: "Badarpur Metro Station",
      costForTwo: "₹250 for two",
      cuisines: ["Chinese", "Asian", "Tibetan", "Desserts"],
      avgRating: 4,
      parentId: "11442",
      avgRatingString: "4.0",
      totalRatingsString: "50+",
      sla: {
        deliveryTime: 44,
        lastMileTravel: 2.9,
        serviceability: "SERVICEABLE",
        slaString: "40-45 mins",
        lastMileTravelString: "2.9 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 01:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "50% OFF",
        subHeader: "UPTO ₹100",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=655872",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "447688",
      name: "Chicago Pizza",
      cloudinaryImageId: "z7vplkcpx1l3bfivhtqb",
      locality: "Green Fields Colony",
      areaName: "Green Fields Colony",
      costForTwo: "₹350 for two",
      cuisines: ["Pizzas", "Italian", "Beverages"],
      avgRating: 4,
      parentId: "60277",
      avgRatingString: "4.0",
      totalRatingsString: "1K+",
      sla: {
        deliveryTime: 48,
        lastMileTravel: 7.2,
        serviceability: "SERVICEABLE",
        slaString: "45-50 mins",
        lastMileTravelString: "7.2 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 04:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "50% OFF",
        subHeader: "UPTO ₹100",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=447688",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "622927",
      name: "The Dessert Heaven - Pure Veg",
      cloudinaryImageId: "bca418d5554239d48ac1f8ba84a42d79",
      locality: "Sector 31",
      areaName: "Inder Colony",
      costForTwo: "₹200 for two",
      cuisines: ["Bakery", "Desserts", "Sweets", "Ice Cream"],
      avgRating: 4.4,
      veg: true,
      parentId: "350292",
      avgRatingString: "4.4",
      totalRatingsString: "100+",
      sla: {
        deliveryTime: 54,
        lastMileTravel: 9.2,
        serviceability: "SERVICEABLE",
        slaString: "50-55 mins",
        lastMileTravelString: "9.2 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 02:00:00",
        opened: true,
      },
      badges: {
        textExtendedBadges: [
          {
            iconId: "guiltfree/GF_Logo_android_3x",
            shortDescription: "options available",
            fontColor: "#7E808C",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {},
          textExtendedBadges: {
            badgeObject: [
              {
                attributes: {
                  description: "",
                  shortDescription: "options available",
                  fontColor: "#7E808C",
                  iconId: "guiltfree/GF_Logo_android_3x",
                },
              },
            ],
          },
        },
      },
      aggregatedDiscountInfoV3: {
        header: "60% OFF",
        subHeader: "UPTO ₹120",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=622927",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "775707",
      name: "RollsKing",
      cloudinaryImageId: "35662624fc589e6ab075b6af6dbb65d1",
      locality: "Greenfields_FBD",
      areaName: "Greenfields_FBD",
      costForTwo: "₹250 for two",
      cuisines: ["Fast Food", "Rolls & Wraps", "North Indian", "Snacks"],
      avgRating: 4.3,
      parentId: "4697",
      avgRatingString: "4.3",
      totalRatingsString: "100+",
      sla: {
        deliveryTime: 44,
        lastMileTravel: 3.7,
        serviceability: "SERVICEABLE",
        slaString: "40-45 mins",
        lastMileTravelString: "3.7 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 05:00:00",
        opened: true,
      },
      badges: {},
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {},
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "50% OFF",
        subHeader: "UPTO ₹100",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      isNewlyOnboarded: true,
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=775707",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "622931",
      name: "Cheesecakes By CakeZone",
      cloudinaryImageId: "76d5f4055f9d5796bc7b72dfba8bd92b",
      locality: "Sector 31",
      areaName: "Inder Colony",
      costForTwo: "₹200 for two",
      cuisines: ["Bakery", "Desserts"],
      avgRating: 3.9,
      veg: true,
      parentId: "348057",
      avgRatingString: "3.9",
      totalRatingsString: "50+",
      sla: {
        deliveryTime: 53,
        lastMileTravel: 9.2,
        serviceability: "SERVICEABLE",
        slaString: "50-55 mins",
        lastMileTravelString: "9.2 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 02:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "newg.png",
            description: "Gourmet",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  imageId: "newg.png",
                  description: "Gourmet",
                },
              },
            ],
          },
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {
        header: "₹125 OFF",
        subHeader: "ABOVE ₹399",
        discountTag: "FLAT DEAL",
      },
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=622931",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
  {
    info: {
      id: "733025",
      name: "The Belgian Waffle Co.",
      cloudinaryImageId: "5116a385bac0548e06c33c08350fbf11",
      locality: "ASHOKA ENCLAVE",
      areaName: "CROWN INTERIOR MALL",
      costForTwo: "₹200 for two",
      cuisines: ["Waffle", "Desserts", "Ice Cream"],
      avgRating: 4.6,
      veg: true,
      parentId: "2233",
      avgRatingString: "4.6",
      totalRatingsString: "100+",
      sla: {
        deliveryTime: 44,
        lastMileTravel: 7.1,
        serviceability: "SERVICEABLE",
        slaString: "40-45 mins",
        lastMileTravelString: "7.1 km",
        iconType: "ICON_TYPE_EMPTY",
      },
      availability: {
        nextCloseTime: "2024-02-27 03:00:00",
        opened: true,
      },
      badges: {
        imageBadges: [
          {
            imageId: "v1695133679/badges/Pure_Veg111.png",
            description: "pureveg",
          },
        ],
      },
      isOpen: true,
      type: "F",
      badgesV2: {
        entityBadges: {
          textBased: {},
          imageBased: {
            badgeObject: [
              {
                attributes: {
                  description: "pureveg",
                  imageId: "v1695133679/badges/Pure_Veg111.png",
                },
              },
            ],
          },
          textExtendedBadges: {},
        },
      },
      aggregatedDiscountInfoV3: {},
      differentiatedUi: {
        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
        differentiatedUiMediaDetails: {
          mediaType: "ADS_MEDIA_ENUM_IMAGE",
          lottie: {},
          video: {},
        },
      },
      reviewsSummary: {},
      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
      restaurantOfferPresentationInfo: {},
      externalRatings: {
        aggregatedRating: {
          rating: "--",
        },
      },
      ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
    },
    analytics: {},
    cta: {
      link: "swiggy://menu?restaurant_id=733025",
      text: "RESTAURANT_MENU",
      type: "DEEPLINK",
    },
  },
];
export let menuData = {
  statusCode: 0,
  data: {
    statusMessage: "done successfully",
    cards: [
      {
        groupedCard: {
          cardGroupMap: {
            REGULAR: {
              cards: [
                {
                  card: {
                    card: {
                      "@type":
                        "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      badges: {},
                      vegOnlyDetails: {
                        imageId: "AutoVegOnly_qkjowj",
                        title: "Showing only vegetarian options.",
                        description: "Tap on the VEG ONLY button to turn off the setting",
                      },
                      topRatedFilter: {},
                      kidsCategoryFilter: {
                        attributes: {
                          displayText: "Kids Favourites",
                          tooltip: {
                            enabled: true,
                            displayText:
                              "Kids Favourites Filter applied. Remove this filter to see the full Menu.",
                          },
                        },
                      },
                      vegFilter: {
                        attributes: {
                          displayText: "VEG",
                        },
                      },
                      nonvegFilter: {
                        attributes: {
                          displayText: "NONVEG",
                        },
                      },
                    },
                    relevance: {
                      type: "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      sectionId: "MENU_FILTER_TOGGLE",
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      title: "Top Picks",
                      carousel: [
                        {
                          type: "TopCarousel",
                          subtype: "image",
                          bannerId: "1814328",
                          creativeId: "TopPicks/24054943B.png",
                          title: "Chicken Shawarma",
                          description: " ",
                          fontColor: "#FFFFFF",
                          dish: {
                            info: {
                              id: "24054943",
                              name: "Chicken Shawarma",
                              category: "Shawarma",
                              description:
                                "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                              imageId: "whobcsb2vwalztixhopi",
                              inStock: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203095",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203096",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          type: "TopCarousel",
                          subtype: "image",
                          bannerId: "1814329",
                          creativeId: "TopPicks/24054946B.png",
                          title: "Chicken Momos (8 Pieces)",
                          description: " ",
                          fontColor: "#FFFFFF",
                          dish: {
                            info: {
                              id: "24054946",
                              name: "Chicken Momos (8 Pieces)",
                              category: "Momos",
                              description:
                                "50 ml | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                              imageId: "rqztsxexf4uhepjpwfm6",
                              inStock: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203107",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments:
                                  "Served with Served with mayonnaise and red chilli sauce",
                                portionSize: "50 ml",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Recommended",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054943",
                              name: "Chicken Shawarma",
                              category: "Shawarma",
                              description:
                                "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                              imageId: "whobcsb2vwalztixhopi",
                              inStock: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203095",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203096",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "2923 ratings",
                                  ratingCountV2: "2923",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "36211921",
                              name: "Creamy Chicken Shawarma",
                              category: "Shawarma",
                              description:
                                "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add on cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                              imageId: "fb2tuglzzfa6obm7d6cs",
                              inStock: 1,
                              price: 16900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203092",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203106",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "489 ratings",
                                  ratingCountV2: "489",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054944",
                              name: "Roasted Chicken Shawarma Bowl",
                              category: "Shawarma",
                              description:
                                "50 ml | Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and put in a microwave safe bowl and served fresh to our beloved customers.",
                              imageId: "ow3qpjqq51rxzcv1klkb",
                              inStock: 1,
                              price: 26900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203097",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203098",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                portionSize: "50 ml",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "492 ratings",
                                  ratingCountV2: "492",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "33883619",
                              name: "Paneer Shawarma",
                              category: "Shawarma",
                              description:
                                "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine.",
                              imageId: "47876777e4c1f5a567e1a439304600e3",
                              inStock: 1,
                              isVeg: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203101",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203102",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "VEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments: "Served with Served with mayonnaise and mint sauce",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "371 ratings",
                                  ratingCountV2: "371",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054946",
                              name: "Chicken Momos (8 Pieces)",
                              category: "Momos",
                              description:
                                "50 ml | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                              imageId: "rqztsxexf4uhepjpwfm6",
                              inStock: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203107",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments:
                                  "Served with Served with mayonnaise and red chilli sauce",
                                portionSize: "50 ml",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "1454 ratings",
                                  ratingCountV2: "1454",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "130267359",
                              name: "Cheese Corn Momos ( Newly Added )",
                              category: "Momos",
                              description:
                                "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos qsr chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                              imageId: "272cb272dc392196faf2e343425cf6f5",
                              inStock: 1,
                              isVeg: 1,
                              price: 14900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "127592292",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "123277941",
                              name: "Kurkure Paneer Momos (8 Pieces)",
                              category: "Kurkure, Chinese & Indian Fusion",
                              description:
                                "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                              imageId: "734063890947eed2463996c6d4ec3268",
                              inStock: 1,
                              isVeg: 1,
                              price: 23900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "106473894",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "18 ratings",
                                  ratingCountV2: "18",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "123277940",
                              name: "Chicken Tangdi Fry (2 Pieces)",
                              category: "Kurkure, Chinese & Indian Fusion",
                              description: "Crispy ",
                              imageId: "0d82c121cd2643716ce05e96f1c4698f",
                              inStock: 1,
                              price: 21900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "9 ratings",
                                  ratingCountV2: "9",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054948",
                              name: "Mineral Water (1 L)",
                              category: "Beverages",
                              description: "Serves 1 | Bisleri or. Kinley",
                              imageId: "e1gzxr4vc6rodmebeofq",
                              inStock: 1,
                              isVeg: 1,
                              price: 3500,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "102 ratings",
                                  ratingCountV2: "102",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                      type: "CATEGORY_TYPE_RECOMMENDED",
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Shawarma",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054943",
                              name: "Chicken Shawarma",
                              category: "Shawarma",
                              description:
                                "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                              imageId: "whobcsb2vwalztixhopi",
                              inStock: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203095",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203096",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "2923 ratings",
                                  ratingCountV2: "2923",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "36211921",
                              name: "Creamy Chicken Shawarma",
                              category: "Shawarma",
                              description:
                                "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add on cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                              imageId: "fb2tuglzzfa6obm7d6cs",
                              inStock: 1,
                              price: 16900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203092",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203106",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "489 ratings",
                                  ratingCountV2: "489",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054944",
                              name: "Roasted Chicken Shawarma Bowl",
                              category: "Shawarma",
                              description:
                                "Medium Spicy | With Bone | 50 ml | Serves 1 | Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and put in a microwave safe bowl and served fresh to our beloved customers.",
                              imageId: "ow3qpjqq51rxzcv1klkb",
                              inStock: 1,
                              price: 26900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203097",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203098",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                portionSize: "50 ml",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "492 ratings",
                                  ratingCountV2: "492",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "36211923",
                              name: "Creamy Roasted Chicken Shawarma Bowl",
                              category: "Shawarma",
                              description:
                                "Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add in cream and put in a microwave safe bowl and served fresh.",
                              imageId: "a01b7b506c94dab1493011b1cd3335b8",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203099",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203100",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "92 ratings",
                                  ratingCountV2: "92",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "123270735",
                              name: "Chicken Shawarma Roll + Roasted Shawarma Bowl ** Save Rs.30 Extra",
                              category: "Shawarma",
                              description:
                                "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh.",
                              inStock: 1,
                              price: 37900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "106459174",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "33883619",
                              name: "Paneer Shawarma",
                              category: "Shawarma",
                              description:
                                "Medium Spicy | Comes with Served with mayonnaise and mint sauce | Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine.",
                              imageId: "47876777e4c1f5a567e1a439304600e3",
                              inStock: 1,
                              isVeg: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203101",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203102",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "VEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments: "Served with Served with mayonnaise and mint sauce",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "371 ratings",
                                  ratingCountV2: "371",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "36211924",
                              name: "Creamy Paneer Shawarma",
                              category: "Shawarma",
                              description:
                                "Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine. Just try it out & appreciate the chef's skills.",
                              imageId: "47876777e4c1f5a567e1a439304600e3",
                              inStock: 1,
                              isVeg: 1,
                              price: 16900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203105",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "11130951",
                                      name: "Extra Spicy Filling",
                                      price: 1000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "14486620",
                                      name: "Extra Butter Filling",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 2,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "37203104",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.6",
                                  ratingCount: "74 ratings",
                                  ratingCountV2: "74",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "123270733",
                              name: "Chicken Shawarma [ Super Saver Box ]",
                              category: "Shawarma",
                              description:
                                "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh.",
                              price: 26900,
                              variants: {
                                variantGroups: [
                                  {
                                    groupId: "31395427",
                                    name: "Quantity",
                                    variations: [
                                      {
                                        name: "Box Of 2 [ Save Rs.10 Extra ]",
                                        default: 1,
                                        id: "97251713",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "Box Of 3 [ Save Rs.30 Extra ]",
                                        price: 12000,
                                        id: "97251714",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "Box Of 4 [ Save Rs.50 Extra ]",
                                        price: 24000,
                                        id: "97251715",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "Box Of 5 [ Save Rs.70 Extra ]",
                                        price: 36000,
                                        id: "97251716",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "Box Of 10 [ Save Rs.200 Extra ]",
                                        price: 93000,
                                        id: "97251717",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                    ],
                                  },
                                ],
                              },
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "106459172",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "106465569",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "98089557",
                                      name: "Extra Spicy Fillings",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 1,
                                  maxFreeAddons: -1,
                                },
                              ],
                              nextAvailableAtMessage: "Next available at 4:58 pm, tomorrow",
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "20 ratings",
                                  ratingCountV2: "20",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "123270734",
                              name: "Creamy Chicken Shawarma [ Super Saver Box ]",
                              category: "Shawarma",
                              description:
                                "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarma are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo, some veggies, cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                              price: 30900,
                              variants: {
                                variantGroups: [
                                  {
                                    groupId: "31395428",
                                    name: "Quantity",
                                    variations: [
                                      {
                                        name: "Box Of 2 [ Save Rs.30 Extra ]",
                                        default: 1,
                                        id: "97251718",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "Box Of 3 [ Save Rs.50 Extra ]",
                                        price: 14000,
                                        id: "97251719",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "Box Of 4 [ Save Rs.70 Extra ]",
                                        price: 28000,
                                        id: "97251720",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "Box Of 5 [ Save Rs.100 Extra ]",
                                        price: 41000,
                                        id: "97251721",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                    ],
                                  },
                                ],
                              },
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "106465570",
                                  groupName: "Add-ons",
                                  choices: [
                                    {
                                      id: "98089557",
                                      name: "Extra Spicy Fillings",
                                      price: 3000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 1,
                                  maxFreeAddons: -1,
                                },
                                {
                                  groupId: "106459173",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Momos",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054946",
                              name: "Chicken Momos (8 Pieces)",
                              category: "Momos",
                              description:
                                "Medium Spicy | Comes with Served with mayonnaise and red chilli sauce | 50 ml | Serves 1 | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                              imageId: "rqztsxexf4uhepjpwfm6",
                              inStock: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203107",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments:
                                  "Served with Served with mayonnaise and red chilli sauce",
                                portionSize: "50 ml",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "1454 ratings",
                                  ratingCountV2: "1454",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054945",
                              name: "Paneer Momos (8 Pieces)",
                              category: "Momos",
                              description:
                                "Medium Spicy | Comes with Served with mayonnaise and red chilli sauce | 50 ml | Serves 1 | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and soft paneer pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                              imageId: "oifv5eatmljnshmmyjpd",
                              inStock: 1,
                              isVeg: 1,
                              price: 13900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "37203108",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "VEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments:
                                  "Served with Served with mayonnaise and red chilli sauce",
                                portionSize: "50 ml",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "472 ratings",
                                  ratingCountV2: "472",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "130267359",
                              name: "Cheese Corn Momos ( Newly Added )",
                              category: "Momos",
                              description:
                                "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos qsr chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                              imageId: "272cb272dc392196faf2e343425cf6f5",
                              inStock: 1,
                              isVeg: 1,
                              price: 14900,
                              variants: {},
                              variantsV2: {},
                              addons: [
                                {
                                  groupId: "127592292",
                                  groupName: "Extras",
                                  choices: [
                                    {
                                      id: "11130952",
                                      name: "Extra Mayonnaise Cup (100 ml)",
                                      price: 7000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130953",
                                      name: "Extra Mint Sauce Cup (100 ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                    {
                                      id: "11130954",
                                      name: "Extra Red Chilli Sauce Cup (100ml)",
                                      price: 6000,
                                      inStock: 1,
                                      isVeg: 1,
                                      isEnabled: 1,
                                    },
                                  ],
                                  maxAddons: 3,
                                  maxFreeAddons: -1,
                                },
                              ],
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      title: "Kurkure, Chinese & Indian Fusion",
                      categories: [
                        {
                          title: "Kurkure",
                          itemCards: [
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123270791",
                                  name: "Kurkure Chicken Shawarma",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  description:
                                    "Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This newly added shawarma in our menu is a fusion of lebanese and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot, rolled and served fresh and hot to our beloved customers.",
                                  imageId: "3f6b5a81b57213aeb0758590ad62a2e7",
                                  inStock: 1,
                                  price: 23900,
                                  variants: {},
                                  variantsV2: {},
                                  addons: [
                                    {
                                      groupId: "106459176",
                                      groupName: "Extras",
                                      choices: [
                                        {
                                          id: "11130952",
                                          name: "Extra Mayonnaise Cup (100 ml)",
                                          price: 7000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130953",
                                          name: "Extra Mint Sauce Cup (100 ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130954",
                                          name: "Extra Red Chilli Sauce Cup (100ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                      ],
                                      maxAddons: 3,
                                      maxFreeAddons: -1,
                                    },
                                  ],
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.4",
                                      ratingCount: "16 ratings",
                                      ratingCountV2: "16",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123270792",
                                  name: "Kurkure Chicken Momos (8 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  description:
                                    "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                  imageId: "f31815d1558ff35607a3a83ce0d9b40a",
                                  inStock: 1,
                                  price: 23900,
                                  variants: {},
                                  variantsV2: {},
                                  addons: [
                                    {
                                      groupId: "106459177",
                                      groupName: "Extras",
                                      choices: [
                                        {
                                          id: "11130952",
                                          name: "Extra Mayonnaise Cup (100 ml)",
                                          price: 7000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130953",
                                          name: "Extra Mint Sauce Cup (100 ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130954",
                                          name: "Extra Red Chilli Sauce Cup (100ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                      ],
                                      maxAddons: 3,
                                      maxFreeAddons: -1,
                                    },
                                  ],
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {
                                    text: "Bestseller",
                                    textColor: "#ffffff",
                                    topBackgroundColor: "#d53d4c",
                                    bottomBackgroundColor: "#b02331",
                                  },
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  isBestseller: true,
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.5",
                                      ratingCount: "37 ratings",
                                      ratingCountV2: "37",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123277941",
                                  name: "Kurkure Paneer Momos (8 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  description:
                                    "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                  imageId: "734063890947eed2463996c6d4ec3268",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 23900,
                                  variants: {},
                                  variantsV2: {},
                                  addons: [
                                    {
                                      groupId: "106473894",
                                      groupName: "Extras",
                                      choices: [
                                        {
                                          id: "11130952",
                                          name: "Extra Mayonnaise Cup (100 ml)",
                                          price: 7000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130953",
                                          name: "Extra Mint Sauce Cup (100 ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130954",
                                          name: "Extra Red Chilli Sauce Cup (100ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                      ],
                                      maxAddons: 3,
                                      maxFreeAddons: -1,
                                    },
                                  ],
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.4",
                                      ratingCount: "18 ratings",
                                      ratingCountV2: "18",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "130267360",
                                  name: "Kurkure Cheese Corn Momos (new Launch)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 24900,
                                  variants: {},
                                  variantsV2: {},
                                  addons: [
                                    {
                                      groupId: "127592293",
                                      groupName: "Extras",
                                      choices: [
                                        {
                                          id: "11130952",
                                          name: "Extra Mayonnaise Cup (100 ml)",
                                          price: 7000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130953",
                                          name: "Extra Mint Sauce Cup (100 ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130954",
                                          name: "Extra Red Chilli Sauce Cup (100ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                      ],
                                      maxAddons: 3,
                                      maxFreeAddons: -1,
                                    },
                                  ],
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123270790",
                                  name: "Kurkure Leg (2 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  description:
                                    "Served with mayonnaise and chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering dishes since then and has become 2nd largest shawarma chain in north india. This newly added kurkure leg piece in our menu is a fusion of different cuisines. Inside, it's juicy tender chicken but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                  price: 23900,
                                  variants: {},
                                  variantsV2: {},
                                  addons: [
                                    {
                                      groupId: "106459175",
                                      groupName: "Extras",
                                      choices: [
                                        {
                                          id: "11130952",
                                          name: "Extra Mayonnaise Cup (100 ml)",
                                          price: 7000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130953",
                                          name: "Extra Mint Sauce Cup (100 ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                        {
                                          id: "11130954",
                                          name: "Extra Red Chilli Sauce Cup (100ml)",
                                          price: 6000,
                                          inStock: 1,
                                          isVeg: 1,
                                          isEnabled: 1,
                                        },
                                      ],
                                      maxAddons: 3,
                                      maxFreeAddons: -1,
                                    },
                                  ],
                                  nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                          ],
                        },
                        {
                          title: "Chinese",
                          itemCards: [
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123270794",
                                  name: "Chicken Chilli Momos (8 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  inStock: 1,
                                  price: 29900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123270796",
                                  name: "Paneer Chilli Momos (8 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 29900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123270799",
                                  name: "Chicken 65 Dry (8 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  inStock: 1,
                                  price: 29900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "2.0",
                                      ratingCount: "3 ratings",
                                      ratingCountV2: "3",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123270801",
                                  name: "Chilli Chicken Boneless Thigh (8 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  inStock: 1,
                                  price: 32900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.4",
                                      ratingCount: "5 ratings",
                                      ratingCountV2: "5",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                          ],
                        },
                        {
                          title: "Fried",
                          itemCards: [
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123277940",
                                  name: "Chicken Tangdi Fry (2 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  description: "Crispy ",
                                  imageId: "0d82c121cd2643716ce05e96f1c4698f",
                                  inStock: 1,
                                  price: 21900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.2",
                                      ratingCount: "9 ratings",
                                      ratingCountV2: "9",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "123270809",
                                  name: "Chicken Lollipop Fry (4 Pieces)",
                                  category: "Kurkure, Chinese & Indian Fusion",
                                  description: "Crispy",
                                  imageId: "59695d3e4cca656d5fdc5f577afcc03c",
                                  inStock: 1,
                                  price: 21900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.7",
                                      ratingCount: "31 ratings",
                                      ratingCountV2: "31",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                          ],
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Beverages",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054947",
                              name: "Coke (750 Ml)",
                              category: "Beverages",
                              description: "Serves 1 | Served cold",
                              imageId: "iry5fu453gvnzexxnwu9",
                              inStock: 1,
                              isVeg: 1,
                              price: 8900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "394 ratings",
                                  ratingCountV2: "394",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "24054948",
                              name: "Mineral Water (1 L)",
                              category: "Beverages",
                              description: "Serves 1 | Bisleri or. Kinley",
                              imageId: "e1gzxr4vc6rodmebeofq",
                              inStock: 1,
                              isVeg: 1,
                              price: 3500,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "102 ratings",
                                  ratingCountV2: "102",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Biryani",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "41490562",
                              name: "Chicken Dum Biryani",
                              category: "Biryani",
                              description:
                                "Medium Spicy | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                              imageId: "ugchcdpg05ivuametha2",
                              price: 11900,
                              variants: {
                                variantGroups: [
                                  {
                                    groupId: "4494729",
                                    name: "Quantity",
                                    variations: [
                                      {
                                        name: "300 Gm | (3 Pcs Wings Or Boneless)",
                                        price: 1000,
                                        default: 1,
                                        id: "14465613",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "600 Gm | (5-6 Pcs Wings Or Boneless Pcs)",
                                        price: 12600,
                                        id: "14465614",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "1 Kg | (9-10 Pcs Wings Or Boneless)",
                                        price: 26000,
                                        id: "14465615",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                    ],
                                  },
                                ],
                              },
                              variantsV2: {},
                              nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments:
                                  "Served with mint curd chutney & spicy tomato chutney",
                                portionSize: "Serves 1",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.4",
                                  ratingCount: "1687 ratings",
                                  ratingCountV2: "1687",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "41490556",
                              name: "Chicken Leg Biryani",
                              category: "Biryani",
                              description:
                                "Medium Spicy | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                              imageId: "vzxgkbawopprfnhddtkk",
                              price: 12500,
                              variants: {
                                variantGroups: [
                                  {
                                    groupId: "4494727",
                                    name: "Quantity",
                                    variations: [
                                      {
                                        name: "300 Grams | (1 Leg Piece + Some Boneless Or Wings)",
                                        price: 1000,
                                        default: 1,
                                        id: "14465607",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "600 Grams | (2 Leg Pieces + Some Boneless Or Wings)",
                                        price: 13400,
                                        id: "14465608",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "1 Kg | (4 Leg Pieces + Some Boneless Or Wings)",
                                        price: 27400,
                                        id: "14465609",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                    ],
                                  },
                                ],
                              },
                              variantsV2: {},
                              nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments:
                                  "Served with mint curd chutney & spicy tomato chutney",
                                portionSize: "Serves 1",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "1151 ratings",
                                  ratingCountV2: "1151",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "41490555",
                              name: "Chicken Thigh Biryani",
                              category: "Biryani",
                              description:
                                "Medium Spicy | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                              imageId: "fo6gm5nvjqwshcznoyjk",
                              price: 13500,
                              variants: {
                                variantGroups: [
                                  {
                                    groupId: "4494726",
                                    name: "Quantity",
                                    variations: [
                                      {
                                        name: "300 Grams | (1 Thigh Piece + Boneless Or Wings)",
                                        price: 1000,
                                        default: 1,
                                        id: "14465604",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "600 Grams | (2 Thigh Pieces + Some Boneless Or Wings)",
                                        price: 14000,
                                        id: "14465605",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "1 Kg | (4 Thigh Pieces + Some Boneless Or Wings)",
                                        price: 34400,
                                        id: "14465606",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                    ],
                                  },
                                ],
                              },
                              variantsV2: {},
                              nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "517 ratings",
                                  ratingCountV2: "517",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "41490560",
                              name: "Boneless Chicken Biryani",
                              category: "Biryani",
                              description:
                                "Medium Spicy | Boneless | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                              imageId: "jlvokk4v2bofhxbzqacs",
                              price: 12500,
                              variants: {
                                variantGroups: [
                                  {
                                    groupId: "4494728",
                                    name: "Quantity",
                                    variations: [
                                      {
                                        name: "300 Gm | (3 Pcs Boneless)",
                                        price: 1000,
                                        default: 1,
                                        id: "14465610",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "600 Gm | (5-6 Pcs Boneless)",
                                        price: 13400,
                                        id: "14465611",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "1 Kg | (9-10 Pcs Boneless)",
                                        price: 29400,
                                        id: "14465612",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                    ],
                                  },
                                ],
                              },
                              variantsV2: {},
                              nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                spiceLevel: "MEDIUMSPICY",
                                accompaniments:
                                  "Served with mint curd chutney & spicy tomato chutney",
                                portionSize: "Serves 1",
                              },
                              ribbon: {
                                text: "Bestseller",
                                textColor: "#ffffff",
                                topBackgroundColor: "#d53d4c",
                                bottomBackgroundColor: "#b02331",
                              },
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              isBestseller: true,
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "873 ratings",
                                  ratingCountV2: "873",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "123270736",
                              name: "Boiled Boneless Chicken Breast ( Gym Diet )",
                              category: "Biryani",
                              description:
                                "It is mainly for fitness enthusiasts and gym goers so please don't expect flavourful taste or aroma of signature spices of uncle chicken. It is boiled along with dum biryani so sometimes a little natural food colour may also be present but rest assured, nothing extra would be present not even salt. Just pure tender chicken breast.",
                              imageId: "thjhcqbnjjtlozzbod8u",
                              price: 24900,
                              variants: {
                                variantGroups: [
                                  {
                                    groupId: "31395429",
                                    name: "Quantity",
                                    variations: [
                                      {
                                        name: "200 Gms",
                                        default: 1,
                                        id: "97251722",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                      {
                                        name: "400 Gms [ Save Rs.40 Extra ]",
                                        price: 21100,
                                        id: "97251723",
                                        inStock: 1,
                                        isEnabled: 1,
                                      },
                                    ],
                                  },
                                ],
                              },
                              variantsV2: {},
                              nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "8 ratings",
                                  ratingCountV2: "8",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type":
                        "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      type: "FSSAI",
                      imageId: "fssai_final_edss9i",
                      text: ["License No. 20818003000369"],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      name: "Uncle Chicken - Shawarma, Biryani & Momos",
                      area: "Sector 14",
                      completeAddress:
                        "Shop No. 165, Huda Market Maharishi Parashar Marg, Sector 14 Faridabad, Haryana, 121007",
                    },
                  },
                },
              ],
            },
          },
        },
      },
    ],
    firstOffsetRequest: true,
    isQCLink: false,
  },
  tid: "3e45fb63-b7f2-4d01-9691-275ef61e28c5",
  sid: "cj92ea31-6ce9-4e9b-84c5-807d086719a9",
  deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
  csrfToken: "Z42msBkwELWD-99dLS0tCskhkPNN1qqd2Widzx08",
};

export let RES_MOCK_DATA = {
  statusCode: 0,
  data: {
    statusMessage: "done successfully",
    pageOffset: {
      nextOffset: "COVCELQ4KICgsd224q7FZDCnEzgE",
      widgetOffset: {
        NewListingView_category_bar_chicletranking_TwoRows: "",
        NewListingView_category_bar_chicletranking_TwoRows_Rendition: "",
        Restaurant_Group_WebView_SEO_PB_Theme: "",
        collectionV5RestaurantListWidget_SimRestoRelevance_food_seo: "10",
        inlineFacetFilter: "",
        restaurantCountWidget: "",
      },
    },
    cards: [
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            header: {
              title: "What's on your mind?",
              headerStyling: {
                padding: {
                  left: 16,
                  top: 16,
                  bottom: 4,
                },
              },
            },
            layout: {
              rows: 1,
              columns: 10,
              horizontalScrollEnabled: true,
              itemSpacing: 24,
              widgetPadding: {},
              containerStyle: {
                containerPadding: {
                  left: 8,
                  top: 8,
                  right: 12,
                  bottom: 4,
                },
              },
              scrollBar: {},
              widgetTheme: {
                defaultMode: {
                  backgroundColour: "#FFFFFF",
                  theme: "THEME_TYPE_LIGHT",
                },
                darkMode: {
                  theme: "THEME_TYPE_DARK",
                },
              },
            },
            imageGridCards: {
              info: [
                {
                  id: "762797",
                  imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                    text: "Burgers",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for burger",
                    altTextCta: "open",
                  },
                  entityId:
                    "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                  frequencyCapping: {},
                },
                {
                  id: "750580",
                  imageId: "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83644?collection_id=83644&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                    text: "pizzas",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for pizza",
                    altTextCta: "open",
                  },
                  entityId:
                    "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza&search_context=pizza",
                  frequencyCapping: {},
                },
                {
                  id: "750597",
                  imageId: "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
                    text: "Ice Cream",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for icecream",
                    altTextCta: "open",
                  },
                  entityId: "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
                  frequencyCapping: {},
                },
                {
                  id: "750582",
                  imageId: "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83645?collection_id=83645&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
                    text: "North Indian",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for north indian",
                    altTextCta: "open",
                  },
                  entityId:
                    "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian&search_context=northindian",
                  frequencyCapping: {},
                },
                {
                  id: "750223",
                  imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
                    text: "Rolls",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for roll",
                    altTextCta: "open",
                  },
                  entityId: "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
                  frequencyCapping: {},
                },
                {
                  id: "750592",
                  imageId: "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83649?collection_id=83649&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                    text: "Biryani",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for biryani",
                    altTextCta: "open",
                  },
                  entityId:
                    "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&search_context=biryani",
                  frequencyCapping: {},
                },
                {
                  id: "750588",
                  imageId: "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
                    text: "Chinese",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for chinese",
                    altTextCta: "open",
                  },
                  entityId: "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
                  frequencyCapping: {},
                },
                {
                  id: "750584",
                  imageId: "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83646?collection_id=83646&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                    text: "South Indian",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for south indian",
                    altTextCta: "open",
                  },
                  entityId:
                    "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian&search_context=southindian",
                  frequencyCapping: {},
                },
                {
                  id: "749769",
                  imageId: "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80462?collection_id=80462&tags=layout_CCS_Momos&type=rcv2",
                    text: "Momos",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for momos",
                    altTextCta: "open",
                  },
                  entityId: "swiggy://collectionV2?collection_id=80462&tags=layout_CCS_Momos",
                  frequencyCapping: {},
                },
                {
                  id: "749774",
                  imageId: "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80464?collection_id=80464&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                    text: "Noodles",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for noodles",
                    altTextCta: "open",
                  },
                  entityId: "80464",
                  frequencyCapping: {},
                },
                {
                  id: "749874",
                  imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
                    text: "Cakes",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for cakes",
                    altTextCta: "open",
                  },
                  entityId: "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
                  frequencyCapping: {},
                },
                {
                  id: "750207",
                  imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
                    text: "Pasta",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for pasta",
                    altTextCta: "open",
                  },
                  entityId: "80480",
                  frequencyCapping: {},
                },
                {
                  id: "750217",
                  imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2",
                    text: "Pav Bhaji",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for pav bhaji",
                    altTextCta: "open",
                  },
                  entityId:
                    "swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual",
                  frequencyCapping: {},
                },
                {
                  id: "750636",
                  imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
                    text: "Kebabs",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for kebabs",
                    altTextCta: "open",
                  },
                  entityId: "80452",
                  frequencyCapping: {},
                },
                {
                  id: "750203",
                  imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
                    text: "Paratha",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for paratha",
                    altTextCta: "open",
                  },
                  entityId: "80476",
                  frequencyCapping: {},
                },
                {
                  id: "750226",
                  imageId: "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80395?collection_id=80395&tags=layout_CCS_Salad&type=rcv2",
                    text: "Salad",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for salad",
                    altTextCta: "open",
                  },
                  entityId: "swiggy://collectionV2?collection_id=80395&tags=layout_CCS_Salad",
                  frequencyCapping: {},
                },
                {
                  id: "750593",
                  imageId: "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Gulab_Jamun.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80432?collection_id=80432&tags=layout_BAU_Contextual%2Cgulab_jamun&type=rcv2",
                    text: "Gulab Jamun",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for gulab jamun",
                    altTextCta: "open",
                  },
                  entityId: "80432",
                  frequencyCapping: {},
                },
                {
                  id: "750209",
                  imageId: "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                  action: {
                    link: "https://www.swiggy.com/collections/80358?collection_id=80358&tags=layout_BAU_Contextual%2Clayout_ux4&type=rcv2",
                    text: "Pastry",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for Pastry",
                    altTextCta: "open",
                  },
                  entityId: "80358",
                  frequencyCapping: {},
                },
                {
                  id: "750235",
                  imageId: "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2",
                    text: "Sandwich",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurants curated for sandwich",
                    altTextCta: "open",
                  },
                  entityId: "swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches",
                  frequencyCapping: {},
                },
                {
                  id: "750239",
                  imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                  action: {
                    link: "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
                    text: "Shake",
                    type: "WEBLINK",
                  },
                  entityType: "BANNER",
                  accessibility: {
                    altText: "restaurant curated for shakes",
                    altTextCta: "open",
                  },
                  entityId: "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
                  frequencyCapping: {},
                },
              ],
              style: {
                width: {
                  type: "TYPE_RELATIVE",
                  value: 0.2941,
                  reference: "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH",
                },
                height: {
                  type: "TYPE_RELATIVE",
                  value: 1.2444,
                  reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH",
                },
              },
            },
            id: "whats_on_your_mind",
            gridElements: {
              infoWithStyle: {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                info: [
                  {
                    id: "762797",
                    imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                      text: "Burgers",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for burger",
                      altTextCta: "open",
                    },
                    entityId:
                      "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                    frequencyCapping: {},
                  },
                  {
                    id: "750580",
                    imageId: "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83644?collection_id=83644&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                      text: "pizzas",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for pizza",
                      altTextCta: "open",
                    },
                    entityId:
                      "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza&search_context=pizza",
                    frequencyCapping: {},
                  },
                  {
                    id: "750597",
                    imageId: "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
                      text: "Ice Cream",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for icecream",
                      altTextCta: "open",
                    },
                    entityId: "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
                    frequencyCapping: {},
                  },
                  {
                    id: "750582",
                    imageId: "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83645?collection_id=83645&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
                      text: "North Indian",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for north indian",
                      altTextCta: "open",
                    },
                    entityId:
                      "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian&search_context=northindian",
                    frequencyCapping: {},
                  },
                  {
                    id: "750223",
                    imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
                      text: "Rolls",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for roll",
                      altTextCta: "open",
                    },
                    entityId: "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
                    frequencyCapping: {},
                  },
                  {
                    id: "750592",
                    imageId: "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83649?collection_id=83649&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                      text: "Biryani",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for biryani",
                      altTextCta: "open",
                    },
                    entityId:
                      "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&search_context=biryani",
                    frequencyCapping: {},
                  },
                  {
                    id: "750588",
                    imageId: "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
                      text: "Chinese",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for chinese",
                      altTextCta: "open",
                    },
                    entityId: "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
                    frequencyCapping: {},
                  },
                  {
                    id: "750584",
                    imageId: "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83646?collection_id=83646&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                      text: "South Indian",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for south indian",
                      altTextCta: "open",
                    },
                    entityId:
                      "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian&search_context=southindian",
                    frequencyCapping: {},
                  },
                  {
                    id: "749769",
                    imageId: "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80462?collection_id=80462&tags=layout_CCS_Momos&type=rcv2",
                      text: "Momos",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for momos",
                      altTextCta: "open",
                    },
                    entityId: "swiggy://collectionV2?collection_id=80462&tags=layout_CCS_Momos",
                    frequencyCapping: {},
                  },
                  {
                    id: "749774",
                    imageId: "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80464?collection_id=80464&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                      text: "Noodles",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for noodles",
                      altTextCta: "open",
                    },
                    entityId: "80464",
                    frequencyCapping: {},
                  },
                  {
                    id: "749874",
                    imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
                      text: "Cakes",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for cakes",
                      altTextCta: "open",
                    },
                    entityId: "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
                    frequencyCapping: {},
                  },
                  {
                    id: "750207",
                    imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
                      text: "Pasta",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for pasta",
                      altTextCta: "open",
                    },
                    entityId: "80480",
                    frequencyCapping: {},
                  },
                  {
                    id: "750217",
                    imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2",
                      text: "Pav Bhaji",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for pav bhaji",
                      altTextCta: "open",
                    },
                    entityId:
                      "swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual",
                    frequencyCapping: {},
                  },
                  {
                    id: "750636",
                    imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
                      text: "Kebabs",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for kebabs",
                      altTextCta: "open",
                    },
                    entityId: "80452",
                    frequencyCapping: {},
                  },
                  {
                    id: "750203",
                    imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
                      text: "Paratha",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for paratha",
                      altTextCta: "open",
                    },
                    entityId: "80476",
                    frequencyCapping: {},
                  },
                  {
                    id: "750226",
                    imageId: "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80395?collection_id=80395&tags=layout_CCS_Salad&type=rcv2",
                      text: "Salad",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for salad",
                      altTextCta: "open",
                    },
                    entityId: "swiggy://collectionV2?collection_id=80395&tags=layout_CCS_Salad",
                    frequencyCapping: {},
                  },
                  {
                    id: "750593",
                    imageId: "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Gulab_Jamun.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80432?collection_id=80432&tags=layout_BAU_Contextual%2Cgulab_jamun&type=rcv2",
                      text: "Gulab Jamun",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for gulab jamun",
                      altTextCta: "open",
                    },
                    entityId: "80432",
                    frequencyCapping: {},
                  },
                  {
                    id: "750209",
                    imageId: "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                    action: {
                      link: "https://www.swiggy.com/collections/80358?collection_id=80358&tags=layout_BAU_Contextual%2Clayout_ux4&type=rcv2",
                      text: "Pastry",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for Pastry",
                      altTextCta: "open",
                    },
                    entityId: "80358",
                    frequencyCapping: {},
                  },
                  {
                    id: "750235",
                    imageId: "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2",
                      text: "Sandwich",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurants curated for sandwich",
                      altTextCta: "open",
                    },
                    entityId:
                      "swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches",
                    frequencyCapping: {},
                  },
                  {
                    id: "750239",
                    imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                    action: {
                      link: "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
                      text: "Shake",
                      type: "WEBLINK",
                    },
                    entityType: "BANNER",
                    accessibility: {
                      altText: "restaurant curated for shakes",
                      altTextCta: "open",
                    },
                    entityId: "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
                    frequencyCapping: {},
                  },
                ],
                style: {
                  width: {
                    type: "TYPE_RELATIVE",
                    value: 0.2941,
                    reference: "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH",
                  },
                  height: {
                    type: "TYPE_RELATIVE",
                    value: 1.2444,
                    reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH",
                  },
                },
              },
            },
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            header: {
              title: "Top restaurant chains in Faridabad",
              action: {},
              headerStyling: {
                padding: {
                  left: 16,
                  top: 28,
                  bottom: 18,
                },
              },
            },
            layout: {
              rows: 1,
              columns: 20,
              horizontalScrollEnabled: true,
              itemSpacing: 32,
              widgetPadding: {},
              containerStyle: {
                containerPadding: {
                  left: 16,
                  right: 12,
                  bottom: 12,
                },
              },
              scrollBar: {
                scrollThumbColor: "#E46D47",
                scrollTrackColor: "#02060C",
                width: 54,
                height: 4,
                scrollStyling: {
                  padding: {
                    top: 6,
                    bottom: 24,
                  },
                },
              },
              widgetTheme: {
                defaultMode: {
                  backgroundColour: "#1B3028",
                  theme: "THEME_TYPE_DARK",
                },
                darkMode: {
                  backgroundColour: "#1B3028",
                  theme: "THEME_TYPE_DARK",
                },
              },
            },
            id: "top_brands_for_you",
            gridElements: {
              infoWithStyle: {
                "@type":
                  "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                restaurants: [
                  {
                    info: {
                      id: "21986",
                      name: "Dark Brown",
                      cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
                      locality: "Shopping Centre Market",
                      areaName: "Sector 15",
                      costForTwo: "₹250 for two",
                      cuisines: [
                        "Italian-American",
                        "Continental",
                        "Burgers",
                        "Pizzas",
                        "Pastas",
                        "Chinese",
                        "Beverages",
                        "Salads",
                        "Asian",
                        "Healthy Food",
                        "Fast Food",
                        "Chaat",
                        "Snacks",
                        "Desserts",
                        "American",
                        "Italian",
                        "Momos",
                        "Rolls & Wraps",
                        "Cafe",
                      ],
                      avgRating: 4.2,
                      parentId: "16162",
                      avgRatingString: "4.2",
                      totalRatingsString: "10K+",
                      sla: {
                        deliveryTime: 25,
                        lastMileTravel: 1.8,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "1.8 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 00:00:00",
                        opened: true,
                      },
                      badges: {},
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "₹100 OFF",
                        subHeader: "ABOVE ₹249",
                        discountTag: "FLAT DEAL",
                        discountCalloutInfo: {
                          message: "Free Delivery",
                          logoCtx: {
                            logo: "v1655895371/free_delivery_logo_hqipbo.png",
                          },
                        },
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/dark-brown-shopping-centre-market-sector-15-faridabad-21986",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "253728",
                      name: "McDonald's",
                      cloudinaryImageId: "535fc9f9c135f7982317bbb6a64a1ffc",
                      locality: "Crown Plaza Mall",
                      areaName: "Sector 15",
                      costForTwo: "₹400 for two",
                      cuisines: ["American"],
                      avgRating: 4.2,
                      parentId: "630",
                      avgRatingString: "4.2",
                      totalRatingsString: "10K+",
                      sla: {
                        deliveryTime: 29,
                        lastMileTravel: 1.7,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "1.7 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 00:15:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "Rxawards/_CATEGORY-Burger.png",
                            description: "Delivery!",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Burger.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "50% OFF",
                        subHeader: "UPTO ₹80",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/mcdonalds-crown-plaza-mall-sector-15-faridabad-253728",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "207998",
                      name: "Burger King",
                      cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
                      locality: "Eldeco Station 1 Mall",
                      areaName: "Sector 12",
                      costForTwo: "₹350 for two",
                      cuisines: ["Burgers", "American"],
                      avgRating: 4.1,
                      parentId: "166",
                      avgRatingString: "4.1",
                      totalRatingsString: "10K+",
                      sla: {
                        deliveryTime: 26,
                        lastMileTravel: 3,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "3.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 05:00:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "Rxawards/_CATEGORY-Burger.png",
                            description: "Delivery!",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Burger.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "60% OFF",
                        subHeader: "UPTO ₹120",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/burger-king-eldeco-station-1-mall-sector-12-faridabad-207998",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "28805",
                      name: "Domino's Pizza",
                      cloudinaryImageId: "d0450ce1a6ba19ea60cd724471ed54a8",
                      locality: "Town Park",
                      areaName: "Sector 16",
                      costForTwo: "₹400 for two",
                      cuisines: ["Pizzas", "Italian", "Pastas", "Desserts"],
                      avgRating: 3.9,
                      parentId: "2456",
                      avgRatingString: "3.9",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 30,
                        lastMileTravel: 0.5,
                        serviceability: "SERVICEABLE",
                        slaString: "30 mins",
                        lastMileTravelString: "0.5 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 02:55:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "Rxawards/_CATEGORY-Pizza.png",
                            description: "Delivery!",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Pizza.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "30% OFF",
                        subHeader: "UPTO ₹75",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/dominos-pizza-town-park-sector-16-faridabad-28805",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "356223",
                      name: "KFC",
                      cloudinaryImageId: "f01666ac73626461d7455d9c24005cd4",
                      locality: "Sector-79",
                      areaName: "Omaxe World Street",
                      costForTwo: "₹450 for two",
                      cuisines: ["Burgers", "Biryani", "American", "Snacks", "Fast Food"],
                      avgRating: 4.1,
                      parentId: "547",
                      avgRatingString: "4.1",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 27,
                        lastMileTravel: 5,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "5.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 02:00:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "Rxawards/_CATEGORY-Burger.png",
                            description: "Delivery!",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Burger.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹179",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/kfc-sector-79-omaxe-world-street-faridabad-356223",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "349817",
                      name: "Pizza Hut",
                      cloudinaryImageId: "2b4f62d606d1b2bfba9ba9e5386fabb7",
                      locality: "Sector-79",
                      areaName: "Omaxe World Street",
                      costForTwo: "₹350 for two",
                      cuisines: ["Pizzas"],
                      avgRating: 3.7,
                      parentId: "721",
                      avgRatingString: "3.7",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 36,
                        lastMileTravel: 5.5,
                        serviceability: "SERVICEABLE",
                        slaString: "35-40 mins",
                        lastMileTravelString: "5.5 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 01:00:00",
                        opened: true,
                      },
                      badges: {},
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "20% OFF",
                        subHeader: "UPTO ₹50",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/pizza-hut-sector-79-omaxe-world-street-faridabad-349817",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "518208",
                      name: "Nirula's",
                      cloudinaryImageId: "a66fa8f5befa65947d9e20f29a863ce0",
                      locality: "Sector-15 Market",
                      areaName: "Sector 15",
                      costForTwo: "₹500 for two",
                      cuisines: ["Ice Cream", "Pizzas", "Fast Food"],
                      avgRating: 4.1,
                      parentId: "1738",
                      avgRatingString: "4.1",
                      totalRatingsString: "100+",
                      sla: {
                        deliveryTime: 19,
                        lastMileTravel: 2.1,
                        serviceability: "SERVICEABLE",
                        slaString: "15-20 mins",
                        lastMileTravelString: "2.1 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 00:30:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      aggregatedDiscountInfoV2: {},
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/nirulas-market-sector-15-faridabad-518208",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "374000",
                      name: "The Brooklyn Creamery - Healthy Ice Cream",
                      cloudinaryImageId: "b1b35780a9b1dfeb26d680506d494eaa",
                      locality: "Sector 16A",
                      areaName: "Sector 19",
                      costForTwo: "₹200 for two",
                      cuisines: ["Desserts", "Ice Cream", "Healthy Food"],
                      avgRating: 4.3,
                      veg: true,
                      parentId: "236673",
                      avgRatingString: "4.3",
                      totalRatingsString: "100+",
                      sla: {
                        deliveryTime: 17,
                        lastMileTravel: 1,
                        serviceability: "SERVICEABLE",
                        slaString: "15-20 mins",
                        lastMileTravelString: "1.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 00:00:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "brand",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "brand",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "60% OFF",
                        subHeader: "UPTO ₹120",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/the-brooklyn-creamery-healthy-ice-cream-sector-16a-sector-19-faridabad-374000",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "206561",
                      name: "House of Chow",
                      cloudinaryImageId: "6e97ac8f5c89213610309ef1940afa05",
                      locality: "Town Park",
                      areaName: "Sector 12",
                      costForTwo: "₹300 for two",
                      cuisines: ["Pan-Asian", "Chinese", "Thai", "Oriental"],
                      avgRating: 4.1,
                      parentId: "9064",
                      avgRatingString: "4.1",
                      totalRatingsString: "5K+",
                      sla: {
                        deliveryTime: 28,
                        lastMileTravel: 3,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "3.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-04 23:59:00",
                        opened: true,
                      },
                      badges: {},
                      isOpen: true,
                      type: "C",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "₹125 OFF",
                        subHeader: "ABOVE ₹249",
                        discountTag: "FLAT DEAL",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/house-of-chow-town-park-sector-12-faridabad-206561",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "56999",
                      name: "La Pino'z Pizza",
                      cloudinaryImageId: "mzb8tq7ccskyvadm9mt2",
                      locality: "Shopping Centre Market",
                      areaName: "Sector 15",
                      costForTwo: "₹250 for two",
                      cuisines: ["Pizzas", "Pastas", "Italian", "Desserts", "Beverages"],
                      avgRating: 3.8,
                      parentId: "4961",
                      avgRatingString: "3.8",
                      totalRatingsString: "10K+",
                      sla: {
                        deliveryTime: 26,
                        lastMileTravel: 2,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "2.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 03:45:00",
                        opened: true,
                      },
                      badges: {},
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹199",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/la-pinoz-pizza-shopping-centre-market-sector-15-faridabad-56999",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "170934",
                      name: "Wow! Momo",
                      cloudinaryImageId: "64fd45fd9f44c1737bc446e470bed666",
                      locality: "Sector 15",
                      areaName: "Sector 15",
                      costForTwo: "₹300 for two",
                      cuisines: [
                        "Tibetan",
                        "Healthy Food",
                        "Asian",
                        "Chinese",
                        "Snacks",
                        "Continental",
                        "Desserts",
                        "Beverages",
                      ],
                      avgRating: 3.9,
                      parentId: "1776",
                      avgRatingString: "3.9",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 24,
                        lastMileTravel: 2,
                        serviceability: "SERVICEABLE",
                        slaString: "20-25 mins",
                        lastMileTravelString: "2.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 02:00:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "Rxawards/_CATEGORY-Chinese.png",
                            description: "Delivery!",
                          },
                          {
                            imageId: "Rxawards/_CATEGORY-Momos.png",
                            description: "Delivery!",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Chinese.png",
                                },
                              },
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Momos.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹99",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/wow-momo-sector-15-faridabad-170934",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "337231",
                      name: "Biryani Blues",
                      cloudinaryImageId: "97377e54937c079fe269d744aa66274a",
                      locality: "Sector 79",
                      areaName: "Sector 79",
                      costForTwo: "₹400 for two",
                      cuisines: ["Biryani", "Hyderabadi", "Lucknowi", "Kebabs"],
                      avgRating: 4.1,
                      parentId: "13813",
                      avgRatingString: "4.1",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 29,
                        lastMileTravel: 5,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "5.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 04:00:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "Rxawards/_CATEGORY-Biryani.png",
                            description: "Delivery!",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Biryani.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "50% OFF",
                        subHeader: "UPTO ₹95",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/biryani-blues-sector-79-faridabad-337231",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "156075",
                      name: "The Good Bowl",
                      cloudinaryImageId: "6e04be27387483a7c00444f8e8241108",
                      locality: "Kapori colony",
                      areaName: "Sector 19",
                      costForTwo: "₹400 for two",
                      cuisines: [
                        "Biryani",
                        "North Indian",
                        "Pastas",
                        "Punjabi",
                        "Desserts",
                        "Beverages",
                      ],
                      avgRating: 4.1,
                      parentId: "7918",
                      avgRatingString: "4.1",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 26,
                        lastMileTravel: 1.3,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "1.3 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-04 23:59:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "60% OFF",
                        subHeader: "UPTO ₹110",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/the-good-bowl-kapori-colony-sector-19-faridabad-156075",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "39278",
                      name: "Faasos - Wraps, Rolls & Shawarma",
                      cloudinaryImageId: "af33b81798b11deba338e94b7585d348",
                      locality: "Kapori Colony",
                      areaName: "Sector 19",
                      costForTwo: "₹200 for two",
                      cuisines: [
                        "Kebabs",
                        "Fast Food",
                        "Snacks",
                        "American",
                        "Healthy Food",
                        "Desserts",
                        "Beverages",
                      ],
                      avgRating: 4.1,
                      parentId: "21809",
                      avgRatingString: "4.1",
                      totalRatingsString: "10K+",
                      sla: {
                        deliveryTime: 27,
                        lastMileTravel: 1.3,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "1.3 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-04 23:59:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹129",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/faasos-wraps-rolls-and-shawarma-kapori-colony-sector-19-faridabad-39278",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "39279",
                      name: "Behrouz Biryani",
                      cloudinaryImageId: "a4ffed13eb197c6df43dfe1c756560e5",
                      locality: "Kapori Colony",
                      areaName: "Sector 19",
                      costForTwo: "₹500 for two",
                      cuisines: [
                        "Biryani",
                        "North Indian",
                        "Kebabs",
                        "Mughlai",
                        "Beverages",
                        "Desserts",
                      ],
                      avgRating: 4.2,
                      parentId: "1803",
                      avgRatingString: "4.2",
                      totalRatingsString: "5K+",
                      sla: {
                        deliveryTime: 24,
                        lastMileTravel: 1.3,
                        serviceability: "SERVICEABLE",
                        slaString: "20-25 mins",
                        lastMileTravelString: "1.3 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-04 23:59:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "Rxawards/_CATEGORY-Biryani.png",
                            description: "Delivery!",
                          },
                          {
                            imageId: "newg.png",
                            description: "Gourmet",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Biryani.png",
                                },
                              },
                              {
                                attributes: {
                                  description: "Gourmet",
                                  imageId: "newg.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "₹125 OFF",
                        subHeader: "ABOVE ₹199",
                        discountTag: "FLAT DEAL",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/behrouz-biryani-kapori-colony-sector-19-faridabad-39279",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "62981",
                      name: "LunchBox - Meals and Thalis",
                      cloudinaryImageId: "4edcfc66d91018d69894941ebb3c8d16",
                      locality: "Kapori Colony",
                      areaName: "Sector 19",
                      costForTwo: "₹200 for two",
                      cuisines: [
                        "Biryani",
                        "North Indian",
                        "Punjabi",
                        "Healthy Food",
                        "Desserts",
                        "Beverages",
                      ],
                      avgRating: 4,
                      parentId: "4925",
                      avgRatingString: "4.0",
                      totalRatingsString: "5K+",
                      sla: {
                        deliveryTime: 25,
                        lastMileTravel: 1.3,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "1.3 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-04 23:59:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹159",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/lunchbox-meals-and-thalis-kapori-colony-sector-19-faridabad-62981",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "39280",
                      name: "Oven Story Pizza - Standout Toppings",
                      cloudinaryImageId: "b39e4312ae2e9f65c3b58faaed83f488",
                      locality: "Kapori Colony",
                      areaName: "Sector 19",
                      costForTwo: "₹400 for two",
                      cuisines: ["Pizzas", "Pastas", "Italian", "Desserts", "Beverages"],
                      avgRating: 4.1,
                      parentId: "3534",
                      avgRatingString: "4.1",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 30,
                        lastMileTravel: 1.3,
                        serviceability: "SERVICEABLE",
                        slaString: "26-35 mins",
                        lastMileTravelString: "1.3 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-04 23:59:00",
                        opened: true,
                      },
                      badges: {},
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "₹125 OFF",
                        subHeader: "ABOVE ₹199",
                        discountTag: "FLAT DEAL",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/oven-story-pizza-standout-toppings-kapori-colony-sector-19-faridabad-39280",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "263954",
                      name: "Chai Point",
                      cloudinaryImageId: "znobbbace3njt7oxau2f",
                      locality: "Adb Pwd Colony",
                      areaName: "Sector 16",
                      costForTwo: "₹150 for two",
                      cuisines: [
                        "Bakery",
                        "Beverages",
                        "Maharashtrian",
                        "Snacks",
                        "Street Food",
                        "South Indian",
                        "Punjabi",
                        "Chaat",
                        "Indian",
                        "American",
                        "Fast Food",
                        "Desserts",
                        "Cafe",
                        "Healthy Food",
                        "Home Food",
                        "North Indian",
                      ],
                      avgRating: 4.2,
                      parentId: "1607",
                      avgRatingString: "4.2",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 23,
                        lastMileTravel: 0.3,
                        serviceability: "SERVICEABLE",
                        slaString: "20-25 mins",
                        lastMileTravelString: "0.3 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-11 00:00:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "60% OFF",
                        subHeader: "UPTO ₹120",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/chai-point-adb-pwd-colony-sector-16-faridabad-263954",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "353657",
                      name: "Chaayos Chai+Snacks=Relax",
                      cloudinaryImageId: "cace805a6ba74137571d0f7ac92302b1",
                      locality: "Shopping Centre Market",
                      areaName: "Sector 15",
                      costForTwo: "₹250 for two",
                      cuisines: [
                        "Bakery",
                        "Beverages",
                        "Chaat",
                        "Desserts",
                        "Home Food",
                        "Italian",
                        "Maharashtrian",
                        "Snacks",
                        "Street Food",
                        "Sweets",
                      ],
                      avgRating: 4.2,
                      parentId: "281782",
                      avgRatingString: "4.2",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 20,
                        lastMileTravel: 2,
                        serviceability: "SERVICEABLE",
                        slaString: "15-20 mins",
                        lastMileTravelString: "2.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-11 00:00:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "60% OFF",
                        subHeader: "UPTO ₹120",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/chaayos-chai-snacks-relax-shopping-centre-market-sector-15-faridabad-353657",
                      type: "WEBLINK",
                    },
                  },
                  {
                    info: {
                      id: "39281",
                      name: "Firangi Bake",
                      cloudinaryImageId: "rbvv4z3539ntnlrfcwhs",
                      locality: "Kapori Colony",
                      areaName: "Sector 19",
                      costForTwo: "₹400 for two",
                      cuisines: [
                        "Pizzas",
                        "Pastas",
                        "Italian",
                        "Mexican",
                        "Healthy Food",
                        "Desserts",
                        "Beverages",
                      ],
                      avgRating: 4.1,
                      parentId: "3952",
                      avgRatingString: "4.1",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 25,
                        lastMileTravel: 1.3,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "1.3 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-04 23:59:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹199",
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {},
                    cta: {
                      link: "https://www.swiggy.com/restaurants/firangi-bake-kapori-colony-sector-19-faridabad-39281",
                      type: "WEBLINK",
                    },
                  },
                ],
                theme: "Restaurant_Group_WebView_SEO_PB_Theme",
                widgetType: "WIDGET_TYPE_POPULAR_BRANDS",
                style: {
                  width: {
                    type: "TYPE_RELATIVE",
                    value: 0.41111112,
                    reference: "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH",
                  },
                  height: {
                    type: "TYPE_RELATIVE",
                    value: 0.7027027,
                    reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH",
                  },
                  layoutAlignment: "LAYOUT_ALIGNMENT_LEFT",
                },
                collectionId: "84124",
              },
            },
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BasicContent",
            title: "Restaurants with online food delivery in Faridabad",
            id: "popular_restaurants_title",
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
            sortConfigs: [
              {
                key: "relevance",
                title: "Relevance (Default)",
                selected: true,
                defaultSelection: true,
              },
              {
                key: "deliveryTimeAsc",
                title: "Delivery Time",
              },
              {
                key: "modelBasedRatingDesc",
                title: "Rating",
              },
              {
                key: "costForTwoAsc",
                title: "Cost: Low to High",
              },
              {
                key: "costForTwoDesc",
                title: "Cost: High to Low",
              },
            ],
            restaurantCount: 490,
            facetList: [
              {
                label: "Delivery Time",
                id: "deliveryTime",
                selection: "SELECT_TYPE_MULTISELECT",
                facetInfo: [
                  {
                    label: "Fast Delivery",
                    id: "deliveryTimefacetquery1",
                    analytics: {},
                    openFilter: true,
                  },
                ],
                viewType: "VIEW_TYPE_HALF_CARD",
                subLabel: "Filter by",
              },
              {
                label: "Cuisines",
                id: "catalog_cuisines",
                selection: "SELECT_TYPE_MULTISELECT",
                facetInfo: [
                  {
                    label: "Afghani",
                    id: "query_afghani",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "American",
                    id: "query_american",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Andhra",
                    id: "query_andhra",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Arabian",
                    id: "query_arabian",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Asian",
                    id: "query_asian",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Awadhi",
                    id: "query_awadhi",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Bakery",
                    id: "query_bakery",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Bangladeshi",
                    id: "query_bangladeshi",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Barbecue",
                    id: "query_barbecue",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Bengali",
                    id: "query_bengali",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Beverages",
                    id: "query_beverages",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Biryani",
                    id: "query_biryani",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "British",
                    id: "query_british",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Burgers",
                    id: "query_burgers",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Burmese",
                    id: "query_burmese",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Cafe",
                    id: "query_cafe",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Cakes and Pastries",
                    id: "query_cakes_and_pastries",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Chaat",
                    id: "query_chaat",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Chettinad",
                    id: "query_chettinad",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Chinese",
                    id: "query_chinese",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Coastal",
                    id: "query_coastal",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Confectionery",
                    id: "query_confectionery",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Continental",
                    id: "query_continental",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Desserts",
                    id: "query_desserts",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "European",
                    id: "query_european",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Fast Food",
                    id: "query_fast_food",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "French",
                    id: "query_french",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Grill",
                    id: "query_grill",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Healthy Food",
                    id: "query_healthy_food",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Home Food",
                    id: "query_home_food",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Hyderabadi",
                    id: "query_hyderabadi",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Ice Cream",
                    id: "query_ice_cream",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Ice Cream Cakes",
                    id: "query_ice_cream_cakes",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Indian",
                    id: "query_indian",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Italian",
                    id: "query_italian",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Italian-American",
                    id: "query_italian-american",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Japanese",
                    id: "query_japanese",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Juices",
                    id: "query_juices",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Kebabs",
                    id: "query_kebabs",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Keto",
                    id: "query_keto",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Lebanese",
                    id: "query_lebanese",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Lucknowi",
                    id: "query_lucknowi",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Maharashtrian",
                    id: "query_maharashtrian",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Meat",
                    id: "query_meat",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Mexican",
                    id: "query_mexican",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Momos",
                    id: "query_momos",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Mughlai",
                    id: "query_mughlai",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Navratri Special",
                    id: "query_navratri_special",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Nepalese",
                    id: "query_nepalese",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "North Eastern",
                    id: "query_north_eastern",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "North Indian",
                    id: "query_north_indian",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Oriental",
                    id: "query_oriental",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Paan",
                    id: "query_paan",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Pan-Asian",
                    id: "query_pan-asian",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Pastas",
                    id: "query_pastas",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Pizzas",
                    id: "query_pizzas",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Punjabi",
                    id: "query_punjabi",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Rolls & Wraps",
                    id: "query_rolls_&_wraps",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Salads",
                    id: "query_salads",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Seafood",
                    id: "query_seafood",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Snacks",
                    id: "query_snacks",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "South Indian",
                    id: "query_south_indian",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Street Food",
                    id: "query_street_food",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Sweets",
                    id: "query_sweets",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Tandoor",
                    id: "query_tandoor",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Thai",
                    id: "query_thai",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Thalis",
                    id: "query_thalis",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Tibetan",
                    id: "query_tibetan",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Waffle",
                    id: "query_waffle",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "rolls",
                    id: "query_rolls",
                    analytics: {},
                    openFilter: true,
                  },
                ],
                viewType: "VIEW_TYPE_HALF_CARD",
                canSearch: true,
                subLabel: "Filter by cuisine",
                openFilter: true,
              },
              {
                label: "Explore",
                id: "explore",
                selection: "SELECT_TYPE_MULTISELECT",
                facetInfo: [
                  {
                    label: "New on Swiggy",
                    id: "newfacetquery1",
                    analytics: {},
                    openFilter: true,
                  },
                ],
                viewType: "VIEW_TYPE_HALF_CARD",
              },
              {
                label: "Ratings",
                id: "rating",
                selection: "SELECT_TYPE_MULTISELECT",
                facetInfo: [
                  {
                    label: "Ratings 4.5+",
                    id: "ratingfacetquery3",
                    analytics: {},
                  },
                  {
                    label: "Ratings 4.0+",
                    id: "ratingfacetquery4",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Ratings 3.5+",
                    id: "ratingfacetquery5",
                    analytics: {},
                  },
                ],
                viewType: "VIEW_TYPE_HALF_CARD",
                subLabel: "Filter by",
              },
              {
                label: "Veg/Non-Veg",
                id: "isVeg",
                selection: "SELECT_TYPE_SINGLESELECT",
                facetInfo: [
                  {
                    label: "Pure Veg",
                    id: "isVegfacetquery2",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Non Veg",
                    id: "isVegfacetquery3",
                    analytics: {},
                  },
                ],
                viewType: "VIEW_TYPE_FLATTENED",
                subLabel: "Filter by",
              },
              {
                label: "Offers",
                id: "restaurantOfferMultiTd",
                selection: "SELECT_TYPE_SINGLESELECT",
                facetInfo: [
                  {
                    label: "Offers",
                    id: "restaurantOfferMultiTdfacetquery3",
                    analytics: {},
                    openFilter: true,
                  },
                ],
                viewType: "VIEW_TYPE_FLATTENED",
                subLabel: "Restaurants with",
              },
              {
                label: "Cost for two",
                id: "costForTwo",
                selection: "SELECT_TYPE_MULTISELECT",
                facetInfo: [
                  {
                    label: "Rs. 300-Rs. 600",
                    id: "costForTwofacetquery3",
                    analytics: {},
                    openFilter: true,
                  },
                  {
                    label: "Greater than Rs. 600",
                    id: "costForTwofacetquery4",
                    analytics: {},
                  },
                  {
                    label: "Less than Rs. 300",
                    id: "costForTwofacetquery5",
                    analytics: {},
                    openFilter: true,
                  },
                ],
                viewType: "VIEW_TYPE_HALF_CARD",
                subLabel: "Filter by",
              },
            ],
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            layout: {
              columns: 4,
            },
            id: "restaurant_grid_listing",
            gridElements: {
              infoWithStyle: {
                "@type":
                  "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                restaurants: [
                  {
                    info: {
                      id: "576302",
                      name: "Chinese Wok",
                      cloudinaryImageId: "e0839ff574213e6f35b3899ebf1fc597",
                      locality: "Block E",
                      areaName: "Sector 86",
                      costForTwo: "₹250 for two",
                      cuisines: ["Chinese", "Asian", "Tibetan", "Desserts"],
                      avgRating: 4,
                      parentId: "61955",
                      avgRatingString: "4.0",
                      totalRatingsString: "500+",
                      sla: {
                        deliveryTime: 27,
                        lastMileTravel: 5,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "5.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 00:00:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "Rxawards/_CATEGORY-Chinese.png",
                            description: "Delivery!",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Delivery!",
                                  imageId: "Rxawards/_CATEGORY-Chinese.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹179",
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/chinese-wok-block-e-sector-86-faridabad-576302",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                  {
                    info: {
                      id: "483332",
                      name: "BOX8 - Desi Meals",
                      cloudinaryImageId: "69a061b7e0f951cef2b4947946f94ec6",
                      locality: "KC Road",
                      areaName: "Badkal Lake",
                      costForTwo: "₹250 for two",
                      cuisines: ["North Indian", "Biryani", "Thalis", "Home Food"],
                      avgRating: 4.4,
                      parentId: "10655",
                      avgRatingString: "4.4",
                      totalRatingsString: "500+",
                      sla: {
                        deliveryTime: 20,
                        lastMileTravel: 4.5,
                        serviceability: "SERVICEABLE",
                        slaString: "15-25 mins",
                        lastMileTravelString: "4.5 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 01:45:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹179",
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/box8-desi-meals-kc-road-badkal-lake-faridabad-483332",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                  {
                    info: {
                      id: "447688",
                      name: "Chicago Pizza",
                      cloudinaryImageId: "z7vplkcpx1l3bfivhtqb",
                      locality: "Green Fields Colony",
                      areaName: "Green Fields Colony",
                      costForTwo: "₹350 for two",
                      cuisines: ["Pizzas", "Italian", "Beverages"],
                      avgRating: 3.8,
                      parentId: "60277",
                      avgRatingString: "3.8",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 42,
                        lastMileTravel: 7.5,
                        serviceability: "SERVICEABLE",
                        slaString: "40-45 mins",
                        lastMileTravelString: "7.5 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-04 23:59:00",
                        opened: true,
                      },
                      badges: {},
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "60% OFF",
                        subHeader: "UPTO ₹120",
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/chicago-pizza-green-fields-colony-faridabad-447688",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                  {
                    info: {
                      id: "21986",
                      name: "Dark Brown",
                      cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
                      locality: "Shopping Centre Market",
                      areaName: "Sector 15",
                      costForTwo: "₹250 for two",
                      cuisines: [
                        "Italian-American",
                        "Continental",
                        "Burgers",
                        "Pizzas",
                        "Pastas",
                        "Chinese",
                        "Beverages",
                        "Salads",
                        "Asian",
                        "Healthy Food",
                        "Fast Food",
                        "Chaat",
                        "Snacks",
                        "Desserts",
                        "American",
                        "Italian",
                        "Momos",
                        "Rolls & Wraps",
                        "Cafe",
                      ],
                      avgRating: 4.2,
                      parentId: "16162",
                      avgRatingString: "4.2",
                      totalRatingsString: "10K+",
                      sla: {
                        deliveryTime: 25,
                        lastMileTravel: 1.8,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "1.8 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 00:00:00",
                        opened: true,
                      },
                      badges: {},
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "₹100 OFF",
                        subHeader: "ABOVE ₹249",
                        discountTag: "FLAT DEAL",
                        discountCalloutInfo: {
                          message: "Free Delivery",
                          logoCtx: {
                            logo: "v1655895371/free_delivery_logo_hqipbo.png",
                          },
                        },
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/dark-brown-shopping-centre-market-sector-15-faridabad-21986",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                  {
                    info: {
                      id: "160794",
                      name: "Jujube Asian Cookhouse",
                      cloudinaryImageId: "aec4411704260f0a4e0749b44c0b6eeb",
                      locality: "Sector 15",
                      areaName: "Sector 16_FBD",
                      costForTwo: "₹500 for two",
                      cuisines: ["Asian"],
                      avgRating: 4.3,
                      parentId: "15279",
                      avgRatingString: "4.3",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 27,
                        lastMileTravel: 2,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "2.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 01:00:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "newg.png",
                            description: "Gourmet",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Gourmet",
                                  imageId: "newg.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "60% OFF",
                        subHeader: "UPTO ₹120",
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/jujube-asian-cookhouse-sector-15-sector-16-fbd-faridabad-160794",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                  {
                    info: {
                      id: "255729",
                      name: "Silbuttah - The Indian Story By Berco's",
                      cloudinaryImageId: "db6d3861e995a9ac4f7e461ddaed1b9f",
                      locality: "Sector 12",
                      areaName: "Sector 12",
                      costForTwo: "₹400 for two",
                      cuisines: ["North Indian", "Mughlai", "Kebabs"],
                      avgRating: 4.2,
                      parentId: "459398",
                      avgRatingString: "4.2",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 27,
                        lastMileTravel: 3,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "3.0 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 00:00:00",
                        opened: true,
                      },
                      badges: {
                        imageBadges: [
                          {
                            imageId: "newg.png",
                            description: "Gourmet",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "Gourmet",
                                  imageId: "newg.png",
                                },
                              },
                            ],
                          },
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "40% OFF",
                        subHeader: "UPTO ₹80",
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/silbuttah-the-indian-story-by-bercos-sector-12-faridabad-255729",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                  {
                    info: {
                      id: "328851",
                      name: "HR-51",
                      cloudinaryImageId: "cf2chuvk0swv15ypwasv",
                      locality: "Friends Colony",
                      areaName: "Sector 14",
                      costForTwo: "₹250 for two",
                      cuisines: ["North Indian", "Chinese", "Snacks"],
                      avgRating: 3.7,
                      parentId: "13822",
                      avgRatingString: "3.7",
                      totalRatingsString: "1K+",
                      sla: {
                        deliveryTime: 28,
                        lastMileTravel: 2.8,
                        serviceability: "SERVICEABLE",
                        slaString: "25-30 mins",
                        lastMileTravelString: "2.8 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 03:00:00",
                        opened: true,
                      },
                      badges: {},
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {},
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "₹100 OFF",
                        subHeader: "ABOVE ₹249",
                        discountTag: "FLAT DEAL",
                        discountCalloutInfo: {
                          message: "Free Delivery",
                          logoCtx: {
                            logo: "v1655895371/free_delivery_logo_hqipbo.png",
                          },
                        },
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/hr-51-friends-colony-sector-14-faridabad-328851",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                  {
                    info: {
                      id: "622189",
                      name: "MOJO Pizza - 2X Toppings",
                      cloudinaryImageId: "59b64f9bb67234987652437f21d379c2",
                      locality: "K C Road",
                      areaName: "New Industrial Township",
                      costForTwo: "₹250 for two",
                      cuisines: ["Pizzas", "Italian", "Fast Food", "Desserts"],
                      avgRating: 4.3,
                      parentId: "11329",
                      avgRatingString: "4.3",
                      totalRatingsString: "100+",
                      sla: {
                        deliveryTime: 25,
                        lastMileTravel: 4.5,
                        serviceability: "SERVICEABLE",
                        slaString: "20-30 mins",
                        lastMileTravelString: "4.5 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 01:45:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹169",
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/mojo-pizza-2x-toppings-k-c-road-new-industrial-township-faridabad-622189",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                  {
                    info: {
                      id: "483340",
                      name: "NH1 Bowls - Highway To North",
                      cloudinaryImageId: "94654fdf308764cd0faf83dba35bcdc3",
                      locality: "KC Road",
                      areaName: "Badkal Lake",
                      costForTwo: "₹250 for two",
                      cuisines: ["North Indian", "Punjabi", "Home Food"],
                      avgRating: 4.3,
                      parentId: "22452",
                      avgRatingString: "4.3",
                      totalRatingsString: "100+",
                      sla: {
                        deliveryTime: 19,
                        lastMileTravel: 4.5,
                        serviceability: "SERVICEABLE",
                        slaString: "14-24 mins",
                        lastMileTravelString: "4.5 km",
                        iconType: "ICON_TYPE_EMPTY",
                      },
                      availability: {
                        nextCloseTime: "2024-04-05 01:45:00",
                        opened: true,
                      },
                      badges: {
                        textExtendedBadges: [
                          {
                            iconId: "guiltfree/GF_Logo_android_3x",
                            shortDescription: "options available",
                            fontColor: "#7E808C",
                          },
                        ],
                      },
                      isOpen: true,
                      type: "F",
                      badgesV2: {
                        entityBadges: {
                          imageBased: {},
                          textBased: {},
                          textExtendedBadges: {
                            badgeObject: [
                              {
                                attributes: {
                                  description: "",
                                  fontColor: "#7E808C",
                                  iconId: "guiltfree/GF_Logo_android_3x",
                                  shortDescription: "options available",
                                },
                              },
                            ],
                          },
                        },
                      },
                      aggregatedDiscountInfoV3: {
                        header: "ITEMS",
                        subHeader: "AT ₹159",
                      },
                      orderabilityCommunication: {
                        title: {},
                        subTitle: {},
                        message: {},
                        customIcon: {},
                      },
                      differentiatedUi: {
                        displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        differentiatedUiMediaDetails: {
                          mediaType: "ADS_MEDIA_ENUM_IMAGE",
                          lottie: {},
                          video: {},
                        },
                      },
                      reviewsSummary: {},
                      displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      restaurantOfferPresentationInfo: {},
                    },
                    analytics: {
                      context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e",
                    },
                    cta: {
                      link: "https://www.swiggy.com/restaurants/nh1-bowls-highway-to-north-kc-road-badkal-lake-faridabad-483340",
                      text: "RESTAURANT_MENU",
                      type: "WEBLINK",
                    },
                    widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo",
                  },
                ],
                theme: "SeoRestaurantListingGridWidget",
              },
            },
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton",
            message: "Show More",
            id: "show_more_button",
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            title: "Best Places to Eat Across Cities",
            brands: [
              {
                text: "Best Restaurants in Bangalore",
                link: "https://www.swiggy.com/city/bangalore/best-restaurants",
              },
              {
                text: "Best Restaurants in Pune",
                link: "https://www.swiggy.com/city/pune/best-restaurants",
              },
              {
                text: "Best Restaurants in Mumbai",
                link: "https://www.swiggy.com/city/mumbai/best-restaurants",
              },
              {
                text: "Best Restaurants in Delhi",
                link: "https://www.swiggy.com/city/delhi/best-restaurants",
              },
              {
                text: "Best Restaurants in Hyderabad",
                link: "https://www.swiggy.com/city/hyderabad/best-restaurants",
              },
              {
                text: "Best Restaurants in Kolkata",
                link: "https://www.swiggy.com/city/kolkata/best-restaurants",
              },
              {
                text: "Best Restaurants in Chennai",
                link: "https://www.swiggy.com/city/chennai/best-restaurants",
              },
              {
                text: "Best Restaurants in Chandigarh",
                link: "https://www.swiggy.com/city/chandigarh/best-restaurants",
              },
              {
                text: "Best Restaurants in Ahmedabad",
                link: "https://www.swiggy.com/city/ahmedabad/best-restaurants",
              },
              {
                text: "Best Restaurants in Jaipur",
                link: "https://www.swiggy.com/city/jaipur/best-restaurants",
              },
              {
                text: "Best Restaurants in Nagpur",
                link: "https://www.swiggy.com/city/nagpur/best-restaurants",
              },
              {
                text: "Best Restaurants in Bhubaneswar",
                link: "https://www.swiggy.com/city/bhubaneswar/best-restaurants",
              },
              {
                text: "Best Restaurants in Kochi",
                link: "https://www.swiggy.com/city/kochi/best-restaurants",
              },
              {
                text: "Best Restaurants in Surat",
                link: "https://www.swiggy.com/city/surat/best-restaurants",
              },
              {
                text: "Best Restaurants in Dehradun",
                link: "https://www.swiggy.com/city/dehradun/best-restaurants",
              },
              {
                text: "Best Restaurants in Ludhiana",
                link: "https://www.swiggy.com/city/ludhiana/best-restaurants",
              },
              {
                text: "Best Restaurants in Patna",
                link: "https://www.swiggy.com/city/patna/best-restaurants",
              },
              {
                text: "Best Restaurants in Mangaluru",
                link: "https://www.swiggy.com/city/mangaluru/best-restaurants",
              },
              {
                text: "Best Restaurants in Bhopal",
                link: "https://www.swiggy.com/city/bhopal/best-restaurants",
              },
              {
                text: "Best Restaurants in Gurgaon",
                link: "https://www.swiggy.com/city/gurgaon/best-restaurants",
              },
              {
                text: "Best Restaurants in Coimbatore",
                link: "https://www.swiggy.com/city/coimbatore/best-restaurants",
              },
              {
                text: "Best Restaurants in Agra",
                link: "https://www.swiggy.com/city/agra/best-restaurants",
              },
              {
                text: "Best Restaurants in Noida",
                link: "https://www.swiggy.com/city/noida/best-restaurants",
              },
              {
                text: "Best Restaurants in Vijayawada",
                link: "https://www.swiggy.com/city/vijayawada/best-restaurants",
              },
              {
                text: "Best Restaurants in Guwahati",
                link: "https://www.swiggy.com/city/guwahati/best-restaurants",
              },
              {
                text: "Best Restaurants in Mysore",
                link: "https://www.swiggy.com/city/mysore/best-restaurants",
              },
              {
                text: "Best Restaurants in Pondicherry",
                link: "https://www.swiggy.com/city/pondicherry/best-restaurants",
              },
              {
                text: "Best Restaurants in Thiruvananthapuram",
                link: "https://www.swiggy.com/city/thiruvananthapuram/best-restaurants",
              },
              {
                text: "Best Restaurants in Ranchi",
                link: "https://www.swiggy.com/city/ranchi/best-restaurants",
              },
              {
                text: "Best Restaurants in Vizag",
                link: "https://www.swiggy.com/city/vizag/best-restaurants",
              },
              {
                text: "Best Restaurants in Udaipur",
                link: "https://www.swiggy.com/city/udaipur/best-restaurants",
              },
              {
                text: "Best Restaurants in Vadodara",
                link: "https://www.swiggy.com/city/vadodara/best-restaurants",
              },
            ],
            id: "restaurant_near_me_links",
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            title: "Best Cuisines Near Me",
            brands: [
              {
                text: "Chinese Restaurant Near Me",
                link: "https://www.swiggy.com/chinese-restaurants-near-me",
              },
              {
                text: "South Indian Restaurant Near Me",
                link: "https://www.swiggy.com/south-indian-restaurants-near-me",
              },
              {
                text: "Indian Restaurant Near Me",
                link: "https://www.swiggy.com/indian-restaurants-near-me",
              },
              {
                text: "Kerala Restaurant Near Me",
                link: "https://www.swiggy.com/kerala-restaurants-near-me",
              },
              {
                text: "Korean Restaurant Near Me",
                link: "https://www.swiggy.com/korean-restaurants-near-me",
              },
              {
                text: "North Indian Restaurant Near Me",
                link: "https://www.swiggy.com/north-indian-restaurants-near-me",
              },
              {
                text: "Seafood Restaurant Near Me",
                link: "https://www.swiggy.com/seafood-restaurants-near-me",
              },
              {
                text: "Bengali Restaurant Near Me",
                link: "https://www.swiggy.com/bengali-restaurants-near-me",
              },
              {
                text: "Punjabi Restaurant Near Me",
                link: "https://www.swiggy.com/punjabi-restaurants-near-me",
              },
              {
                text: "Italian Restaurant Near Me",
                link: "https://www.swiggy.com/italian-restaurants-near-me",
              },
              {
                text: "Andhra Restaurant Near Me",
                link: "https://www.swiggy.com/andhra-restaurants-near-me",
              },
              {
                text: "Biryani Restaurant Near Me",
                link: "https://www.swiggy.com/biryani-restaurants-near-me",
              },
              {
                text: "Japanese Restaurant Near Me",
                link: "https://www.swiggy.com/japanese-restaurants-near-me",
              },
              {
                text: "Arabian Restaurant Near Me",
                link: "https://www.swiggy.com/arabian-restaurants-near-me",
              },
              {
                text: "Fast Food Restaurant Near Me",
                link: "https://www.swiggy.com/fast-food-restaurants-near-me",
              },
              {
                text: "Jain Restaurant Near Me",
                link: "https://www.swiggy.com/jain-restaurants-near-me",
              },
              {
                text: "Gujarati Restaurant Near Me",
                link: "https://www.swiggy.com/gujarati-restaurants-near-me",
              },
              {
                text: "Thai Restaurant Near Me",
                link: "https://www.swiggy.com/thai-restaurants-near-me",
              },
              {
                text: "Pizzas Restaurant Near Me",
                link: "https://www.swiggy.com/pizzas-restaurants-near-me",
              },
              {
                text: "Asian Restaurant Near Me",
                link: "https://www.swiggy.com/asian-restaurants-near-me",
              },
              {
                text: "Cafe Restaurant Near Me",
                link: "https://www.swiggy.com/cafe-restaurants-near-me",
              },
              {
                text: "Continental Restaurant Near Me",
                link: "https://www.swiggy.com/continental-restaurants-near-me",
              },
              {
                text: "Mexican Restaurant Near Me",
                link: "https://www.swiggy.com/mexican-restaurants-near-me",
              },
              {
                text: "Mughlai Restaurant Near Me",
                link: "https://www.swiggy.com/mughlai-restaurants-near-me",
              },
              {
                text: "Sushi Restaurant Near Me",
                link: "https://www.swiggy.com/sushi-restaurants-near-me",
              },
              {
                text: "Mangalorean Restaurant Near Me",
                link: "https://www.swiggy.com/mangalorean-restaurants-near-me",
              },
              {
                text: "Tibetan Restaurant Near Me",
                link: "https://www.swiggy.com/tibetan-restaurants-near-me",
              },
              {
                text: "Barbecue Restaurant Near Me",
                link: "https://www.swiggy.com/barbecue-restaurants-near-me",
              },
              {
                text: "Maharashtrian Restaurant Near Me",
                link: "https://www.swiggy.com/maharashtrian-restaurants-near-me",
              },
              {
                text: "Nepalese Restaurant Near Me",
                link: "https://www.swiggy.com/nepalese-restaurants-near-me",
              },
              {
                text: "Rajasthani Restaurant Near Me",
                link: "https://www.swiggy.com/rajasthani-restaurants-near-me",
              },
              {
                text: "Turkish Restaurant Near Me",
                link: "https://www.swiggy.com/turkish-restaurants-near-me",
              },
            ],
            id: "restaurant_near_me_links",
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            title: "Explore Every Restaurants Near Me",
            brands: [
              {
                text: "Explore Restaurants Near Me",
                link: "https://www.swiggy.com/restaurants-near-me",
              },
              {
                text: "Explore Top Rated Restaurants Near Me",
                link: "https://www.swiggy.com/best-restaurants-near-me",
              },
            ],
            id: "restaurant_near_me_links",
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks",
            title: "For better experience,download the Swiggy app now",
            androidAppImage: "portal/m/play_store.png",
            androidAppLink:
              "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
            iosAppImage: "portal/m/app_store.png",
            iosAppLink:
              "https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage",
            id: "app_install_links",
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.FooterContent",
            cities: [
              {
                text: "Bangalore",
                link: "https://www.swiggy.com/city/bangalore",
              },
              {
                text: "Gurgaon",
                link: "https://www.swiggy.com/city/gurgaon",
              },
              {
                text: "Hyderabad",
                link: "https://www.swiggy.com/city/hyderabad",
              },
              {
                text: "Delhi",
                link: "https://www.swiggy.com/city/delhi",
              },
              {
                text: "Mumbai",
                link: "https://www.swiggy.com/city/mumbai",
              },
              {
                text: "Pune",
                link: "https://www.swiggy.com/city/pune",
              },
              {
                text: "Kolkata",
                link: "https://www.swiggy.com/city/kolkata",
              },
              {
                text: "Chennai",
                link: "https://www.swiggy.com/city/chennai",
              },
              {
                text: "Ahmedabad",
                link: "https://www.swiggy.com/city/ahmedabad",
              },
              {
                text: "Chandigarh",
                link: "https://www.swiggy.com/city/chandigarh",
              },
              {
                text: "Jaipur",
                link: "https://www.swiggy.com/city/jaipur",
              },
              {
                text: "Kochi",
                link: "https://www.swiggy.com/city/kochi",
              },
              {
                text: "Coimbatore",
                link: "https://www.swiggy.com/city/coimbatore",
              },
              {
                text: "Lucknow",
                link: "https://www.swiggy.com/city/lucknow",
              },
              {
                text: "Nagpur",
                link: "https://www.swiggy.com/city/nagpur",
              },
              {
                text: "Vadodara",
                link: "https://www.swiggy.com/city/vadodara",
              },
              {
                text: "Indore",
                link: "https://www.swiggy.com/city/indore",
              },
              {
                text: "Guwahati",
                link: "https://www.swiggy.com/city/guwahati",
              },
              {
                text: "Vizag",
                link: "https://www.swiggy.com/city/vizag",
              },
              {
                text: "Surat",
                link: "https://www.swiggy.com/city/surat",
              },
              {
                text: "Dehradun",
                link: "https://www.swiggy.com/city/dehradun",
              },
              {
                text: "Noida",
                link: "https://www.swiggy.com/city/noida",
              },
              {
                text: "Ludhiana",
                link: "https://www.swiggy.com/city/ludhiana",
              },
              {
                text: "Trichy",
                link: "https://www.swiggy.com/city/trichy",
              },
              {
                text: "Vijayawada",
                link: "https://www.swiggy.com/city/vijayawada",
              },
              {
                text: "Kanpur",
                link: "https://www.swiggy.com/city/kanpur",
              },
              {
                text: "Mysore",
                link: "https://www.swiggy.com/city/mysore",
              },
              {
                text: "Nashik",
                link: "https://www.swiggy.com/city/nashik",
              },
              {
                text: "Udaipur",
                link: "https://www.swiggy.com/city/udaipur",
              },
              {
                text: "Pondicherry",
                link: "https://www.swiggy.com/city/pondicherry",
              },
              {
                text: "Agra",
                link: "https://www.swiggy.com/city/agra",
              },
              {
                text: "Aurangabad",
                link: "https://www.swiggy.com/city/aurangabad",
              },
              {
                text: "Jalandhar",
                link: "https://www.swiggy.com/city/jalandhar",
              },
              {
                text: "Kota",
                link: "https://www.swiggy.com/city/kota",
              },
              {
                text: "Madurai",
                link: "https://www.swiggy.com/city/madurai",
              },
              {
                text: "Allahabad",
                link: "https://www.swiggy.com/city/allahabad",
              },
              {
                text: "Manipal",
                link: "https://www.swiggy.com/city/manipal",
              },
              {
                text: "Amritsar",
                link: "https://www.swiggy.com/city/amritsar",
              },
              {
                text: "Bareilly",
                link: "https://www.swiggy.com/city/bareilly",
              },
              {
                text: "Meerut",
                link: "https://www.swiggy.com/city/meerut",
              },
              {
                text: "Bhopal",
                link: "https://www.swiggy.com/city/bhopal",
              },
              {
                text: "Ooty",
                link: "https://www.swiggy.com/city/ooty",
              },
              {
                text: "Bhubaneswar",
                link: "https://www.swiggy.com/city/bhubaneswar",
              },
              {
                text: "Raipur",
                link: "https://www.swiggy.com/city/raipur",
              },
              {
                text: "Bikaner",
                link: "https://www.swiggy.com/city/bikaner",
              },
              {
                text: "Rajkot",
                link: "https://www.swiggy.com/city/rajkot",
              },
              {
                text: "Kozhikode",
                link: "https://www.swiggy.com/city/kozhikode",
              },
              {
                text: "Central Goa",
                link: "https://www.swiggy.com/city/central-goa",
              },
              {
                text: "Sirsa",
                link: "https://www.swiggy.com/city/sirsa",
              },
              {
                text: "Gwalior",
                link: "https://www.swiggy.com/city/gwalior",
              },
              {
                text: "Thrissur",
                link: "https://www.swiggy.com/city/thrissur",
              },
              {
                text: "Kharagpur",
                link: "https://www.swiggy.com/city/kharagpur",
              },
              {
                text: "Tirupati",
                link: "https://www.swiggy.com/city/tirupati",
              },
              {
                text: "Tirupur",
                link: "https://www.swiggy.com/city/tirupur",
              },
              {
                text: "Vellore",
                link: "https://www.swiggy.com/city/vellore",
              },
              {
                text: "Thiruvananthapuram",
                link: "https://www.swiggy.com/city/thiruvananthapuram",
              },
              {
                text: "Warangal",
                link: "https://www.swiggy.com/city/warangal",
              },
              {
                text: "Varanasi",
                link: "https://www.swiggy.com/city/varanasi",
              },
              {
                text: "Mangaluru",
                link: "https://www.swiggy.com/city/mangaluru",
              },
              {
                text: "Patna",
                link: "https://www.swiggy.com/city/patna",
              },
              {
                text: "Ranchi",
                link: "https://www.swiggy.com/city/ranchi",
              },
              {
                text: "Faridabad",
                link: "https://www.swiggy.com/city/faridabad",
              },
              {
                text: "Guntur",
                link: "https://www.swiggy.com/city/guntur",
              },
              {
                text: "Ujjain",
                link: "https://www.swiggy.com/city/ujjain",
              },
              {
                text: "Patiala",
                link: "https://www.swiggy.com/city/patiala",
              },
              {
                text: "Karnal",
                link: "https://www.swiggy.com/city/karnal",
              },
              {
                text: "Kakinada",
                link: "https://www.swiggy.com/city/kakinada",
              },
              {
                text: "Rajahmundry",
                link: "https://www.swiggy.com/city/rajahmundry",
              },
              {
                text: "Bilaspur",
                link: "https://www.swiggy.com/city/bilaspur",
              },
              {
                text: "Bhilai",
                link: "https://www.swiggy.com/city/bhilai",
              },
              {
                text: "Anand",
                link: "https://www.swiggy.com/city/anand",
              },
              {
                text: "Bhavnagar",
                link: "https://www.swiggy.com/city/bhavnagar",
              },
              {
                text: "Jammu",
                link: "https://www.swiggy.com/city/jammu",
              },
              {
                text: "Muktsar",
                link: "https://www.swiggy.com/city/muktsar",
              },
              {
                text: "Panipat",
                link: "https://www.swiggy.com/city/panipat",
              },
              {
                text: "Dhanbad",
                link: "https://www.swiggy.com/city/dhanbad",
              },
              {
                text: "Hubli",
                link: "https://www.swiggy.com/city/hubli",
              },
              {
                text: "Belgaum",
                link: "https://www.swiggy.com/city/belgaum",
              },
              {
                text: "Jabalpur",
                link: "https://www.swiggy.com/city/jabalpur",
              },
              {
                text: "Kolhapur",
                link: "https://www.swiggy.com/city/kolhapur",
              },
              {
                text: "Solapur",
                link: "https://www.swiggy.com/city/solapur",
              },
              {
                text: "Shillong",
                link: "https://www.swiggy.com/city/shillong",
              },
              {
                text: "Cuttack",
                link: "https://www.swiggy.com/city/cuttack",
              },
              {
                text: "Aligarh",
                link: "https://www.swiggy.com/city/aligarh",
              },
              {
                text: "Salem",
                link: "https://www.swiggy.com/city/salem",
              },
              {
                text: "Jodhpur",
                link: "https://www.swiggy.com/city/jodhpur",
              },
              {
                text: "Ajmer",
                link: "https://www.swiggy.com/city/ajmer",
              },
              {
                text: "Jhansi",
                link: "https://www.swiggy.com/city/jhansi",
              },
              {
                text: "Gorakhpur",
                link: "https://www.swiggy.com/city/gorakhpur",
              },
              {
                text: "Thanjavur",
                link: "https://www.swiggy.com/city/thanjavur",
              },
              {
                text: "Erode",
                link: "https://www.swiggy.com/city/erode",
              },
              {
                text: "Nellore",
                link: "https://www.swiggy.com/city/nellore",
              },
              {
                text: "Rourkela",
                link: "https://www.swiggy.com/city/rourkela",
              },
              {
                text: "Anantapur",
                link: "https://www.swiggy.com/city/anantapur",
              },
              {
                text: "Kurnool",
                link: "https://www.swiggy.com/city/kurnool",
              },
              {
                text: "Ahmednagar",
                link: "https://www.swiggy.com/city/ahmednagar",
              },
              {
                text: "Phagwara",
                link: "https://www.swiggy.com/city/phagwara",
              },
              {
                text: "Ambala",
                link: "https://www.swiggy.com/city/ambala",
              },
              {
                text: "Ballari",
                link: "https://www.swiggy.com/city/ballari",
              },
              {
                text: "Saharanpur",
                link: "https://www.swiggy.com/city/saharanpur",
              },
              {
                text: "Tirunelveli",
                link: "https://www.swiggy.com/city/tirunelveli",
              },
              {
                text: "Bathinda",
                link: "https://www.swiggy.com/city/bathinda",
              },
              {
                text: "Mathura",
                link: "https://www.swiggy.com/city/mathura",
              },
              {
                text: "Haridwar",
                link: "https://www.swiggy.com/city/haridwar",
              },
              {
                text: "Ratnagiri",
                link: "https://www.swiggy.com/city/ratnagiri",
              },
              {
                text: "Sangli",
                link: "https://www.swiggy.com/city/sangli",
              },
              {
                text: "Amravati",
                link: "https://www.swiggy.com/city/amravati",
              },
              {
                text: "Rishikesh",
                link: "https://www.swiggy.com/city/rishikesh",
              },
              {
                text: "Nagercoil",
                link: "https://www.swiggy.com/city/nagercoil",
              },
              {
                text: "KanyaKumari",
                link: "https://www.swiggy.com/city/kanyakumari",
              },
              {
                text: "Kadapa",
                link: "https://www.swiggy.com/city/kadapa",
              },
              {
                text: "Nizamabad",
                link: "https://www.swiggy.com/city/nizamabad",
              },
              {
                text: "Shivamogga",
                link: "https://www.swiggy.com/city/shivamogga",
              },
              {
                text: "Davanagere",
                link: "https://www.swiggy.com/city/davanagere",
              },
              {
                text: "Roorkee",
                link: "https://www.swiggy.com/city/roorkee",
              },
              {
                text: "Nanded",
                link: "https://www.swiggy.com/city/nanded",
              },
              {
                text: "Rewa",
                link: "https://www.swiggy.com/city/rewa",
              },
              {
                text: "Satna",
                link: "https://www.swiggy.com/city/satna",
              },
              {
                text: "Muzaffarpur",
                link: "https://www.swiggy.com/city/muzaffarpur",
              },
              {
                text: "Valsad",
                link: "https://www.swiggy.com/city/valsad",
              },
              {
                text: "Vapi",
                link: "https://www.swiggy.com/city/vapi",
              },
              {
                text: "Chhapra",
                link: "https://www.swiggy.com/city/chhapra",
              },
              {
                text: "Dharamshala",
                link: "https://www.swiggy.com/city/dharamshala",
              },
              {
                text: "Kollam",
                link: "https://www.swiggy.com/city/kollam",
              },
              {
                text: "Silchar",
                link: "https://www.swiggy.com/city/silchar",
              },
              {
                text: "Alappuzha",
                link: "https://www.swiggy.com/city/alappuzha",
              },
              {
                text: "Sonipat",
                link: "https://www.swiggy.com/city/sonipat",
              },
              {
                text: "Rohtak",
                link: "https://www.swiggy.com/city/rohtak",
              },
              {
                text: "Mehsana",
                link: "https://www.swiggy.com/city/mehsana",
              },
              {
                text: "Kullu",
                link: "https://www.swiggy.com/city/kullu",
              },
              {
                text: "Dhule",
                link: "https://www.swiggy.com/city/dhule",
              },
              {
                text: "Dharwad",
                link: "https://www.swiggy.com/city/dharwad",
              },
              {
                text: "Latur",
                link: "https://www.swiggy.com/city/latur",
              },
              {
                text: "Vizianagaram",
                link: "https://www.swiggy.com/city/vizianagaram",
              },
              {
                text: "Khammam",
                link: "https://www.swiggy.com/city/khammam",
              },
              {
                text: "Hampi",
                link: "https://www.swiggy.com/city/hampi",
              },
              {
                text: "Nainital",
                link: "https://www.swiggy.com/city/nainital",
              },
              {
                text: "Akola",
                link: "https://www.swiggy.com/city/akola",
              },
              {
                text: "Kalaburagi",
                link: "https://www.swiggy.com/city/kalaburagi",
              },
              {
                text: "Gaya",
                link: "https://www.swiggy.com/city/gaya",
              },
              {
                text: "Muzaffarnagar",
                link: "https://www.swiggy.com/city/muzaffarnagar",
              },
              {
                text: "Dewas",
                link: "https://www.swiggy.com/city/dewas",
              },
              {
                text: "Korba",
                link: "https://www.swiggy.com/city/korba",
              },
              {
                text: "Mussoorie",
                link: "https://www.swiggy.com/city/mussoorie",
              },
              {
                text: "Jalgaon",
                link: "https://www.swiggy.com/city/jalgaon",
              },
              {
                text: "Yamuna Nagar",
                link: "https://www.swiggy.com/city/yamuna-nagar",
              },
              {
                text: "Bhagalpur",
                link: "https://www.swiggy.com/city/bhagalpur",
              },
              {
                text: "Hapur",
                link: "https://www.swiggy.com/city/hapur",
              },
              {
                text: "Morena",
                link: "https://www.swiggy.com/city/morena",
              },
              {
                text: "Hassan",
                link: "https://www.swiggy.com/city/hassan",
              },
              {
                text: "Hisar",
                link: "https://www.swiggy.com/city/hisar",
              },
              {
                text: "Godhra",
                link: "https://www.swiggy.com/city/godhra",
              },
              {
                text: "Kolar ",
                link: "https://www.swiggy.com/city/kolar",
              },
              {
                text: "Rampur",
                link: "https://www.swiggy.com/city/rampur",
              },
              {
                text: "Sitapur",
                link: "https://www.swiggy.com/city/sitapur",
              },
              {
                text: "Etawah",
                link: "https://www.swiggy.com/city/etawah",
              },
              {
                text: "Porbandar",
                link: "https://www.swiggy.com/city/porbandar",
              },
              {
                text: "Nadiad",
                link: "https://www.swiggy.com/city/nadiad",
              },
              {
                text: "Sagar",
                link: "https://www.swiggy.com/city/sagar",
              },
              {
                text: "Morbi",
                link: "https://www.swiggy.com/city/morbi",
              },
              {
                text: "Chhindwara",
                link: "https://www.swiggy.com/city/chhindwara",
              },
              {
                text: "Tumakuru",
                link: "https://www.swiggy.com/city/tumakuru",
              },
              {
                text: "Singrauli",
                link: "https://www.swiggy.com/city/singrauli",
              },
              {
                text: "Thoothukudi",
                link: "https://www.swiggy.com/city/thoothukudi",
              },
              {
                text: "Katni",
                link: "https://www.swiggy.com/city/katni",
              },
              {
                text: "Khandwa",
                link: "https://www.swiggy.com/city/khandwa",
              },
              {
                text: "Eluru",
                link: "https://www.swiggy.com/city/eluru",
              },
              {
                text: "Malappuram",
                link: "https://www.swiggy.com/city/malappuram",
              },
              {
                text: "Dibrugarh",
                link: "https://www.swiggy.com/city/dibrugarh",
              },
              {
                text: "Deoghar",
                link: "https://www.swiggy.com/city/deoghar",
              },
              {
                text: "Khanna",
                link: "https://www.swiggy.com/city/khanna",
              },
              {
                text: "Bidar",
                link: "https://www.swiggy.com/city/bidar",
              },
              {
                text: "Madikeri",
                link: "https://www.swiggy.com/city/madikeri",
              },
              {
                text: "Haldwani",
                link: "https://www.swiggy.com/city/haldwani",
              },
              {
                text: "Farrukhabad",
                link: "https://www.swiggy.com/city/farrukhabad",
              },
              {
                text: "Malegaon",
                link: "https://www.swiggy.com/city/malegaon",
              },
              {
                text: "Dindigul",
                link: "https://www.swiggy.com/city/dindigul",
              },
              {
                text: "Shahjahanpur",
                link: "https://www.swiggy.com/city/shahjahanpur",
              },
              {
                text: "Beed",
                link: "https://www.swiggy.com/city/beed",
              },
              {
                text: "Junagadh",
                link: "https://www.swiggy.com/city/junagadh",
              },
              {
                text: "Asansol",
                link: "https://www.swiggy.com/city/asansol",
              },
              {
                text: "Beawar",
                link: "https://www.swiggy.com/city/beawar",
              },
              {
                text: "Kishangarh",
                link: "https://www.swiggy.com/city/kishangarh",
              },
              {
                text: "Parbhani",
                link: "https://www.swiggy.com/city/parbhani",
              },
              {
                text: "Gondia",
                link: "https://www.swiggy.com/city/gondia",
              },
              {
                text: "Ichalkaranji",
                link: "https://www.swiggy.com/city/ichalkaranji",
              },
              {
                text: "Jalna",
                link: "https://www.swiggy.com/city/jalna",
              },
              {
                text: "Yavatmal",
                link: "https://www.swiggy.com/city/yavatmal",
              },
              {
                text: "Shivpuri",
                link: "https://www.swiggy.com/city/shivpuri",
              },
              {
                text: "Moga",
                link: "https://www.swiggy.com/city/moga",
              },
              {
                text: "Abohar",
                link: "https://www.swiggy.com/city/abohar",
              },
              {
                text: "Adoni",
                link: "https://www.swiggy.com/city/adoni",
              },
              {
                text: "Madanapalle",
                link: "https://www.swiggy.com/city/madanapalle",
              },
              {
                text: "Tiruvannamalai",
                link: "https://www.swiggy.com/city/tiruvannamalai",
              },
              {
                text: "Satara",
                link: "https://www.swiggy.com/city/satara",
              },
              {
                text: "Ambur",
                link: "https://www.swiggy.com/city/ambur",
              },
              {
                text: "Karimnagar",
                link: "https://www.swiggy.com/city/karimnagar",
              },
              {
                text: "Ratlam",
                link: "https://www.swiggy.com/city/ratlam",
              },
              {
                text: "Moradabad",
                link: "https://www.swiggy.com/city/moradabad",
              },
              {
                text: "Machilipatnam",
                link: "https://www.swiggy.com/city/machilipatnam",
              },
              {
                text: "Ongole",
                link: "https://www.swiggy.com/city/ongole",
              },
              {
                text: "Kottayam",
                link: "https://www.swiggy.com/city/kottayam",
              },
              {
                text: "Darbhanga",
                link: "https://www.swiggy.com/city/darbhanga",
              },
              {
                text: "Kurukshetra",
                link: "https://www.swiggy.com/city/kurukshetra",
              },
              {
                text: "Unnao",
                link: "https://www.swiggy.com/city/unnao",
              },
              {
                text: "Bulandshahr",
                link: "https://www.swiggy.com/city/bulandshahr",
              },
              {
                text: "Durgapur",
                link: "https://www.swiggy.com/city/durgapur",
              },
              {
                text: "Siliguri",
                link: "https://www.swiggy.com/city/siliguri",
              },
              {
                text: "Pali",
                link: "https://www.swiggy.com/city/pali",
              },
              {
                text: "Tadepalligudem",
                link: "https://www.swiggy.com/city/tadepalligudem",
              },
              {
                text: "Ramagundam",
                link: "https://www.swiggy.com/city/ramagundam",
              },
              {
                text: "Mahbubnagar",
                link: "https://www.swiggy.com/city/mahbubnagar",
              },
              {
                text: "Bhiwani",
                link: "https://www.swiggy.com/city/bhiwani",
              },
              {
                text: "Cuddalore",
                link: "https://www.swiggy.com/city/cuddalore",
              },
              {
                text: "Kaithal",
                link: "https://www.swiggy.com/city/kaithal",
              },
              {
                text: "Jagtial",
                link: "https://www.swiggy.com/city/jagtial",
              },
              {
                text: "Palakkad",
                link: "https://www.swiggy.com/city/palakkad",
              },
              {
                text: "Guna",
                link: "https://www.swiggy.com/city/guna",
              },
              {
                text: "Kumbakonam",
                link: "https://www.swiggy.com/city/kumbakonam",
              },
              {
                text: "Maunath Bhanjan",
                link: "https://www.swiggy.com/city/maunath-bhanjan",
              },
              {
                text: "Baripada",
                link: "https://www.swiggy.com/city/baripada",
              },
              {
                text: "Orai",
                link: "https://www.swiggy.com/city/orai",
              },
              {
                text: "Bhadrak",
                link: "https://www.swiggy.com/city/bhadrak",
              },
              {
                text: "Batala",
                link: "https://www.swiggy.com/city/batala",
              },
              {
                text: "Firozpur",
                link: "https://www.swiggy.com/city/firozpur",
              },
              {
                text: "Barnala",
                link: "https://www.swiggy.com/city/barnala",
              },
              {
                text: "Raigarh",
                link: "https://www.swiggy.com/city/raigarh",
              },
              {
                text: "Nagaon",
                link: "https://www.swiggy.com/city/nagaon",
              },
              {
                text: "Mainpuri",
                link: "https://www.swiggy.com/city/mainpuri",
              },
              {
                text: "Balurghat",
                link: "https://www.swiggy.com/city/balurghat",
              },
              {
                text: "Giridih",
                link: "https://www.swiggy.com/city/giridih",
              },
              {
                text: "Ghazipur",
                link: "https://www.swiggy.com/city/ghazipur",
              },
              {
                text: "Jagdalpur",
                link: "https://www.swiggy.com/city/jagdalpur",
              },
              {
                text: "Vidisha",
                link: "https://www.swiggy.com/city/vidisha",
              },
              {
                text: "Dimapur",
                link: "https://www.swiggy.com/city/dimapur",
              },
              {
                text: "Shikohabad",
                link: "https://www.swiggy.com/city/shikohabad",
              },
              {
                text: "Imphal",
                link: "https://www.swiggy.com/city/imphal",
              },
              {
                text: "Lakhimpur",
                link: "https://www.swiggy.com/city/lakhimpur",
              },
              {
                text: "Rudrapur",
                link: "https://www.swiggy.com/city/rudrapur",
              },
              {
                text: "Ambikapur",
                link: "https://www.swiggy.com/city/ambikapur",
              },
              {
                text: "Rae Bareli",
                link: "https://www.swiggy.com/city/rae-bareli",
              },
              {
                text: "Tinsukia",
                link: "https://www.swiggy.com/city/tinsukia",
              },
              {
                text: "Rajapalayam",
                link: "https://www.swiggy.com/city/rajapalayam",
              },
              {
                text: "Rajnandgaon",
                link: "https://www.swiggy.com/city/rajnandgaon",
              },
              {
                text: "Kashipur",
                link: "https://www.swiggy.com/city/kashipur",
              },
              {
                text: "Ranibennur",
                link: "https://www.swiggy.com/city/ranibennur",
              },
              {
                text: "Burhanpur",
                link: "https://www.swiggy.com/city/burhanpur",
              },
              {
                text: "Bhadravati",
                link: "https://www.swiggy.com/city/bhadravati",
              },
              {
                text: "Chittoor",
                link: "https://www.swiggy.com/city/chittoor",
              },
              {
                text: "Pudukkottai",
                link: "https://www.swiggy.com/city/pudukkottai",
              },
              {
                text: "Hardoi",
                link: "https://www.swiggy.com/city/hardoi",
              },
              {
                text: "Basti",
                link: "https://www.swiggy.com/city/basti",
              },
              {
                text: "Karaikkudi",
                link: "https://www.swiggy.com/city/karaikkudi",
              },
              {
                text: "Lalitpur",
                link: "https://www.swiggy.com/city/lalitpur",
              },
              {
                text: "Hospet",
                link: "https://www.swiggy.com/city/hospet",
              },
              {
                text: "Budaun",
                link: "https://www.swiggy.com/city/budaun",
              },
              {
                text: "Neemuch",
                link: "https://www.swiggy.com/city/neemuch",
              },
              {
                text: "Pilibhit",
                link: "https://www.swiggy.com/city/pilibhit",
              },
              {
                text: "Barshi",
                link: "https://www.swiggy.com/city/barshi",
              },
              {
                text: "Sri Ganganagar",
                link: "https://www.swiggy.com/city/sri-ganganagar",
              },
              {
                text: "Wardha",
                link: "https://www.swiggy.com/city/wardha",
              },
              {
                text: "Sehore",
                link: "https://www.swiggy.com/city/sehore",
              },
              {
                text: "Bhimavaram",
                link: "https://www.swiggy.com/city/bhimavaram",
              },
              {
                text: "Hanumangarh",
                link: "https://www.swiggy.com/city/hanumangarh",
              },
              {
                text: "Pathankot",
                link: "https://www.swiggy.com/city/pathankot",
              },
              {
                text: "Puri",
                link: "https://www.swiggy.com/city/puri",
              },
              {
                text: "Fatehpur",
                link: "https://www.swiggy.com/city/fatehpur",
              },
              {
                text: "Surendranagar Dudhrej",
                link: "https://www.swiggy.com/city/surendranagar-dudhrej",
              },
              {
                text: "Jamnagar",
                link: "https://www.swiggy.com/city/jamnagar",
              },
              {
                text: "Bhuj",
                link: "https://www.swiggy.com/city/bhuj",
              },
              {
                text: "Gandhidham",
                link: "https://www.swiggy.com/city/gandhidham",
              },
              {
                text: "Bharuch",
                link: "https://www.swiggy.com/city/bharuch",
              },
              {
                text: "Navsari",
                link: "https://www.swiggy.com/city/navsari",
              },
              {
                text: "Amreli",
                link: "https://www.swiggy.com/city/amreli",
              },
              {
                text: "Palanpur",
                link: "https://www.swiggy.com/city/palanpur",
              },
              {
                text: "Bhilwara",
                link: "https://www.swiggy.com/city/bhilwara",
              },
              {
                text: "Suratgarh",
                link: "https://www.swiggy.com/city/suratgarh",
              },
              {
                text: "Sikar",
                link: "https://www.swiggy.com/city/sikar",
              },
              {
                text: "Churu",
                link: "https://www.swiggy.com/city/churu",
              },
              {
                text: "Alwar",
                link: "https://www.swiggy.com/city/alwar",
              },
              {
                text: "Bhiwadi",
                link: "https://www.swiggy.com/city/bhiwadi",
              },
              {
                text: "Bharatpur",
                link: "https://www.swiggy.com/city/bharatpur",
              },
              {
                text: "Mount Abu",
                link: "https://www.swiggy.com/city/mount-abu",
              },
              {
                text: "Bundi",
                link: "https://www.swiggy.com/city/bundi",
              },
              {
                text: "Sawai Madhopur",
                link: "https://www.swiggy.com/city/sawai-madhopur",
              },
              {
                text: "Purulia",
                link: "https://www.swiggy.com/city/purulia",
              },
              {
                text: "Bardhaman",
                link: "https://www.swiggy.com/city/bardhaman",
              },
              {
                text: "Raniganj",
                link: "https://www.swiggy.com/city/raniganj",
              },
              {
                text: "Darjeeling",
                link: "https://www.swiggy.com/city/darjeeling",
              },
              {
                text: "Jalpaiguri",
                link: "https://www.swiggy.com/city/jalpaiguri",
              },
              {
                text: "Chittorgarh",
                link: "https://www.swiggy.com/city/chittorgarh",
              },
              {
                text: "Dholpur",
                link: "https://www.swiggy.com/city/dholpur",
              },
              {
                text: "Uluberia",
                link: "https://www.swiggy.com/city/uluberia",
              },
              {
                text: "Nabadwip",
                link: "https://www.swiggy.com/city/nabadwip",
              },
              {
                text: "Bongaon",
                link: "https://www.swiggy.com/city/bongaon",
              },
              {
                text: "Kanchrapara",
                link: "https://www.swiggy.com/city/kanchrapara",
              },
              {
                text: "Habra",
                link: "https://www.swiggy.com/city/habra",
              },
              {
                text: "Firozabad",
                link: "https://www.swiggy.com/city/firozabad",
              },
              {
                text: "Nalgonda",
                link: "https://www.swiggy.com/city/nalgonda",
              },
              {
                text: "Chandrapur",
                link: "https://www.swiggy.com/city/chandrapur",
              },
              {
                text: "Bijapur",
                link: "https://www.swiggy.com/city/bijapur",
              },
              {
                text: "Bhusawal",
                link: "https://www.swiggy.com/city/bhusawal",
              },
              {
                text: "Raichur",
                link: "https://www.swiggy.com/city/raichur",
              },
              {
                text: "Bahraich",
                link: "https://www.swiggy.com/city/bahraich",
              },
              {
                text: "Azamgarh",
                link: "https://www.swiggy.com/city/azamgarh",
              },
              {
                text: "Bahadurgarh",
                link: "https://www.swiggy.com/city/bahadurgarh",
              },
              {
                text: "Jind",
                link: "https://www.swiggy.com/city/jind",
              },
              {
                text: "Rewari",
                link: "https://www.swiggy.com/city/rewari",
              },
              {
                text: "Palwal",
                link: "https://www.swiggy.com/city/palwal",
              },
              {
                text: "Hathras",
                link: "https://www.swiggy.com/city/hathras",
              },
              {
                text: "Sambalpur",
                link: "https://www.swiggy.com/city/sambalpur",
              },
              {
                text: "Banda",
                link: "https://www.swiggy.com/city/banda",
              },
              {
                text: "Hoshiarpur",
                link: "https://www.swiggy.com/city/hoshiarpur",
              },
              {
                text: "Faridkot",
                link: "https://www.swiggy.com/city/faridkot",
              },
              {
                text: "Mandsaur",
                link: "https://www.swiggy.com/city/mandsaur",
              },
              {
                text: "Suryapet",
                link: "https://www.swiggy.com/city/suryapet",
              },
              {
                text: "Adilabad",
                link: "https://www.swiggy.com/city/adilabad",
              },
              {
                text: "Narasaraopet",
                link: "https://www.swiggy.com/city/narasaraopet",
              },
              {
                text: "Faizabad",
                link: "https://www.swiggy.com/city/faizabad",
              },
              {
                text: "Tadpatri",
                link: "https://www.swiggy.com/city/tadpatri",
              },
              {
                text: "Gonda",
                link: "https://www.swiggy.com/city/gonda",
              },
              {
                text: "Mughalsarai",
                link: "https://www.swiggy.com/city/mughalsarai",
              },
              {
                text: "Medinipur",
                link: "https://www.swiggy.com/city/medinipur",
              },
              {
                text: "Nagda",
                link: "https://www.swiggy.com/city/nagda",
              },
              {
                text: "Raiganj",
                link: "https://www.swiggy.com/city/raiganj",
              },
              {
                text: "Deoria City",
                link: "https://www.swiggy.com/city/deoria-city",
              },
              {
                text: "Sultanpur",
                link: "https://www.swiggy.com/city/sultanpur",
              },
              {
                text: "Shamli",
                link: "https://www.swiggy.com/city/shamli",
              },
              {
                text: "Krishnanagar",
                link: "https://www.swiggy.com/city/krishnanagar",
              },
              {
                text: "Ballia",
                link: "https://www.swiggy.com/city/ballia",
              },
              {
                text: "Guntakal",
                link: "https://www.swiggy.com/city/guntakal",
              },
              {
                text: "Miryalaguda",
                link: "https://www.swiggy.com/city/miryalaguda",
              },
              {
                text: "Etah",
                link: "https://www.swiggy.com/city/etah",
              },
              {
                text: "Berhampore",
                link: "https://www.swiggy.com/city/berhampore",
              },
              {
                text: "Gudivada",
                link: "https://www.swiggy.com/city/gudivada",
              },
              {
                text: "Haldia",
                link: "https://www.swiggy.com/city/haldia",
              },
              {
                text: "Santipur",
                link: "https://www.swiggy.com/city/santipur",
              },
              {
                text: "Basirhat",
                link: "https://www.swiggy.com/city/basirhat",
              },
              {
                text: "Udgir",
                link: "https://www.swiggy.com/city/udgir",
              },
              {
                text: "Proddatur",
                link: "https://www.swiggy.com/city/proddatur",
              },
              {
                text: "Nagapattinam",
                link: "https://www.swiggy.com/city/nagapattinam",
              },
              {
                text: "Chikmagalur",
                link: "https://www.swiggy.com/city/chikmagalur",
              },
              {
                text: "Chandausi",
                link: "https://www.swiggy.com/city/chandausi",
              },
              {
                text: "Bhind",
                link: "https://www.swiggy.com/city/bhind",
              },
              {
                text: "Mandya",
                link: "https://www.swiggy.com/city/mandya",
              },
              {
                text: "Bagalkot",
                link: "https://www.swiggy.com/city/bagalkot",
              },
              {
                text: "Nandurbar",
                link: "https://www.swiggy.com/city/nandurbar",
              },
              {
                text: "Chitradurga",
                link: "https://www.swiggy.com/city/chitradurga",
              },
              {
                text: "Osmanabad",
                link: "https://www.swiggy.com/city/osmanabad",
              },
              {
                text: "Modinagar",
                link: "https://www.swiggy.com/city/modinagar",
              },
              {
                text: "Gadag-Betigeri",
                link: "https://www.swiggy.com/city/gadag-betigeri",
              },
              {
                text: "Hoshangabad",
                link: "https://www.swiggy.com/city/hoshangabad",
              },
              {
                text: "Jaunpur",
                link: "https://www.swiggy.com/city/jaunpur",
              },
              {
                text: "Port Blair",
                link: "https://www.swiggy.com/city/port-blair",
              },
              {
                text: "Jorhat",
                link: "https://www.swiggy.com/city/jorhat",
              },
              {
                text: "Nandyal",
                link: "https://www.swiggy.com/city/nandyal",
              },
              {
                text: "Biharsharif",
                link: "https://www.swiggy.com/city/biharsharif",
              },
              {
                text: "Buxar",
                link: "https://www.swiggy.com/city/buxar",
              },
              {
                text: "Siwan",
                link: "https://www.swiggy.com/city/siwan",
              },
              {
                text: "Dehri",
                link: "https://www.swiggy.com/city/dehri",
              },
              {
                text: "Bettiah",
                link: "https://www.swiggy.com/city/bettiah",
              },
              {
                text: "Kishanganj",
                link: "https://www.swiggy.com/city/kishanganj",
              },
              {
                text: "Saharsa",
                link: "https://www.swiggy.com/city/saharsa",
              },
              {
                text: "Hajipur",
                link: "https://www.swiggy.com/city/hajipur",
              },
              {
                text: "Motihari",
                link: "https://www.swiggy.com/city/motihari",
              },
              {
                text: "Sasaram",
                link: "https://www.swiggy.com/city/sasaram",
              },
              {
                text: "Munger",
                link: "https://www.swiggy.com/city/munger",
              },
              {
                text: "Katihar",
                link: "https://www.swiggy.com/city/katihar",
              },
              {
                text: "Arrah",
                link: "https://www.swiggy.com/city/arrah",
              },
              {
                text: "Srikakulam",
                link: "https://www.swiggy.com/city/srikakulam",
              },
              {
                text: "Begusarai",
                link: "https://www.swiggy.com/city/begusarai",
              },
              {
                text: "Neyveli",
                link: "https://www.swiggy.com/city/neyveli",
              },
              {
                text: "Waidhan",
                link: "https://www.swiggy.com/city/waidhan",
              },
              {
                text: "Markapur",
                link: "https://www.swiggy.com/city/markapur",
              },
              {
                text: "Chikkaballapur",
                link: "https://www.swiggy.com/city/chikkaballapur",
              },
              {
                text: "Bhatkal",
                link: "https://www.swiggy.com/city/bhatkal",
              },
              {
                text: "Gokak",
                link: "https://www.swiggy.com/city/gokak",
              },
              {
                text: "Itarsi",
                link: "https://www.swiggy.com/city/itarsi",
              },
              {
                text: "Dhar",
                link: "https://www.swiggy.com/city/dhar",
              },
              {
                text: "Chalisgaon",
                link: "https://www.swiggy.com/city/chalisgaon",
              },
              {
                text: "Thiruvallur",
                link: "https://www.swiggy.com/city/thiruvallur",
              },
              {
                text: "Namakkal",
                link: "https://www.swiggy.com/city/namakkal",
              },
              {
                text: "Dharmapuri",
                link: "https://www.swiggy.com/city/dharmapuri",
              },
              {
                text: "Bhandara",
                link: "https://www.swiggy.com/city/bhandara",
              },
              {
                text: "Virudhunagar",
                link: "https://www.swiggy.com/city/virudhunagar",
              },
              {
                text: "Siddipet",
                link: "https://www.swiggy.com/city/siddipet",
              },
              {
                text: "Gadwal",
                link: "https://www.swiggy.com/city/gadwal",
              },
              {
                text: "Bodhan-Rural",
                link: "https://www.swiggy.com/city/bodhan-rural",
              },
              {
                text: "Kamareddy",
                link: "https://www.swiggy.com/city/kamareddy",
              },
              {
                text: "Jhunjhunu",
                link: "https://www.swiggy.com/city/jhunjhunu",
              },
              {
                text: "Kapurthala",
                link: "https://www.swiggy.com/city/kapurthala",
              },
              {
                text: "Sangrur",
                link: "https://www.swiggy.com/city/sangrur",
              },
              {
                text: "Gurdaspur",
                link: "https://www.swiggy.com/city/gurdaspur",
              },
              {
                text: "Ramgarh",
                link: "https://www.swiggy.com/city/ramgarh",
              },
              {
                text: "Bantwal",
                link: "https://www.swiggy.com/city/bantwal",
              },
              {
                text: "Doddaballapura",
                link: "https://www.swiggy.com/city/doddaballapura",
              },
              {
                text: "Buldana",
                link: "https://www.swiggy.com/city/buldana",
              },
              {
                text: "Karad",
                link: "https://www.swiggy.com/city/karad",
              },
              {
                text: "Krishnagiri",
                link: "https://www.swiggy.com/city/krishnagiri",
              },
              {
                text: "Tiptur",
                link: "https://www.swiggy.com/city/tiptur",
              },
              {
                text: "Bhadrachalam",
                link: "https://www.swiggy.com/city/bhadrachalam",
              },
              {
                text: "Mancherial",
                link: "https://www.swiggy.com/city/mancherial",
              },
              {
                text: "Balrampur",
                link: "https://www.swiggy.com/city/balrampur",
              },
              {
                text: "Bharabanki",
                link: "https://www.swiggy.com/city/bharabanki",
              },
              {
                text: "Malout",
                link: "https://www.swiggy.com/city/malout",
              },
              {
                text: "Fatehgarh Sahib",
                link: "https://www.swiggy.com/city/fatehgarh-sahib",
              },
              {
                text: "Ropar",
                link: "https://www.swiggy.com/city/ropar",
              },
              {
                text: "Nangal",
                link: "https://www.swiggy.com/city/nangal",
              },
              {
                text: "Narnaul",
                link: "https://www.swiggy.com/city/narnaul",
              },
              {
                text: "Naraingarh",
                link: "https://www.swiggy.com/city/naraingarh",
              },
              {
                text: "Himmatnagar",
                link: "https://www.swiggy.com/city/himmatnagar",
              },
              {
                text: "Dausa",
                link: "https://www.swiggy.com/city/dausa",
              },
              {
                text: "Jahanabad",
                link: "https://www.swiggy.com/city/jahanabad",
              },
              {
                text: "Samastipur",
                link: "https://www.swiggy.com/city/samastipur",
              },
              {
                text: "Purnea",
                link: "https://www.swiggy.com/city/purnea",
              },
              {
                text: "Berhampur",
                link: "https://www.swiggy.com/city/berhampur",
              },
              {
                text: "Malda",
                link: "https://www.swiggy.com/city/malda",
              },
              {
                text: "Tuni",
                link: "https://www.swiggy.com/city/tuni",
              },
              {
                text: "Puttur",
                link: "https://www.swiggy.com/city/puttur",
              },
              {
                text: "Rayachoty",
                link: "https://www.swiggy.com/city/rayachoty",
              },
              {
                text: "Nirmal",
                link: "https://www.swiggy.com/city/nirmal",
              },
              {
                text: "Mirzapur",
                link: "https://www.swiggy.com/city/mirzapur",
              },
              {
                text: "Tanuku",
                link: "https://www.swiggy.com/city/tanuku",
              },
              {
                text: "Dahod",
                link: "https://www.swiggy.com/city/dahod",
              },
              {
                text: "Barmer",
                link: "https://www.swiggy.com/city/barmer",
              },
              {
                text: "Gangapur City",
                link: "https://www.swiggy.com/city/gangapur-city",
              },
              {
                text: "Mandi Gobindgarh",
                link: "https://www.swiggy.com/city/mandi-gobindgarh",
              },
              {
                text: "Tarn Taran Sahib",
                link: "https://www.swiggy.com/city/tarn-taran-sahib",
              },
              {
                text: "Nakodar",
                link: "https://www.swiggy.com/city/nakodar",
              },
              {
                text: "Ankleshwar",
                link: "https://www.swiggy.com/city/ankleshwar",
              },
              {
                text: "Vyara",
                link: "https://www.swiggy.com/city/vyara",
              },
              {
                text: "Bardoli",
                link: "https://www.swiggy.com/city/bardoli",
              },
              {
                text: "Halol",
                link: "https://www.swiggy.com/city/halol",
              },
              {
                text: "Bijnor",
                link: "https://www.swiggy.com/city/bijnor",
              },
              {
                text: "Sangamner",
                link: "https://www.swiggy.com/city/sangamner",
              },
              {
                text: "Baramati",
                link: "https://www.swiggy.com/city/baramati",
              },
              {
                text: "Betul",
                link: "https://www.swiggy.com/city/betul",
              },
              {
                text: "Chhatarpur",
                link: "https://www.swiggy.com/city/chhatarpur",
              },
              {
                text: "Balaghat",
                link: "https://www.swiggy.com/city/balaghat",
              },
              {
                text: "Sivakasi",
                link: "https://www.swiggy.com/city/sivakasi",
              },
              {
                text: "Viluppuram",
                link: "https://www.swiggy.com/city/viluppuram",
              },
              {
                text: "Ramanathapuram",
                link: "https://www.swiggy.com/city/ramanathapuram",
              },
              {
                text: "Sirsi",
                link: "https://www.swiggy.com/city/sirsi",
              },
              {
                text: "Theni",
                link: "https://www.swiggy.com/city/theni",
              },
              {
                text: "Karur",
                link: "https://www.swiggy.com/city/karur",
              },
              {
                text: "Karwar",
                link: "https://www.swiggy.com/city/karwar",
              },
              {
                text: "Sindhanur",
                link: "https://www.swiggy.com/city/sindhanur",
              },
              {
                text: "Kannur",
                link: "https://www.swiggy.com/city/kannur",
              },
              {
                text: "Noida 1",
                link: "https://www.swiggy.com/city/noida-1",
              },
              {
                text: "Thiruvalla",
                link: "https://www.swiggy.com/city/thiruvalla",
              },
              {
                text: "Thodupuzha",
                link: "https://www.swiggy.com/city/thodupuzha",
              },
              {
                text: "Kadiri",
                link: "https://www.swiggy.com/city/kadiri",
              },
              {
                text: "Kavali",
                link: "https://www.swiggy.com/city/kavali",
              },
              {
                text: "Tezpur",
                link: "https://www.swiggy.com/city/tezpur",
              },
              {
                text: "Kayamkulam",
                link: "https://www.swiggy.com/city/kayamkulam",
              },
              {
                text: "Kottarakkara",
                link: "https://www.swiggy.com/city/kottarakkara",
              },
              {
                text: "Mandi Dabwali",
                link: "https://www.swiggy.com/city/mandi-dabwali",
              },
              {
                text: "Fatehabad",
                link: "https://www.swiggy.com/city/fatehabad",
              },
              {
                text: "Jagraon",
                link: "https://www.swiggy.com/city/jagraon",
              },
              {
                text: "Mansa",
                link: "https://www.swiggy.com/city/mansa",
              },
              {
                text: "Pinjore City",
                link: "https://www.swiggy.com/city/pinjore-city",
              },
              {
                text: "Fazilka",
                link: "https://www.swiggy.com/city/fazilka",
              },
              {
                text: "Baddi",
                link: "https://www.swiggy.com/city/baddi",
              },
              {
                text: "Solan",
                link: "https://www.swiggy.com/city/solan",
              },
              {
                text: "Daltonganj",
                link: "https://www.swiggy.com/city/daltonganj",
              },
              {
                text: "Balangir",
                link: "https://www.swiggy.com/city/balangir",
              },
              {
                text: "Kothagudem",
                link: "https://www.swiggy.com/city/kothagudem",
              },
              {
                text: "Hansi",
                link: "https://www.swiggy.com/city/hansi",
              },
              {
                text: "Aurangabad_Bihar",
                link: "https://www.swiggy.com/city/aurangabadbihar",
              },
              {
                text: "Gopalganj",
                link: "https://www.swiggy.com/city/gopalganj",
              },
              {
                text: "Jharsuguda",
                link: "https://www.swiggy.com/city/jharsuguda",
              },
              {
                text: "Tohana",
                link: "https://www.swiggy.com/city/tohana",
              },
              {
                text: "Jhalawar",
                link: "https://www.swiggy.com/city/jhalawar",
              },
              {
                text: "Sivasagar",
                link: "https://www.swiggy.com/city/sivasagar",
              },
              {
                text: "Bagdogra",
                link: "https://www.swiggy.com/city/bagdogra",
              },
              {
                text: "Kendrapada",
                link: "https://www.swiggy.com/city/kendrapada",
              },
              {
                text: "Mallapuram (Do not Use)",
                link: "https://www.swiggy.com/city/mallapuram-do-not-use",
              },
              {
                text: "Veraval",
                link: "https://www.swiggy.com/city/veraval",
              },
              {
                text: "Daman",
                link: "https://www.swiggy.com/city/daman",
              },
              {
                text: "Chiplun",
                link: "https://www.swiggy.com/city/chiplun",
              },
              {
                text: "Silvassa",
                link: "https://www.swiggy.com/city/silvassa",
              },
              {
                text: "Lonavla",
                link: "https://www.swiggy.com/city/lonavla",
              },
              {
                text: "Bongaigaon",
                link: "https://www.swiggy.com/city/bongaigaon",
              },
              {
                text: "Golaghat",
                link: "https://www.swiggy.com/city/golaghat",
              },
              {
                text: "Duliajan",
                link: "https://www.swiggy.com/city/duliajan",
              },
              {
                text: "Bolpur",
                link: "https://www.swiggy.com/city/bolpur",
              },
              {
                text: "Madhubani",
                link: "https://www.swiggy.com/city/madhubani",
              },
              {
                text: "Balasore",
                link: "https://www.swiggy.com/city/balasore",
              },
              {
                text: "Palampur",
                link: "https://www.swiggy.com/city/palampur",
              },
              {
                text: "Kotdwar",
                link: "https://www.swiggy.com/city/kotdwar",
              },
              {
                text: "Koppal",
                link: "https://www.swiggy.com/city/koppal",
              },
              {
                text: "Chikhli",
                link: "https://www.swiggy.com/city/chikhli",
              },
              {
                text: "Dahanu",
                link: "https://www.swiggy.com/city/dahanu",
              },
              {
                text: "Itanagar",
                link: "https://www.swiggy.com/city/itanagar",
              },
              {
                text: "Rangpo",
                link: "https://www.swiggy.com/city/rangpo",
              },
              {
                text: "Aizawl",
                link: "https://www.swiggy.com/city/aizawl",
              },
              {
                text: "Gangtok",
                link: "https://www.swiggy.com/city/gangtok",
              },
              {
                text: "Mayiladuthurai",
                link: "https://www.swiggy.com/city/mayiladuthurai",
              },
              {
                text: "Kannauj",
                link: "https://www.swiggy.com/city/kannauj",
              },
              {
                text: "Cooch Behar",
                link: "https://www.swiggy.com/city/cooch-behar",
              },
              {
                text: "Palani",
                link: "https://www.swiggy.com/city/palani",
              },
              {
                text: "Bilimora",
                link: "https://www.swiggy.com/city/bilimora",
              },
              {
                text: "Boisar",
                link: "https://www.swiggy.com/city/boisar",
              },
              {
                text: "Kohima",
                link: "https://www.swiggy.com/city/kohima",
              },
              {
                text: "Naharlagun",
                link: "https://www.swiggy.com/city/naharlagun",
              },
              {
                text: "Dumka",
                link: "https://www.swiggy.com/city/dumka",
              },
              {
                text: "Rajsamand",
                link: "https://www.swiggy.com/city/rajsamand",
              },
              {
                text: "Gauriganj",
                link: "https://www.swiggy.com/city/gauriganj",
              },
              {
                text: "Bodinayakanur",
                link: "https://www.swiggy.com/city/bodinayakanur",
              },
              {
                text: "Bhawanipatna",
                link: "https://www.swiggy.com/city/bhawanipatna",
              },
              {
                text: "Baran",
                link: "https://www.swiggy.com/city/baran",
              },
              {
                text: "Narsinghpur",
                link: "https://www.swiggy.com/city/narsinghpur",
              },
              {
                text: "Kovilpatti",
                link: "https://www.swiggy.com/city/kovilpatti",
              },
              {
                text: "Pusad",
                link: "https://www.swiggy.com/city/pusad",
              },
              {
                text: "Kendujhar",
                link: "https://www.swiggy.com/city/kendujhar",
              },
              {
                text: "Manali",
                link: "https://www.swiggy.com/city/manali",
              },
              {
                text: "Diu",
                link: "https://www.swiggy.com/city/diu",
              },
              {
                text: "Khamgaon",
                link: "https://www.swiggy.com/city/khamgaon",
              },
              {
                text: "Ramanagara",
                link: "https://www.swiggy.com/city/ramanagara",
              },
              {
                text: "Alipurduar",
                link: "https://www.swiggy.com/city/alipurduar",
              },
              {
                text: "Almora",
                link: "https://www.swiggy.com/city/almora",
              },
              {
                text: "Jhargram",
                link: "https://www.swiggy.com/city/jhargram",
              },
              {
                text: "Arambagh",
                link: "https://www.swiggy.com/city/arambagh",
              },
              {
                text: "Bhadohi",
                link: "https://www.swiggy.com/city/bhadohi",
              },
              {
                text: "Tenkasi",
                link: "https://www.swiggy.com/city/tenkasi",
              },
              {
                text: "Srivilliputhur",
                link: "https://www.swiggy.com/city/srivilliputhur",
              },
              {
                text: "Chidambaram",
                link: "https://www.swiggy.com/city/chidambaram",
              },
              {
                text: "Rajgarh",
                link: "https://www.swiggy.com/city/rajgarh",
              },
              {
                text: "Pratapgarh",
                link: "https://www.swiggy.com/city/pratapgarh",
              },
              {
                text: "Washim",
                link: "https://www.swiggy.com/city/washim",
              },
              {
                text: "Raghunathpur",
                link: "https://www.swiggy.com/city/raghunathpur",
              },
              {
                text: "Suri",
                link: "https://www.swiggy.com/city/suri",
              },
              {
                text: "Kadayanallur",
                link: "https://www.swiggy.com/city/kadayanallur",
              },
              {
                text: "Thiruvarur",
                link: "https://www.swiggy.com/city/thiruvarur",
              },
              {
                text: "Ranaghat-WB",
                link: "https://www.swiggy.com/city/ranaghat-wb",
              },
              {
                text: "Wayanad",
                link: "https://www.swiggy.com/city/wayanad",
              },
              {
                text: "Perambalur",
                link: "https://www.swiggy.com/city/perambalur",
              },
              {
                text: "Paramakudi",
                link: "https://www.swiggy.com/city/paramakudi",
              },
              {
                text: "Bela Pratapgarh",
                link: "https://www.swiggy.com/city/bela-pratapgarh",
              },
              {
                text: "Mahoba",
                link: "https://www.swiggy.com/city/mahoba",
              },
              {
                text: "Sitamarhi",
                link: "https://www.swiggy.com/city/sitamarhi",
              },
              {
                text: "Chakdaha",
                link: "https://www.swiggy.com/city/chakdaha",
              },
              {
                text: "Khalilabad",
                link: "https://www.swiggy.com/city/khalilabad",
              },
              {
                text: "Pattukkottai",
                link: "https://www.swiggy.com/city/pattukkottai",
              },
              {
                text: "Tindivanam",
                link: "https://www.swiggy.com/city/tindivanam",
              },
              {
                text: "Tiruttani",
                link: "https://www.swiggy.com/city/tiruttani",
              },
              {
                text: "Gangarampur",
                link: "https://www.swiggy.com/city/gangarampur",
              },
              {
                text: "Dharapuram",
                link: "https://www.swiggy.com/city/dharapuram",
              },
              {
                text: "Arakkonam",
                link: "https://www.swiggy.com/city/arakkonam",
              },
              {
                text: "Sirkali",
                link: "https://www.swiggy.com/city/sirkali",
              },
              {
                text: "Mettupalayam",
                link: "https://www.swiggy.com/city/mettupalayam",
              },
              {
                text: "Digboi",
                link: "https://www.swiggy.com/city/digboi",
              },
              {
                text: "Biswanath Chariali",
                link: "https://www.swiggy.com/city/biswanath-chariali",
              },
              {
                text: "Nalbari",
                link: "https://www.swiggy.com/city/nalbari",
              },
              {
                text: "Shirdi city",
                link: "https://www.swiggy.com/city/shirdi-city",
              },
              {
                text: "Mukerian",
                link: "https://www.swiggy.com/city/mukerian",
              },
              {
                text: "Hosur",
                link: "https://www.swiggy.com/city/hosur",
              },
              {
                text: "Palakollu",
                link: "https://www.swiggy.com/city/palakollu",
              },
              {
                text: "Ravulapalem",
                link: "https://www.swiggy.com/city/ravulapalem",
              },
              {
                text: "Barh",
                link: "https://www.swiggy.com/city/barh",
              },
              {
                text: "Palghar",
                link: "https://www.swiggy.com/city/palghar",
              },
              {
                text: "Kushalnagar",
                link: "https://www.swiggy.com/city/kushalnagar",
              },
              {
                text: "Dungarpur",
                link: "https://www.swiggy.com/city/dungarpur",
              },
              {
                text: "Chaibasa",
                link: "https://www.swiggy.com/city/chaibasa",
              },
              {
                text: "Haveri",
                link: "https://www.swiggy.com/city/haveri",
              },
              {
                text: "Karaikal",
                link: "https://www.swiggy.com/city/karaikal",
              },
              {
                text: "Jjajjar",
                link: "https://www.swiggy.com/city/jjajjar",
              },
              {
                text: "Kokrajhar",
                link: "https://www.swiggy.com/city/kokrajhar",
              },
              {
                text: "Rangia",
                link: "https://www.swiggy.com/city/rangia",
              },
              {
                text: "Hamirpur",
                link: "https://www.swiggy.com/city/hamirpur",
              },
              {
                text: "Una",
                link: "https://www.swiggy.com/city/una",
              },
              {
                text: "Sulthan Bathery",
                link: "https://www.swiggy.com/city/sulthan-bathery",
              },
              {
                text: "Rayagada",
                link: "https://www.swiggy.com/city/rayagada",
              },
              {
                text: "Paradeep",
                link: "https://www.swiggy.com/city/paradeep",
              },
              {
                text: "Mandapeta",
                link: "https://www.swiggy.com/city/mandapeta",
              },
              {
                text: "Jamui",
                link: "https://www.swiggy.com/city/jamui",
              },
              {
                text: "Pilkhuwa",
                link: "https://www.swiggy.com/city/pilkhuwa",
              },
              {
                text: "Parvathipuram",
                link: "https://www.swiggy.com/city/parvathipuram",
              },
              {
                text: "Ambajogai",
                link: "https://www.swiggy.com/city/ambajogai",
              },
              {
                text: "Araria",
                link: "https://www.swiggy.com/city/araria",
              },
              {
                text: "North Lakhimpur",
                link: "https://www.swiggy.com/city/north-lakhimpur",
              },
              {
                text: "Rajampet",
                link: "https://www.swiggy.com/city/rajampet",
              },
              {
                text: "Udumalaipettai",
                link: "https://www.swiggy.com/city/udumalaipettai",
              },
              {
                text: "Tirupattur",
                link: "https://www.swiggy.com/city/tirupattur",
              },
              {
                text: "Hojai",
                link: "https://www.swiggy.com/city/hojai",
              },
              {
                text: "Khagaria",
                link: "https://www.swiggy.com/city/khagaria",
              },
              {
                text: "Dasuya",
                link: "https://www.swiggy.com/city/dasuya",
              },
              {
                text: "Gudur",
                link: "https://www.swiggy.com/city/gudur",
              },
              {
                text: "Sullurpeta",
                link: "https://www.swiggy.com/city/sullurpeta",
              },
              {
                text: "Piler",
                link: "https://www.swiggy.com/city/piler",
              },
              {
                text: "SankaranKoil",
                link: "https://www.swiggy.com/city/sankarankoil",
              },
              {
                text: "Nabha",
                link: "https://www.swiggy.com/city/nabha",
              },
              {
                text: "LPU - Phagwara",
                link: "https://www.swiggy.com/city/lpu-phagwara",
              },
              {
                text: "Jangipur",
                link: "https://www.swiggy.com/city/jangipur",
              },
              {
                text: "Roha",
                link: "https://www.swiggy.com/city/roha",
              },
            ],
            id: "footer_content",
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.MetaContext",
            citySlug: "faridabad",
            lat: "28.4089123",
            lng: "77.3177894",
            userAgent:
              "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/123.0.0.0 Safari/537.36",
            gandalfRequest:
              '{"sortAttribute":"relevance","isFiltered":false,"queryId":"seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e","seoParams":{"apiName":"FoodHomePage","brandId":"","seoUrl":"www.swiggy.com","pageType":"FOOD_HOME_PAGE"}}',
            id: "meta_data",
            metaInfo: {
              pageType: "FOOD_HOME_PAGE",
              pageTitle: "Order Food Online from India's Best Food Delivery Service | Swiggy",
              pageMetaDescription:
                "Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.",
              pageKeywords: "Food delivery, Online food order, Online food dleivery",
            },
            screenType: "filteredCollection",
            seoParams: {
              apiName: "FoodHomePage",
              seoUrl: "www.swiggy.com",
              pageType: "FOOD_HOME_PAGE",
            },
          },
        },
      },
    ],
    firstOffsetRequest: true,
    cacheExpiryTime: 240,
    nextFetch: 1,
  },
  tid: "77533f11-5e8d-4b54-a4a7-1c92985210c7",
  sid: "d3bd968b-8262-4755-a5c0-d4ee42f09309",
  deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
  csrfToken: "UwmkelsQ8Duk-9B3iU9InosXfu2k2oHASD-Klhgc",
};

export let MENU_MOCK_DATA = {
  statusCode: 0,
  data: {
    statusMessage: "done successfully",
    cards: [
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            text: "Dark Brown",
            headerStyling: {
              textColor: "text_Highest_Emphasis",
              textVariant: "header_H3_Black",
            },
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            tabs: [
              {
                id: "Order Online",
                title: "Order Online",
              },
            ],
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            info: {
              id: "21986",
              name: "Dark Brown",
              city: "Faridabad",
              slugs: {
                restaurant: "dark-brown-sector-15-sector-15_archive",
                city: "faridabad",
              },
              uniqueId: "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
              locality: "Shopping Centre Market",
              areaName: "Sector 15",
              costForTwo: "25000",
              costForTwoMessage: "₹250 for two",
              cuisines: ["Italian-American", "Continental"],
              avgRating: 4.2,
              feeDetails: {
                restaurantId: "21986",
                fees: [
                  {
                    name: "TYPE_DISTANCE",
                    fee: 4200,
                  },
                  {
                    name: "TYPE_TIME",
                  },
                ],
                totalFee: 4200,
                title: "Delivery Charge",
                amount: "4200",
                icon: "v1648635511/Delivery_fee_new_cjxumu",
              },
              parentId: "16162",
              avgRatingString: "4.2",
              totalRatingsString: "10K+ ratings",
              sla: {
                restaurantId: "21986",
                deliveryTime: 26,
                minDeliveryTime: 25,
                maxDeliveryTime: 30,
                lastMileTravel: 1.8,
                serviceability: "SERVICEABLE",
                stressFactor: 1,
                rainMode: "RAIN_MODE_NONE",
                longDistance: "LONG_DISTANCE_NOT_LONG_DISTANCE",
                zoneId: 749,
                slaString: "25-30 MINS",
                lastMileTravelString: "1.7 km",
                iconType: "ICON_TYPE_EMPTY",
              },
              availability: {
                nextCloseTime: "2024-04-05 00:00:00",
                visibility: true,
                opened: true,
                restaurantClosedMeta: {},
              },
              aggregatedDiscountInfo: {
                header: "FLAT100 off",
                shortDescriptionList: [
                  {
                    meta: "FLAT100 off  | Use LNBINGE",
                    discountType: "Flat",
                    operationType: "RESTAURANT",
                  },
                  {
                    discountType: "Percentage",
                    operationType: "RESTAURANT",
                  },
                ],
                descriptionList: [
                  {
                    meta: "FLAT100 off  | Use LNBINGE",
                    discountType: "Flat",
                    operationType: "RESTAURANT",
                  },
                  {
                    discountType: "Percentage",
                    operationType: "RESTAURANT",
                  },
                ],
                visible: true,
              },
              badges: {},
              slugString: "dark-brown-sector-15-sector-15_archive",
              multiOutlet: true,
              isOpen: true,
              labels: [
                {
                  title: "Timings",
                  message: "null",
                },
                {
                  title: "Address",
                  message: "Shop - 144, booth no.163, Huda Market, sec15, faridabad",
                },
                {
                  title: "Cuisines",
                  message: "Italian-American,Continental",
                },
              ],
              totalRatings: 10000,
              aggregatedDiscountInfoV2: {
                header: "FLAT100 off",
                shortDescriptionList: [
                  {
                    meta: "FLAT100 off  | Use LNBINGE",
                    discountType: "Flat",
                    operationType: "RESTAURANT",
                  },
                  {
                    discountType: "Percentage",
                    operationType: "RESTAURANT",
                  },
                ],
                descriptionList: [
                  {
                    meta: "FLAT100 off  | Use LNBINGE",
                    discountType: "Flat",
                    operationType: "RESTAURANT",
                  },
                  {
                    discountType: "Percentage",
                    operationType: "RESTAURANT",
                  },
                ],
                couponDetailsCta: "View coupon details",
              },
              type: "F",
              nudgeBanners: [
                {
                  minValue: 125,
                  maxValue: 179,
                  priority: 2,
                  couponCode: "SAVINGS4ME",
                  discountInfo: {
                    discountType: "Percentage",
                    value: 20,
                  },
                  logoCtx: {},
                },
                {
                  minValue: 279,
                  maxValue: 399,
                  priority: 3,
                  couponCode: "MDM150",
                  discountInfo: {
                    discountType: "Flat",
                    value: 150,
                  },
                  lockedMessage: "Add items worth ₹<amount> to save ₹150 | Code MDM150",
                  unlockedMessage: "MDM150 Coupon Unlocked! Use it to save ₹150",
                  logoCtx: {},
                },
              ],
              headerBanner: {
                url: "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/21986",
              },
              expectationNotifiers: [
                {
                  icon: {
                    imageId: "v1648635511/Delivery_fee_new_cjxumu",
                  },
                  popup: {
                    cta: {},
                  },
                  type: "DISTANCE_FEE_NON_FOOD_LM",
                  enrichedText: "<b>1.8 km</b> | <del>₹42</del> Free Delivery on your order",
                  halfCardPopup: {
                    halfCardPopupHeader: {},
                  },
                },
              ],
              ratingSlab: "RATING_SLAB_5",
              orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {},
              },
              cartOrderabilityNudgeBanner: {
                parameters: {},
                presentation: {},
              },
              latLong: "28.395346190109397,77.32197622453688",
              backgroundImageOverlayInfo: {},
            },
            analytics: {},
          },
          relevance: {
            type: "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            sectionId: "POP_UP_CROUTON_MENU",
          },
        },
      },
      {
        card: {
          card: {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            layout: {
              rows: 1,
              columns: 5,
              horizontalScrollEnabled: true,
              itemSpacing: 12,
              lineSpacing: 10,
              widgetPadding: {},
              containerStyle: {
                containerPadding: {
                  left: 10,
                  right: 10,
                  bottom: 16,
                },
              },
              scrollBar: {},
            },
            id: "offerCollectionWidget_UX4",
            gridElements: {
              infoWithStyle: {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                offers: [
                  {
                    info: {
                      header: "FLAT ₹100 OFF",
                      offerTag: "LATE NIGHT",
                      offerTagColor: "#E46D47",
                      offerIds: ["21b510e6-d1e5-49f2-9a0c-7c8df2376113"],
                      expiryTime: "1970-01-01T00:00:00Z",
                      couponCode: "USE LNBINGE",
                      description: "ABOVE ₹249",
                      offerType: "offers",
                      restId: "21986",
                      offerLogo: "offers/generic",
                      descriptionTextColor: "#7302060C",
                    },
                    cta: {
                      type: "OFFER_HALF_CARD",
                    },
                  },
                  {
                    info: {
                      header: "20% OFF UPTO ₹45",
                      offerTagColor: "#E46D47",
                      offerIds: ["bec108ac-7985-4c49-a231-2f489c7bfa89"],
                      expiryTime: "1970-01-01T00:00:00Z",
                      couponCode: "USE SAVINGS4ME",
                      description: "ABOVE ₹179",
                      offerType: "offers",
                      restId: "21986",
                      offerLogo: "offers/generic",
                      descriptionTextColor: "#7302060C",
                    },
                    cta: {
                      type: "OFFER_HALF_CARD",
                    },
                  },
                  {
                    info: {
                      header: "FLAT ₹150 OFF",
                      offerTag: "FLAT DEAL",
                      offerTagColor: "#E46D47",
                      offerIds: ["2b0a5844-c1d1-48db-a745-1fc78a37b6e4"],
                      expiryTime: "1970-01-01T00:00:00Z",
                      couponCode: "USE MDM150",
                      description: "ABOVE ₹399",
                      offerType: "offers",
                      restId: "21986",
                      offerLogo: "offers/generic",
                      descriptionTextColor: "#7302060C",
                    },
                    cta: {
                      type: "OFFER_HALF_CARD",
                    },
                  },
                  {
                    info: {
                      header: "15% OFF UPTO ₹150",
                      offerTagColor: "#E46D47",
                      logoBottom:
                        "MARKETING_BANNERS/IMAGES/OFFERS/2024/3/31/5e5be43d-5232-4afc-843d-d828639ae129_HSBC.png",
                      offerIds: ["7b012c7c-a7e1-49d7-a84a-2ba6e1224780"],
                      expiryTime: "1970-01-01T00:00:00Z",
                      couponCode: "USE HSBCMANIA",
                      description: "ABOVE ₹499",
                      offerType: "offers",
                      restId: "21986",
                      offerLogo:
                        "MARKETING_BANNERS/IMAGES/OFFERS/2024/3/31/5e5be43d-5232-4afc-843d-d828639ae129_HSBC.png",
                      descriptionTextColor: "#7302060C",
                    },
                    cta: {
                      type: "OFFER_HALF_CARD",
                    },
                  },
                  {
                    info: {
                      header: "FLAT ₹125 OFF",
                      offerTag: "FLAT DEAL",
                      offerTagColor: "#E46D47",
                      offerIds: ["84cd7bc1-65e3-4f0a-9280-844a68d9d474"],
                      expiryTime: "1970-01-01T00:00:00Z",
                      couponCode: "USE FLAT125",
                      description: "ABOVE ₹249",
                      offerType: "offers",
                      restId: "21986",
                      offerLogo: "offers/generic",
                      descriptionTextColor: "#7302060C",
                    },
                    cta: {
                      type: "OFFER_HALF_CARD",
                    },
                  },
                ],
                habitMilestoneInfo: {
                  callout: {},
                },
                loyaltyDiscoverPresentationInfo: {
                  logoCtx: {},
                },
              },
            },
          },
        },
      },
      {
        groupedCard: {
          cardGroupMap: {
            REGULAR: {
              cards: [
                {
                  card: {
                    card: {
                      "@type":
                        "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      badges: {},
                      vegOnlyDetails: {
                        imageId: "AutoVegOnly_qkjowj",
                        title: "Showing only vegetarian options.",
                        description: "Tap on the VEG ONLY button to turn off the setting",
                      },
                      topRatedFilter: {},
                      kidsCategoryFilter: {
                        attributes: {
                          displayText: "Kids Favourites",
                          tooltip: {
                            enabled: true,
                            displayText:
                              "Kids Favourites Filter applied. Remove this filter to see the full Menu.",
                          },
                        },
                      },
                      vegFilter: {
                        attributes: {
                          displayText: "VEG",
                        },
                      },
                      nonvegFilter: {
                        attributes: {
                          displayText: "NONVEG",
                        },
                      },
                    },
                    relevance: {
                      type: "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      sectionId: "MENU_FILTER_TOGGLE",
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      title: "Top Picks",
                      carousel: [
                        {
                          type: "TopCarousel",
                          subtype: "image",
                          bannerId: "1814238",
                          creativeId: "TopPicks/12563599B.png",
                          title: "Grilled Veg Paneer Sandwich",
                          description: " ",
                          fontColor: "#FFFFFF",
                          dish: {
                            info: {
                              id: "12563599",
                              name: "Grilled Veg Paneer Sandwich",
                              category: "Sandwich",
                              description: "Grilled Paneer + Tomato + Onion + Tandoori Mayonnaise",
                              imageId: "str6dgmj5eya9agsgnvb",
                              inStock: 1,
                              isVeg: 1,
                              price: 24900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              itemBadge: {},
                              badgesV2: {},
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          type: "TopCarousel",
                          subtype: "image",
                          bannerId: "1814237",
                          creativeId: "TopPicks/4077858B.png",
                          title: "Davidoff Coffee",
                          description: " ",
                          fontColor: "#FFFFFF",
                          dish: {
                            info: {
                              id: "4077858",
                              name: "Davidoff Coffee",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                              inStock: 1,
                              isVeg: 1,
                              price: 18000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              itemBadge: {},
                              badgesV2: {},
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          type: "TopCarousel",
                          subtype: "image",
                          bannerId: "1814239",
                          creativeId: "TopPicks/96805980B.png",
                          title: "Hot Brownie With Hot Chocolate",
                          description: " ",
                          fontColor: "#FFFFFF",
                          dish: {
                            info: {
                              id: "96805980",
                              name: "Hot Brownie With Hot Chocolate",
                              category: "Desserts",
                              description: "Serves 1",
                              imageId: "9079c5941e9c9ec99c9e1b3aed4c53ea",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              itemBadge: {},
                              badgesV2: {},
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          type: "TopCarousel",
                          subtype: "image",
                          bannerId: "1814235",
                          creativeId: "TopPicks/100949073B.png",
                          title: "Mix Sauce Pasta (Penne)",
                          description: " ",
                          fontColor: "#FFFFFF",
                          dish: {
                            info: {
                              id: "100949073",
                              name: "Mix Sauce Pasta (Penne)",
                              category: "Pastas",
                              description: "Serves 1",
                              imageId: "59a99f7eee5a4656b7b6d82490857463",
                              inStock: 1,
                              isVeg: 1,
                              price: 29000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              itemBadge: {},
                              badgesV2: {},
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          type: "TopCarousel",
                          subtype: "image",
                          bannerId: "1814236",
                          creativeId: "TopPicks/4077862B.png",
                          title: "Cold Coffee",
                          description: " ",
                          fontColor: "#FFFFFF",
                          dish: {
                            info: {
                              id: "4077862",
                              name: "Cold Coffee",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "thvril6hi8fwrftuuayg",
                              inStock: 1,
                              isVeg: 1,
                              price: 14000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              itemBadge: {},
                              badgesV2: {},
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Recommended",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000919",
                              name: "Tomato Basil Soup",
                              category: "Soups",
                              imageId: "7491a231591f7c8ef6299a3846e59f22",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "44 ratings",
                                  ratingCountV2: "44",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000922",
                              name: "Minestrone Soup",
                              category: "Soups",
                              imageId: "5d42ac81e15221854bcff2f2728b0756",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.7",
                                  ratingCount: "19 ratings",
                                  ratingCountV2: "19",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000924",
                              name: "Broccoli Mushroom Soup",
                              category: "Soups",
                              imageId: "74d5792e3f3cbdbc6da69228f53e394a",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "50 ratings",
                                  ratingCountV2: "50",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806071",
                              name: "Veg Manchow Soup",
                              category: "Soups",
                              imageId: "05307aa34e454058947fda4617a93185",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.7",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806072",
                              name: "Veg Hot & Sour Soup",
                              category: "Soups",
                              imageId: "cvw4mo9midegdkky6v1a",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.9",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806080",
                              name: "Veg Spring Roll",
                              category: "Appetizers",
                              description:
                                "Serves 1 | Deep-fried, stuffed rolls packed with seasoned assorted veggies.",
                              imageId: "uixdrme6e8v6udsill2b",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "24 ratings",
                                  ratingCountV2: "24",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "73170622",
                              name: "Crispy Corn",
                              category: "Appetizers",
                              imageId: "2c482f34b257753b843846b77bda83ff",
                              inStock: 1,
                              isVeg: 1,
                              price: 31000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "21 ratings",
                                  ratingCountV2: "21",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000929",
                              name: "Mozzarella Cheese Stick",
                              category: "Appetizers",
                              description: "Serves 1",
                              imageId: "a5553c3cccf840486b4651bb43d6193c",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "34 ratings",
                                  ratingCountV2: "34",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000931",
                              name: "Cottage Cheese Finger",
                              category: "Appetizers",
                              description: "Serves 1",
                              imageId: "8247914a73d640b489ea18fd9da204c2",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "14 ratings",
                                  ratingCountV2: "14",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000933",
                              name: "Mac An Cheese Roll",
                              category: "Appetizers",
                              imageId: "c3c9f192e21cda38a103b730eeabb617",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.2",
                                  ratingCount: "11 ratings",
                                  ratingCountV2: "11",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000938",
                              name: "Veg Quesadilla",
                              category: "Appetizers",
                              imageId: "y5wdcgfyq3zvieb9tq7k",
                              inStock: 1,
                              isVeg: 1,
                              price: 35000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "40 ratings",
                                  ratingCountV2: "40",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "65373200",
                              name: "Cheesy Chicken Garlic Bread",
                              category: "Appetizers",
                              imageId: "6ea2115c9beb322d26f55e9434013258",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388291",
                              name: "Fish Finger",
                              category: "Appetizers",
                              imageId: "fr5h5gd3136chq0qmb2k",
                              inStock: 1,
                              price: 60000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.6",
                                  ratingCount: "22 ratings",
                                  ratingCountV2: "22",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388364",
                              name: "Chicken Quesadilla",
                              category: "Appetizers",
                              imageId: "3de7c0cd4d3a33f610dfb59cc0330fba",
                              inStock: 1,
                              price: 60000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "13 ratings",
                                  ratingCountV2: "13",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388366",
                              name: "Grilled Chicken Tacos",
                              category: "Appetizers",
                              imageId: "3459612908fefb04a7b6a474f455117a",
                              inStock: 1,
                              price: 54900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388368",
                              name: "Chicken Corn Paper Tacos",
                              category: "Appetizers",
                              imageId: "c10090e963cebe1ca4fc0030ba692108",
                              inStock: 1,
                              price: 54900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388371",
                              name: "Signature Chicken Nachos",
                              category: "Appetizers",
                              imageId: "132354fc2cfdd5bcfcaad7ccd29c6731",
                              inStock: 1,
                              price: 54900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806100",
                              name: "Chicken & Cheese Roll",
                              category: "Appetizers",
                              description: "Serves 1",
                              imageId: "70281f65f7a8ac41a197cd571fa242d0",
                              inStock: 1,
                              price: 43000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806103",
                              name: "Chicken Special Roll",
                              category: "Appetizers",
                              imageId: "f818471f535553a4351c1490b80147a4",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "19021818",
                              name: "Veg Noodles",
                              category: "Chinese",
                              description:
                                "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                              imageId: "d2dkjmf5h7vil9zzjnoo",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              showImage: true,
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "84 ratings",
                                  ratingCountV2: "84",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                      type: "CATEGORY_TYPE_RECOMMENDED",
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      title: "Soups",
                      categories: [
                        {
                          title: "Soups",
                          itemCards: [
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "119531729",
                                  name: "Veg Tom Yum Soup",
                                  category: "Soups",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 19900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "131044284",
                                  name: "Sweet Corn Soup",
                                  category: "Soups",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 17000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "25000919",
                                  name: "Tomato Basil Soup",
                                  category: "Soups",
                                  imageId: "7491a231591f7c8ef6299a3846e59f22",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 15000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.1",
                                      ratingCount: "44 ratings",
                                      ratingCountV2: "44",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "25000922",
                                  name: "Minestrone Soup",
                                  category: "Soups",
                                  imageId: "5d42ac81e15221854bcff2f2728b0756",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 15000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.7",
                                      ratingCount: "19 ratings",
                                      ratingCountV2: "19",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "25000924",
                                  name: "Broccoli Mushroom Soup",
                                  category: "Soups",
                                  imageId: "74d5792e3f3cbdbc6da69228f53e394a",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 17000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.1",
                                      ratingCount: "50 ratings",
                                      ratingCountV2: "50",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806071",
                                  name: "Veg Manchow Soup",
                                  category: "Soups",
                                  imageId: "05307aa34e454058947fda4617a93185",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 17000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "1.7",
                                      ratingCount: "6 ratings",
                                      ratingCountV2: "6",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806072",
                                  name: "Veg Hot & Sour Soup",
                                  category: "Soups",
                                  imageId: "cvw4mo9midegdkky6v1a",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 17000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "2.9",
                                      ratingCount: "4 ratings",
                                      ratingCountV2: "4",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                          ],
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Appetizers",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "131044959",
                              name: "Chicken Spring Roll",
                              category: "Appetizers",
                              inStock: 1,
                              price: 32100,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000927",
                              name: "Corn & Cheese Roll",
                              category: "Appetizers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "14 ratings",
                                  ratingCountV2: "14",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806080",
                              name: "Veg Spring Roll",
                              category: "Appetizers",
                              description:
                                "Serves 1 | Deep-fried, stuffed rolls packed with seasoned assorted veggies.",
                              imageId: "uixdrme6e8v6udsill2b",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "24 ratings",
                                  ratingCountV2: "24",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "73170622",
                              name: "Crispy Corn",
                              category: "Appetizers",
                              imageId: "2c482f34b257753b843846b77bda83ff",
                              inStock: 1,
                              isVeg: 1,
                              price: 31000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "21 ratings",
                                  ratingCountV2: "21",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "67996521",
                              name: "Paneer Kulcha",
                              category: "Appetizers",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000929",
                              name: "Mozzarella Cheese Stick",
                              category: "Appetizers",
                              description: "Serves 1",
                              imageId: "a5553c3cccf840486b4651bb43d6193c",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "34 ratings",
                                  ratingCountV2: "34",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000931",
                              name: "Cottage Cheese Finger",
                              category: "Appetizers",
                              description: "Serves 1",
                              imageId: "8247914a73d640b489ea18fd9da204c2",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "14 ratings",
                                  ratingCountV2: "14",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000933",
                              name: "Mac An Cheese Roll",
                              category: "Appetizers",
                              imageId: "c3c9f192e21cda38a103b730eeabb617",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.2",
                                  ratingCount: "11 ratings",
                                  ratingCountV2: "11",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000938",
                              name: "Veg Quesadilla",
                              category: "Appetizers",
                              imageId: "y5wdcgfyq3zvieb9tq7k",
                              inStock: 1,
                              isVeg: 1,
                              price: 35000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "40 ratings",
                                  ratingCountV2: "40",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "71676683",
                              name: "Chicken Cheese Finger",
                              category: "Appetizers",
                              inStock: 1,
                              price: 48000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "65373200",
                              name: "Cheesy Chicken Garlic Bread",
                              category: "Appetizers",
                              imageId: "6ea2115c9beb322d26f55e9434013258",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "65373205",
                              name: "Chicken Cheese Fries",
                              category: "Appetizers",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "59141394",
                              name: "Dynamite Chicken",
                              category: "Appetizers",
                              description: "Serves 1",
                              imageId: "pfoied7sjl36bcui9gnv",
                              inStock: 1,
                              price: 56000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388285",
                              name: "Caucasian Spice Fish & Chips",
                              category: "Appetizers",
                              inStock: 1,
                              price: 72000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388291",
                              name: "Fish Finger",
                              category: "Appetizers",
                              imageId: "fr5h5gd3136chq0qmb2k",
                              inStock: 1,
                              price: 60000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.6",
                                  ratingCount: "22 ratings",
                                  ratingCountV2: "22",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388363",
                              name: "Moroccan Chicken",
                              category: "Appetizers",
                              inStock: 1,
                              price: 54900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388364",
                              name: "Chicken Quesadilla",
                              category: "Appetizers",
                              imageId: "3de7c0cd4d3a33f610dfb59cc0330fba",
                              inStock: 1,
                              price: 60000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "13 ratings",
                                  ratingCountV2: "13",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388366",
                              name: "Grilled Chicken Tacos",
                              category: "Appetizers",
                              imageId: "3459612908fefb04a7b6a474f455117a",
                              inStock: 1,
                              price: 54900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388368",
                              name: "Chicken Corn Paper Tacos",
                              category: "Appetizers",
                              imageId: "c10090e963cebe1ca4fc0030ba692108",
                              inStock: 1,
                              price: 54900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388371",
                              name: "Signature Chicken Nachos",
                              category: "Appetizers",
                              imageId: "132354fc2cfdd5bcfcaad7ccd29c6731",
                              inStock: 1,
                              price: 54900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388372",
                              name: "Twist Cone Fish",
                              category: "Appetizers",
                              inStock: 1,
                              price: 72000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806098",
                              name: "Chicken Kulcha ",
                              category: "Appetizers",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806100",
                              name: "Chicken & Cheese Roll",
                              category: "Appetizers",
                              description: "Serves 1",
                              imageId: "70281f65f7a8ac41a197cd571fa242d0",
                              inStock: 1,
                              price: 43000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806103",
                              name: "Chicken Special Roll",
                              category: "Appetizers",
                              imageId: "f818471f535553a4351c1490b80147a4",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      title: "Chinese",
                      categories: [
                        {
                          title: "Chinese",
                          itemCards: [
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "119533395",
                                  name: "Singapori Veg Noodle",
                                  category: "Chinese",
                                  imageId: "343db05cc4b92f3a6163b7d9e1a081db",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 29900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.7",
                                      ratingCount: "18 ratings",
                                      ratingCountV2: "18",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "19021818",
                                  name: "Veg Noodles",
                                  category: "Chinese",
                                  description:
                                    "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                                  imageId: "d2dkjmf5h7vil9zzjnoo",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 24000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.2",
                                      ratingCount: "84 ratings",
                                      ratingCountV2: "84",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "19021823",
                                  name: "Chilli Potato",
                                  category: "Chinese",
                                  description: "Serves 1",
                                  imageId: "lw8unhoxkntfp5ikqbc6",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 26000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.7",
                                      ratingCount: "113 ratings",
                                      ratingCountV2: "113",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "60883673",
                                  name: "Schezwan Noodles",
                                  category: "Chinese",
                                  description: "Serves 1",
                                  imageId: "hu6hvqbmdsyfgr9n05zq",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.6",
                                      ratingCount: "23 ratings",
                                      ratingCountV2: "23",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "19021822",
                                  name: "Chilli Garlic Noodles",
                                  category: "Chinese",
                                  description:
                                    "Serves 1 | A spicy stir fry of assorted veggies and noodles tossed in hot chilli garlic sauce.",
                                  imageId: "fahvbq7m9vzrjyzcpl1i",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 26000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.3",
                                      ratingCount: "188 ratings",
                                      ratingCountV2: "188",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "19021825",
                                  name: "Chilli Paneer Dry",
                                  category: "Chinese",
                                  description:
                                    "Serves 1 | Diced Paneer (Indian Cottage Cheese) tossed in spicy sauce made with soya sauce, chilli sauce and Vinegar.",
                                  imageId: "eydcdhxfvdavqdpovbuo",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 45000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.9",
                                      ratingCount: "64 ratings",
                                      ratingCountV2: "64",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "60883672",
                                  name: "Veg Fried Rice",
                                  category: "Chinese",
                                  description: "Serves 1",
                                  imageId: "5614f60a7659fac365eac10e453d3b06",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 24000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.1",
                                      ratingCount: "7 ratings",
                                      ratingCountV2: "7",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806024",
                                  name: "Honey Chilli Potato",
                                  category: "Chinese",
                                  description:
                                    "Serves 1 | Finger potatoes tossed with sriracha, honey, sesame & spring onions.",
                                  imageId: "44f09c62ba809fb44e3f129de196fba1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.9",
                                      ratingCount: "41 ratings",
                                      ratingCountV2: "41",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806029",
                                  name: "Veg. Manchurian Dry",
                                  category: "Chinese",
                                  description: "Serves 1",
                                  imageId: "d62187bc8fa90a8ff08b4eb59cf84167",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 42000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.9",
                                      ratingCount: "41 ratings",
                                      ratingCountV2: "41",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806031",
                                  name: "Chilli Mushroom Dry ",
                                  category: "Chinese",
                                  description: "Serves 1",
                                  imageId: "f7f8c3947284c8ace4c08fff7d95256c",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 42000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806034",
                                  name: "Veg. Salt N Pepper",
                                  category: "Chinese",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 42000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "19021820",
                                  name: "Hakka Noodles",
                                  category: "Chinese",
                                  description:
                                    "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                                  imageId: "gwlgrufdtbwa6jizzuq3",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 24000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.3",
                                      ratingCount: "104 ratings",
                                      ratingCountV2: "104",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                          ],
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Coffees, Shakes And Crushers",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "131044281",
                              name: "Nutella Brownie Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 27000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "127034563",
                              name: "Biscoff Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "4077865",
                              name: "Strawberry Shake",
                              category: "Coffees, Shakes And Crushers",
                              description:
                                "A refreshing milkshake prepared with strawberry sauce, ice cream and wholesome milk perfect to satisfy your cravings.",
                              imageId: "srrcen0hsajeed0pbsta",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.6",
                                  ratingCount: "267 ratings",
                                  ratingCountV2: "267",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "8271203",
                              name: "Vanilla Coffee",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.9",
                                  ratingCount: "8 ratings",
                                  ratingCountV2: "8",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "4077862",
                              name: "Cold Coffee",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "thvril6hi8fwrftuuayg",
                              inStock: 1,
                              isVeg: 1,
                              price: 14000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "1555 ratings",
                                  ratingCountV2: "1555",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805969",
                              name: "Kitkat Shake",
                              category: "Coffees, Shakes And Crushers",
                              description:
                                "Combination of kitkat and chocolate sauce to make it a perfect thick shake.",
                              imageId: "sx5w4k7sovbg6ueogbxe",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "695 ratings",
                                  ratingCountV2: "695",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "8271204",
                              name: "Irish Coffee",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "224528e353a23792cf44cc67ac22dc4c",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "23 ratings",
                                  ratingCountV2: "23",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805982",
                              name: "Nutella Shake",
                              category: "Coffees, Shakes And Crushers",
                              description:
                                "A perfect blend of milk, nutella, and soft vanilla ice cream. A classic for summers. Serves 1-2",
                              imageId: "pfl2dfavnuwxxs3rifkg",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "14 ratings",
                                  ratingCountV2: "14",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "19021805",
                              name: "Tiramisu Coffee",
                              category: "Coffees, Shakes And Crushers",
                              description: "Tiramisu Frappe Blended with Chocolate Choco Chips",
                              imageId: "pwvnpo8lxbvdgpllb09g",
                              inStock: 1,
                              isVeg: 1,
                              price: 18000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "20 ratings",
                                  ratingCountV2: "20",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "65373206",
                              name: "Chocolate Coffee",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                              inStock: 1,
                              isVeg: 1,
                              price: 16000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "8 ratings",
                                  ratingCountV2: "8",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "65373208",
                              name: "Ferrero Rocher Coffee",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "20 ratings",
                                  ratingCountV2: "20",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "4077848",
                              name: "Cafe Choco Cookie",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.2",
                                  ratingCount: "50 ratings",
                                  ratingCountV2: "50",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "5628463",
                              name: "Caramel Frappe",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "26 ratings",
                                  ratingCountV2: "26",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "5628464",
                              name: "Hazelnut Frappe",
                              category: "Coffees, Shakes And Crushers",
                              description: "Serves 1",
                              imageId: "cd0763f82c02ecf62408f91aa237ead9",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "60 ratings",
                                  ratingCountV2: "60",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "8271213",
                              name: "Mocha Frappe",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "53a1390972bbd7c63cdf1aaadff21385",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "91 ratings",
                                  ratingCountV2: "91",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "4077858",
                              name: "Davidoff Coffee",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                              inStock: 1,
                              isVeg: 1,
                              price: 18000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "307 ratings",
                                  ratingCountV2: "307",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "85675793",
                              name: "Blackberry Mango",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 23000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "8271214",
                              name: "Belgian Choco Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "4978a35f9bf554b45da8fb795a722ade",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.6",
                                  ratingCount: "226 ratings",
                                  ratingCountV2: "226",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "5628465",
                              name: "Ferrero Rocher Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "86729088fd68e7bbd28d54be175485b5",
                              inStock: 1,
                              isVeg: 1,
                              price: 34900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "43 ratings",
                                  ratingCountV2: "43",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "19021855",
                              name: "Peanut Butter",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "311a9f9ef4c5fa16d6495e66b4c5682d",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805929",
                              name: "Almond Coffee",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 18000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805934",
                              name: "Tiramisu Chip ",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805937",
                              name: "Dark Brownie Crusher",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "cd0f52cca7ee7dc16f734389e6a9d3ea",
                              inStock: 1,
                              isVeg: 1,
                              price: 18000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "109 ratings",
                                  ratingCountV2: "109",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805947",
                              name: "Oreo Chocolate",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "4b6dddf2fc5c3d8c4b504d6d1cc9ee69",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "98 ratings",
                                  ratingCountV2: "98",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805949",
                              name: "Oreo Mint",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "4b6dddf2fc5c3d8c4b504d6d1cc9ee69",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805951",
                              name: "Oreo Strawberry",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "9 ratings",
                                  ratingCountV2: "9",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805955",
                              name: "Berry Oreo Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805956",
                              name: "Oreo Mango",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "cuoech9pjhqtjmftyiyo",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805958",
                              name: "Oreo Walnut Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805960",
                              name: "Oreo Black Currant",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.1",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805962",
                              name: "Oreo Vanilla",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.7",
                                  ratingCount: "8 ratings",
                                  ratingCountV2: "8",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805964",
                              name: "Choco Banana Oreo Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "c58b8d7fd7a29e4f4f3c8b86d69d684e",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805966",
                              name: "Red Velvet Oreo",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805971",
                              name: "Blackcurrant Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "657332a561f2f18fdc3e4f800b88c7fe",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.6",
                                  ratingCount: "18 ratings",
                                  ratingCountV2: "18",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805972",
                              name: "Heartbeat Crusher",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 16000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805974",
                              name: "Chocolate Choco chip",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "25 ratings",
                                  ratingCountV2: "25",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805976",
                              name: "Vanilla Choco chip",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805978",
                              name: "Banana Walnut Choco chip",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805979",
                              name: "Mint Chocolate Chip Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 18000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805983",
                              name: "Nutella Peanut",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 29000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805984",
                              name: "Snickers Smoothie",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805985",
                              name: "Peanut Banana",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "24bb523b11f330fffaa0c69f6d03cb2f",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805989",
                              name: "Kesar Almond Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805993",
                              name: "Protein Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.9",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805994",
                              name: "Blueberry Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.7",
                                  ratingCount: "11 ratings",
                                  ratingCountV2: "11",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805997",
                              name: "Mixed Berry Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805998",
                              name: "Paan Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806001",
                              name: "Saffron Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806003",
                              name: "Chocolate Banana Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806006",
                              name: "Vanilla Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "6f24f0ae20baedb3d3bb2843492a6f4a",
                              inStock: 1,
                              isVeg: 1,
                              price: 14000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806008",
                              name: "Chocolate Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "rlvntu5uxy778d9ujhqd",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "33 ratings",
                                  ratingCountV2: "33",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806011",
                              name: "Pineapple Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "cf038b2e80057ee7f32ff3883cf6c83d",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806013",
                              name: "Alphonso Mango",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "f10d92d6b69c6c7db113ec8b17ef2997",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806017",
                              name: "Strawberry Chocolate Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.2",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806018",
                              name: "Strawberry Walnut Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806021",
                              name: "Butterscotch Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "86bc8d2e39bcb3bd291e24d0b26a8a1c",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.7",
                                  ratingCount: "92 ratings",
                                  ratingCountV2: "92",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806023",
                              name: "Caramel Lovers",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "db499d83469b01ef81c5c9b568cddcaf",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806026",
                              name: "Caramel Popcorn Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806028",
                              name: "Pina Alphonso Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "95a1c40dd30521c0e4a167f966392eb9",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806030",
                              name: "Marshmallow Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806032",
                              name: "Love Rose Vanilla",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 20000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806035",
                              name: "Red Velvet Cake Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806037",
                              name: "Vanilla Cake Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "2a869e2f73b9adef412e600cdbd0626f",
                              inStock: 1,
                              isVeg: 1,
                              price: 29000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806039",
                              name: "Chocolate Cake Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                              inStock: 1,
                              isVeg: 1,
                              price: 29000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806041",
                              name: "Monkey Banana Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "083293181b88b7ba910c873ebe8dea78",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806044",
                              name: "Bubble-gum Marshmallow",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806046",
                              name: "Bubble-gum Shake",
                              category: "Coffees, Shakes And Crushers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "10 ratings",
                                  ratingCountV2: "10",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806048",
                              name: "Fruit & Nut Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806050",
                              name: "Banoffee Pie Cake Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806052",
                              name: "Tiramisu Cake Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806054",
                              name: "Nutella Cheese Cake Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806056",
                              name: "Blueberry Cheesecake Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806058",
                              name: "Nutella Caramel Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806062",
                              name: "Kiwi Strawberry Smoothie",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "7611804852b854642f932faf541f27c8",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806064",
                              name: "Strawberry Banana Smoothie",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "bc231ce0b57f77eecd1091fbaeccb0c1",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806066",
                              name: "Chocolate Paan Shake",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "0ff51573d1d68ad15c113280f954093f",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806070",
                              name: "Five Star",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "103707100",
                              name: "Chocolate Hazelnut Shake",
                              category: "Coffees, Shakes And Crushers",
                              description:
                                "Richness of chocolate blended with hazelnut touch makes a deadly combination for shake lovers",
                              imageId: "a09bace04d68657d996e028f93284c3f",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "11 ratings",
                                  ratingCountV2: "11",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805946",
                              name: "Choco Brownie Crusher",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "140 ratings",
                                  ratingCountV2: "140",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805952",
                              name: "Nutella Oreo",
                              category: "Coffees, Shakes And Crushers",
                              imageId: "ad8aaa3ea9674eeee5e4a5775c56cfa2",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "40 ratings",
                                  ratingCountV2: "40",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "112579342",
                              name: "Tutti Fruitti Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 18000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "112579343",
                              name: "Rose Paan Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805967",
                              name: "Red Velvet Shake",
                              category: "Coffees, Shakes And Crushers",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Salads",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "131044961",
                              name: "Chicken Tikka Salad",
                              category: "Salads",
                              inStock: 1,
                              price: 45000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563608",
                              name: "Veg Caesar Salad",
                              category: "Salads",
                              description:
                                "Iceberg, lettuce green, olive, cherry tomato, broccoli and parmesan cheese and creamy dressing.",
                              imageId: "43eb7ec82b0b334ac76335309d9adcf6",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.0",
                                  ratingCount: "70 ratings",
                                  ratingCountV2: "70",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563611",
                              name: "Grilled Veg Salad",
                              category: "Salads",
                              description:
                                "Iceberg, broccoli, beans, zucchini, carrot, olives, onion, tomato [hot salad with olive oil].",
                              imageId: "c6b86b6430624f3b4eed461cb212a502",
                              inStock: 1,
                              isVeg: 1,
                              price: 31000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "143 ratings",
                                  ratingCountV2: "143",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563609",
                              name: "Barbeque Salad",
                              category: "Salads",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "34 ratings",
                                  ratingCountV2: "34",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806074",
                              name: "Broccoli Mushroom Salad",
                              category: "Salads",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "59 ratings",
                                  ratingCountV2: "59",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000926",
                              name: "Cottage Cheese Pineapple Salad",
                              category: "Salads",
                              imageId: "2713c5fd49af1b7088eef988bc21106f",
                              inStock: 1,
                              isVeg: 1,
                              price: 31000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "20 ratings",
                                  ratingCountV2: "20",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "71676682",
                              name: "Smoke Chicken Salad",
                              category: "Salads",
                              inStock: 1,
                              price: 44000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "58162988",
                              name: "Brisket Chicken Creamy Salad",
                              category: "Salads",
                              inStock: 1,
                              price: 39000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388245",
                              name: "Chicken Pineapple Salad",
                              category: "Salads",
                              inStock: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "14 ratings",
                                  ratingCountV2: "14",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388247",
                              name: "Grilled Chicken Salad",
                              category: "Salads",
                              imageId: "b2233572d9e9a64f7e40e1ed2116e9da",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "73 ratings",
                                  ratingCountV2: "73",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806086",
                              name: "Chicken Caesar Salad ",
                              category: "Salads",
                              imageId: "42dfc1326334f98e56417eeaac98d364",
                              inStock: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "33 ratings",
                                  ratingCountV2: "33",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806090",
                              name: "Crispy Fish Salad",
                              category: "Salads",
                              inStock: 1,
                              price: 48000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "119532321",
                              name: "Aloo Tikki Salad",
                              category: "Salads",
                              inStock: 1,
                              isVeg: 1,
                              price: 27000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "119532322",
                              name: "Paneer Tikka Salad",
                              category: "Salads",
                              inStock: 1,
                              isVeg: 1,
                              price: 31000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Wraps",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "119533397",
                              name: "Chilli Mushroom Wrap",
                              category: "Wraps",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563592",
                              name: "Paneer Wraps",
                              category: "Wraps",
                              description:
                                "Serves 1 | Paneer, bell pepper, capsicum, onion, cabbage, garlic sauce and spicy oregano.",
                              imageId: "24047a9b9013325dc9256f7e29017925",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "103 ratings",
                                  ratingCountV2: "103",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563597",
                              name: "Spicy Paneer Tikka Wraps",
                              category: "Wraps",
                              description:
                                "Medium Spicy | Serves 1 | Juicy grilled paneer tikka stuffed and rolled into a scrumptious wrap.",
                              imageId: "htpsddiwuuqybtsp4hyx",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                spiceLevel: "MEDIUMSPICY",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "366 ratings",
                                  ratingCountV2: "366",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563594",
                              name: "Soya Wraps",
                              category: "Wraps",
                              description:
                                "Serves 1 | Bell pepper, capsicum, onion, cabbage, Nutella chunks, oregano, chilli flakes and sauce.",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.5",
                                  ratingCount: "71 ratings",
                                  ratingCountV2: "71",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563598",
                              name: "Corny Wraps",
                              category: "Wraps",
                              description:
                                "Serves 1 | Bell pepper, capsicum, onion, cabbage, sweet corn, oregano, chilli flakes and sauce.",
                              imageId: "53c1b023e1a0b88d6ae10027bd2be5e7",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "21 ratings",
                                  ratingCountV2: "21",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60859012",
                              name: "Egg & Chicken Wrap",
                              category: "Wraps",
                              description: "Serves 1",
                              imageId: "85a0321ca6e2da91d8156dcb80d73fba",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60859011",
                              name: "Crispy Chicken Wrap",
                              category: "Wraps",
                              description: "Serves 1",
                              imageId: "wm2pxqoge4u4dlqasnzl",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.6",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388417",
                              name: "Chilli Chicken Wrap",
                              category: "Wraps",
                              description: "Serves 1",
                              imageId: "253c0d587fdb5db9d2309239e4f928b6",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.2",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388421",
                              name: "Pesto Chicken Wrap",
                              category: "Wraps",
                              description: "Serves 1",
                              imageId: "7565ad519b92deeed37a5aa1a37ae783",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806116",
                              name: "Grilled Veg. Wraps",
                              category: "Wraps",
                              description: "Serves 1",
                              imageId: "b58163bc53960b84a3d785c88d005ec6",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.6",
                                  ratingCount: "47 ratings",
                                  ratingCountV2: "47",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806166",
                              name: "Chicken Shawarma Wrap ",
                              category: "Wraps",
                              description: "Serves 1",
                              imageId: "z9vqfpotga887cb6okjc",
                              inStock: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "29 ratings",
                                  ratingCountV2: "29",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388419",
                              name: "Grilled Chicken Wrap",
                              category: "Wraps",
                              description: "Serves 1",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.9",
                                  ratingCount: "9 ratings",
                                  ratingCountV2: "9",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Hot Beverages",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "62668406",
                              name: "Hot Chocolate Drink",
                              category: "Hot Beverages",
                              imageId: "5f64a8a54ba3fb81172807d6458ef955",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "25 ratings",
                                  ratingCountV2: "25",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806079",
                              name: "Molten Hot Chocolate Drink",
                              category: "Hot Beverages",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Sandwich",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "131044299",
                              name: "Mushroom Capsicum Sandwich",
                              category: "Sandwich",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "131044300",
                              name: "Spinach & Corn Sandwich",
                              category: "Sandwich",
                              inStock: 1,
                              isVeg: 1,
                              price: 22200,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563599",
                              name: "Grilled Veg Paneer Sandwich",
                              category: "Sandwich",
                              description: "Grilled Paneer + Tomato + Onion + Tandoori Mayonnaise",
                              imageId: "str6dgmj5eya9agsgnvb",
                              inStock: 1,
                              isVeg: 1,
                              price: 24900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "413 ratings",
                                  ratingCountV2: "413",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "4077798",
                              name: "Classic Tandoori Sandwich",
                              category: "Sandwich",
                              imageId: "40e4f266cf84360d5d9627d5e6c72ae0",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.6",
                                  ratingCount: "270 ratings",
                                  ratingCountV2: "270",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563604",
                              name: "Classic Spicy Sandwich",
                              category: "Sandwich",
                              description:
                                "Medium Spicy | Serves 1 | Capsicum + Broccoli +Zucchini + Jalapeno with Spicy Red Sauce & Cheese",
                              imageId: "94a98482c0464145876da568c6798527",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                spiceLevel: "MEDIUMSPICY",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "47 ratings",
                                  ratingCountV2: "47",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "5628459",
                              name: "Aloo Tikki Sandwich",
                              category: "Sandwich",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "84 ratings",
                                  ratingCountV2: "84",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563600",
                              name: "Cheese Sandwich",
                              category: "Sandwich",
                              imageId: "xj01vjh08icbrhu420pc",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "27 ratings",
                                  ratingCountV2: "27",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563602",
                              name: "American Cheese Sandwich",
                              category: "Sandwich",
                              description:
                                "Broccoli + Beans + Zucchini + Carrot + Capsicum + Onion + White Cream Sauce",
                              imageId: "c1adipam0khlnpzhs9dx",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.7",
                                  ratingCount: "33 ratings",
                                  ratingCountV2: "33",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563603",
                              name: "Club Sandwich",
                              category: "Sandwich",
                              description:
                                "Broccoli + Zucchini + Beans + Carrot + Jalapeno with Creamy Red Sauce",
                              imageId: "jkjlc3veehrqrhnrnyoy",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.3",
                                  ratingCount: "74 ratings",
                                  ratingCountV2: "74",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "19021815",
                              name: "Falafel Hummus Sandwich",
                              category: "Sandwich",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "24 ratings",
                                  ratingCountV2: "24",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443767",
                              name: "Dark Brown Special Sandwich",
                              category: "Sandwich",
                              inStock: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "28 ratings",
                                  ratingCountV2: "28",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443770",
                              name: "Chicken Seekh Kabab Sandwich",
                              category: "Sandwich",
                              description: "Serves 1",
                              imageId: "14dcb6590eae683347d10110e3e6e149",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "9 ratings",
                                  ratingCountV2: "9",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388431",
                              name: "Grilled Chicken Sandwich",
                              category: "Sandwich",
                              imageId: "ec63478e4ad42136c9487610eee216d1",
                              inStock: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "30 ratings",
                                  ratingCountV2: "30",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388434",
                              name: "Open Melted Chicken Sandwich",
                              category: "Sandwich",
                              description: "Serves 1",
                              inStock: 1,
                              price: 38000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388436",
                              name: "Chicken Club Sandwich",
                              category: "Sandwich",
                              description: "Serves 1",
                              imageId: "ee1d9bc6bcf464604ff0cec46b9c02ef",
                              inStock: 1,
                              price: 38000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "20 ratings",
                                  ratingCountV2: "20",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388441",
                              name: "Chicken Peri Peri Sandwich",
                              category: "Sandwich",
                              imageId: "2a442efd895aa9fa05506b2315abba04",
                              inStock: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.7",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805936",
                              name: "Veg. Grilled Sandwich",
                              category: "Sandwich",
                              description: "Serves 1",
                              imageId: "091477b70271890f13a61d7780e819d6",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "216 ratings",
                                  ratingCountV2: "216",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805939",
                              name: "Veg. Delight Sandwich",
                              category: "Sandwich",
                              inStock: 1,
                              isVeg: 1,
                              price: 24900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.3",
                                  ratingCount: "34 ratings",
                                  ratingCountV2: "34",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806078",
                              name: "Roast Chicken Crispy Club Sandwich",
                              category: "Sandwich",
                              inStock: 1,
                              price: 38000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443768",
                              name: "Mutton Seekh Kabab Sandwich",
                              category: "Sandwich",
                              inStock: 1,
                              price: 38000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Burgers",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "9831785",
                              name: "Aloo Tikki Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "3cc3ae08ba8560f910f0381f2566ce5d",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "393 ratings",
                                  ratingCountV2: "393",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "9831787",
                              name: "Cheese Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "jsu8qp3kwejvrb0xrddl",
                              inStock: 1,
                              isVeg: 1,
                              price: 23000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "317 ratings",
                                  ratingCountV2: "317",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "9831788",
                              name: "Herbs Chilli Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "vpkswls0bwkvma5y9x3j",
                              inStock: 1,
                              isVeg: 1,
                              price: 23000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "674 ratings",
                                  ratingCountV2: "674",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "9831789",
                              name: "Paneer Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "9ece4c79b3c9925160c8b5ed04aa5cca",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "162 ratings",
                                  ratingCountV2: "162",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563607",
                              name: "Green Garden Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "568be84be60e75c383cb48297f33cfc0",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "68 ratings",
                                  ratingCountV2: "68",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "19021821",
                              name: "Open Veg Garden",
                              category: "Burgers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.3",
                                  ratingCount: "18 ratings",
                                  ratingCountV2: "18",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "71676686",
                              name: "Juicy Chicken Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "9bddd257aa31d6cc24a916819c4cdb1e",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.3",
                                  ratingCount: "16 ratings",
                                  ratingCountV2: "16",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "71676685",
                              name: "Egg Chicken Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "9bddd257aa31d6cc24a916819c4cdb1e",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60080568",
                              name: "Mutton Tikki Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "71c6bae748d2a5a672a09264d64b363e",
                              inStock: 1,
                              price: 33000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.3",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388387",
                              name: "Chicken Tikki Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "88750040ce94d78adb8ac68e2efac7bc",
                              inStock: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "13 ratings",
                                  ratingCountV2: "13",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388388",
                              name: "Pesto Chicken Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "75c578ed2633d445087409881a9f49b8",
                              inStock: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "13 ratings",
                                  ratingCountV2: "13",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806117",
                              name: "Falafel Hummus Wraps",
                              category: "Burgers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.5",
                                  ratingCount: "52 ratings",
                                  ratingCountV2: "52",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806154",
                              name: "Grilled Chicken Burger ",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "xzqv0r3aasdrdrahyfig",
                              inStock: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.6",
                                  ratingCount: "26 ratings",
                                  ratingCountV2: "26",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806155",
                              name: "Fish And Chips Burger",
                              category: "Burgers",
                              description: "Serves 1",
                              imageId: "2d720e91506f3c93c7f04dba210a64a5",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "22 ratings",
                                  ratingCountV2: "22",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Side Offers",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443796",
                              name: "Cheese Garlic Bread",
                              category: "Side Offers",
                              description:
                                "Serves 1 | Everything is Better with cheese & Garlicky Goodness.",
                              imageId: "ljygnylffanzx7rcsrxv",
                              inStock: 1,
                              isVeg: 1,
                              price: 20000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "152 ratings",
                                  ratingCountV2: "152",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443793",
                              name: "Cheese Fries",
                              category: "Side Offers",
                              description: "Serves 1",
                              imageId: "0d5b791377da53cf7c2102a278980a0a",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "17 ratings",
                                  ratingCountV2: "17",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443773",
                              name: "Crunchy French Fries",
                              category: "Side Offers",
                              description: "Serves 1",
                              imageId: "535619e08224a48b22c816fb14f363dd",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.7",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563572",
                              name: "French Fries",
                              category: "Side Offers",
                              description: "Serves 1",
                              imageId: "b7551843b418ccdf3584d1d148588057",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "152 ratings",
                                  ratingCountV2: "152",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563573",
                              name: "Garlic Bread Plain",
                              category: "Side Offers",
                              description: "Serves 1",
                              imageId: "0148886a811d917f3952631ff0d093af",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "75 ratings",
                                  ratingCountV2: "75",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563575",
                              name: "Falafel Pita Hummus",
                              category: "Side Offers",
                              description: "Serves 1",
                              imageId: "fd3068ca6121aa76c85425f2e1cf5969",
                              inStock: 1,
                              isVeg: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "94 ratings",
                                  ratingCountV2: "94",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805954",
                              name: "Peri Peri Fries",
                              category: "Side Offers",
                              description: "Serves 1",
                              imageId: "bae234a686ed5dbdb846fd0ffdee319f",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.7",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805988",
                              name: "Stuff Garlic Bread",
                              category: "Side Offers",
                              description: "Serves 1",
                              imageId: "mstnbqyyxfbazybgeedi",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.9",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805996",
                              name: "Nachos With Cheese",
                              category: "Side Offers",
                              description: "Serves 1",
                              imageId: "69f5be1332c45ea91d13d59be7b20874",
                              inStock: 1,
                              isVeg: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "105 ratings",
                                  ratingCountV2: "105",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "112579341",
                              name: "Cheese Peri-peri Fries",
                              category: "Side Offers",
                              description: "Peri peri fries loaded with melted mozzarella cheese",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Crispers Kingdom",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "64346558",
                              name: "Crispy Chicken Burger ",
                              category: "Crispers Kingdom",
                              description: "Serves 1",
                              imageId: "vov2s292tdwfqmalrfg2",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.8",
                                  ratingCount: "15 ratings",
                                  ratingCountV2: "15",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806082",
                              name: "Crispy Chicken Salad",
                              category: "Crispers Kingdom",
                              description: "Serves 1",
                              imageId: "42dfc1326334f98e56417eeaac98d364",
                              inStock: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Thirsty Quenchers",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "94150142",
                              name: "Chilli Guava",
                              category: "Thirsty Quenchers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "94150141",
                              name: "Yuzu",
                              category: "Thirsty Quenchers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60080573",
                              name: "Cumber Masala",
                              category: "Thirsty Quenchers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60080572",
                              name: "Strawberry Masala",
                              category: "Thirsty Quenchers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60080571",
                              name: "Masala Soda",
                              category: "Thirsty Quenchers",
                              description: "Serves 1",
                              imageId: "ab167572d31c1de981c8d713cf9ad3c1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.3",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60080570",
                              name: "Peach Masala",
                              category: "Thirsty Quenchers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "94150155",
                              name: "Kala Khatta",
                              category: "Thirsty Quenchers",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 19000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Combos",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "68554181",
                              name: "Noodles With Chilli Paneer",
                              category: "Combos",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 45000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "58999219",
                              name: "Fried Rice With Manchurian",
                              category: "Combos",
                              description: "Serves 1",
                              imageId: "75b34874b14a0b9acb07cd187f6218d8",
                              inStock: 1,
                              isVeg: 1,
                              price: 29000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "48 ratings",
                                  ratingCountV2: "48",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "58999218",
                              name: "Fried Rice With Chilli Paneer",
                              category: "Combos",
                              description: "Serves 1",
                              imageId: "830033471bd61b441d228b36091fb8ee",
                              inStock: 1,
                              isVeg: 1,
                              price: 38000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.7",
                                  ratingCount: "26 ratings",
                                  ratingCountV2: "26",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806049",
                              name: "Veg Noodles With Manchurian",
                              category: "Combos",
                              description: "Serves 1",
                              imageId: "4c152ef1e2f505f66faf957dccb097ff",
                              inStock: 1,
                              isVeg: 1,
                              price: 29000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "8 ratings",
                                  ratingCountV2: "8",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806096",
                              name: "Veg Noodles With Manchurian  ",
                              category: "Combos",
                              description: "Serves 1",
                              imageId: "4c152ef1e2f505f66faf957dccb097ff",
                              inStock: 1,
                              isVeg: 1,
                              price: 27000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "8 ratings",
                                  ratingCountV2: "8",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Dimsum",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "102736201",
                              name: "Chicken Gravy Dimsum (6pcs)",
                              category: "Dimsum",
                              description: "Serves 1",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "102736200",
                              name: "Achari Dimsum (6 Pcs)",
                              category: "Dimsum",
                              description: "Serves 1",
                              imageId: "b283f2b5308d30b4f7267c1613adbb12",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.1",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "102736199",
                              name: "Malai Dimsum (6 Pcs)",
                              category: "Dimsum",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "102736175",
                              name: "Gravy Dimsum (6 Pcs)",
                              category: "Dimsum",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60882574",
                              name: "Schezwan Chicken Dimsum ( 8 Pcs)",
                              category: "Dimsum",
                              description: "Serves 1",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "58994282",
                              name: "Kurkure Chicken Dimsum( 8 Pcs ) ",
                              category: "Dimsum",
                              description: "Serves 1",
                              imageId: "q6y6cmuqyvqz4crbjpvk",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.9",
                                  ratingCount: "19 ratings",
                                  ratingCountV2: "19",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "57097093",
                              name: "Chicken Dimsums ( 8 Pcs ) ",
                              category: "Dimsum",
                              description: "Serves 1",
                              imageId: "8a520958c2f2266213423a45a8e3d55f",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.4",
                                  ratingCount: "21 ratings",
                                  ratingCountV2: "21",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806134",
                              name: "Veg Dimsum",
                              category: "Dimsum",
                              description: "Serves 1",
                              imageId: "grmqhghpehvz5ifjhav7",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.7",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806135",
                              name: "Paneer & Corn Dimsum",
                              category: "Dimsum",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806136",
                              name: "Kurkure Veg Dimsum",
                              category: "Dimsum",
                              description: "Serves 1",
                              imageId: "02c4be58106b16a0652be6dc4a988395",
                              inStock: 1,
                              isVeg: 1,
                              price: 29000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "8 ratings",
                                  ratingCountV2: "8",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806137",
                              name: "Kurkure Paneer & Corn Dimsum",
                              category: "Dimsum",
                              description: "Serves 1",
                              imageId: "c36704a15ce6e88877122da04c888066",
                              inStock: 1,
                              isVeg: 1,
                              price: 33000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.7",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806138",
                              name: "Schezwan Veg Dimsums",
                              category: "Dimsum",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      title: "Desserts",
                      categories: [
                        {
                          title: "Desserts",
                          itemCards: [
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "78155342",
                                  name: "Strawberry Flurry",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 17000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "73170624",
                                  name: "Oreo Flurry",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 17000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.1",
                                      ratingCount: "5 ratings",
                                      ratingCountV2: "5",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "66322201",
                                  name: "Double Oreo Delight",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 26000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.9",
                                      ratingCount: "38 ratings",
                                      ratingCountV2: "38",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96805986",
                                  name: "Banoffee Pie",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  imageId: "c7e12b4629fad2e1669b48daa382ae77",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 26000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.1",
                                      ratingCount: "6 ratings",
                                      ratingCountV2: "6",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96805990",
                                  name: "Choco Torte",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 26000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.1",
                                      ratingCount: "7 ratings",
                                      ratingCountV2: "7",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96805992",
                                  name: "Chocolate Mousse",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  imageId: "ce6380d27931dd0812d94149d71aab13",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 17000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "2.8",
                                      ratingCount: "7 ratings",
                                      ratingCountV2: "7",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96805995",
                                  name: "Nutella Cheese Cake  ",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  imageId: "ptzys9t2u1t8peqvivdo",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.5",
                                      ratingCount: "35 ratings",
                                      ratingCountV2: "35",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806002",
                                  name: "Blueberry Cheese Cake Pastry",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  imageId: "4337482ed72b9ecb7cca0ba8c57ffd9e",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.7",
                                      ratingCount: "8 ratings",
                                      ratingCountV2: "8",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806009",
                                  name: "Real Strawberry With Nutella ",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806020",
                                  name: "Mango Flurry ",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 17000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806022",
                                  name: "Strawberry Mango Flurry",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 18000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96805980",
                                  name: "Hot Brownie With Hot Chocolate",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  imageId: "9079c5941e9c9ec99c9e1b3aed4c53ea",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 19900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.4",
                                      ratingCount: "960 ratings",
                                      ratingCountV2: "960",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96805981",
                                  name: "Hot Brownie With Hot Chocolate & Ice Cream",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  imageId: "c5edcee7c15971037868516ee43925f7",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 24000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.4",
                                      ratingCount: "98 ratings",
                                      ratingCountV2: "98",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96805999",
                                  name: "Irish Tiramisu",
                                  category: "Desserts",
                                  description: "Serves 1",
                                  imageId: "bxaapk8pkvswkqxwsjyt",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 29900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "1.3",
                                      ratingCount: "3 ratings",
                                      ratingCountV2: "3",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                          ],
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Pancakes",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "131044297",
                              name: "Fruit Pancake ( Cocktail Fruit )",
                              category: "Pancakes",
                              inStock: 1,
                              isVeg: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "67712150",
                              name: "Banana Pancake",
                              category: "Pancakes",
                              imageId: "nzwzp9asfa3zgutxclaq",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "67712151",
                              name: "Nutella Pancake",
                              category: "Pancakes",
                              imageId: "tqyuxpb01t6fk8nozot8",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "61 ratings",
                                  ratingCountV2: "61",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "67712152",
                              name: "Strawberry Pancake",
                              category: "Pancakes",
                              imageId: "06a55fe03d94f07e0de7fe8c0554bcdd",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "67712154",
                              name: "Classic Pancake",
                              category: "Pancakes",
                              imageId: "2d6137d6432637c31325f64e59464b6b",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.9",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Ice Creams",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "77820440",
                              name: "Vanilla with KitKat Ice Cream [2 Scoops]",
                              category: "Ice Creams",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.9",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "77820441",
                              name: "Vanilla With Oreo",
                              category: "Ice Creams",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "77820442",
                              name: "Vanilla with Hot Chocolate Ice Cream [2 Scoops]",
                              category: "Ice Creams",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "77820449",
                              name: "Black Currant",
                              category: "Ice Creams",
                              description: "Serves 1",
                              imageId: "47a331ccc02a2aec4e2b72a905ffe51a",
                              inStock: 1,
                              isVeg: 1,
                              price: 11000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806025",
                              name: "Vanilla",
                              category: "Ice Creams",
                              description: "Serves 1",
                              imageId: "6f24f0ae20baedb3d3bb2843492a6f4a",
                              inStock: 1,
                              isVeg: 1,
                              price: 11000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806027",
                              name: "Chocolate",
                              category: "Ice Creams",
                              description: "Serves 1",
                              imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                              inStock: 1,
                              isVeg: 1,
                              price: 11000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806033",
                              name: "Butterscotch",
                              category: "Ice Creams",
                              description: "Serves 1",
                              imageId: "efdcb4dfc667a0835f27b55796672649",
                              inStock: 1,
                              isVeg: 1,
                              price: 11000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806036",
                              name: "Strawberry",
                              category: "Ice Creams",
                              description: "Serves 1",
                              imageId: "a68ed28cf0610486535c4c0581792d37",
                              inStock: 1,
                              isVeg: 1,
                              price: 11000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806038",
                              name: "Fruit & Nut  ",
                              category: "Ice Creams",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 11000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806045",
                              name: "Mango ",
                              category: "Ice Creams",
                              description: "Serves 1",
                              imageId: "03230051babe743f1bfa4fa32031adfa",
                              inStock: 1,
                              isVeg: 1,
                              price: 11000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806047",
                              name: "Pineapple",
                              category: "Ice Creams",
                              description: "Serves 1",
                              imageId: "ac110bdd52bbe32e63c110435b218333",
                              inStock: 1,
                              isVeg: 1,
                              price: 11000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Full Cakes",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "59568174",
                              name: "Irish Tiramisu Cake",
                              category: "Full Cakes",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 237000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "59568175",
                              name: "Nutella Cheese Cake",
                              category: "Full Cakes",
                              description: "Serves 1",
                              imageId: "ubc1k5nevhg4btmgtmkc",
                              inStock: 1,
                              isVeg: 1,
                              price: 211000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "35 ratings",
                                  ratingCountV2: "35",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806075",
                              name: "Banoffee Pie  ",
                              category: "Full Cakes",
                              description: "Serves 1",
                              imageId: "c7e12b4629fad2e1669b48daa382ae77",
                              inStock: 1,
                              isVeg: 1,
                              price: 211000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806076",
                              name: "Blueberry Cheese Cake   ",
                              category: "Full Cakes",
                              description:
                                "Serves 1 | Blueberry jam topped on a rich cream and cheese dessert.",
                              imageId: "iso0xdar8lbewtjs5aqh",
                              inStock: 1,
                              isVeg: 1,
                              price: 224000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806077",
                              name: "Chocolate Torte Cake",
                              category: "Full Cakes",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 165000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Chinese Soup",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388208",
                              name: "Chicken Manchow Soup",
                              category: "Chinese Soup",
                              description: "Serves 1",
                              imageId: "49758aabff9bd651b59f7158ab09afd4",
                              inStock: 1,
                              price: 23000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.6",
                                  ratingCount: "13 ratings",
                                  ratingCountV2: "13",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806167",
                              name: "Chicken Hot & Sour Soup",
                              category: "Chinese Soup",
                              description: "Serves 1",
                              inStock: 1,
                              price: 23000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806169",
                              name: "Lemon Chicken Herbs   ",
                              category: "Chinese Soup",
                              description: "Serves 1",
                              inStock: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "9 ratings",
                                  ratingCountV2: "9",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806170",
                              name: "Broccoli Chicken Almond Soup   ",
                              category: "Chinese Soup",
                              description: "Serves 1",
                              inStock: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Main Course",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388454",
                              name: "Grilled Chicken Peri Peri Sauce",
                              category: "Main Course",
                              description: "Serves 1",
                              inStock: 1,
                              price: 77000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388349",
                              name: "Fish In Lemon Butter",
                              category: "Main Course",
                              description: "Serves 1",
                              imageId: "rzvdmz5s8ark7ztsbtbf",
                              inStock: 1,
                              price: 71000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.5",
                                  ratingCount: "28 ratings",
                                  ratingCountV2: "28",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388350",
                              name: "Grilled Fish Peri Peri",
                              category: "Main Course",
                              description: "Serves 1",
                              imageId: "bwdktio3gotz97y3qff3",
                              inStock: 1,
                              price: 77000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388352",
                              name: "Grilled Fish Mustard Cream Sauce",
                              category: "Main Course",
                              description: "Serves 1",
                              inStock: 1,
                              price: 77000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806104",
                              name: "Chicken Pepper Sticks",
                              category: "Main Course",
                              description: "Serves 1",
                              inStock: 1,
                              price: 77000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806105",
                              name: "Chicken Wings With BBQ Sauce",
                              category: "Main Course",
                              description:
                                "Serves 1 | Chicken wings glazed in smoky barbeque sauce.",
                              inStock: 1,
                              price: 66000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806107",
                              name: "Chicken Finger With Cocktail Sauce",
                              category: "Main Course",
                              description: "Serves 1",
                              inStock: 1,
                              price: 66000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806108",
                              name: "Grilled Chicken BBQ Sauce",
                              category: "Main Course",
                              description: "Serves 1",
                              inStock: 1,
                              price: 77000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.0",
                                  ratingCount: "1 rating",
                                  ratingCountV2: "1",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Chinese Starters",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "119533393",
                              name: "Schezwan Chicken Noodles",
                              category: "Chinese Starters",
                              inStock: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60883667",
                              name: "Schezwan Fried Rice",
                              category: "Chinese Starters",
                              description: "Serves 1",
                              imageId: "d8098eef65a1d6206c8c346de07cbc98",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60883668",
                              name: "Schezwan Chicken",
                              category: "Chinese Starters",
                              description: "Serves 1",
                              imageId: "48d2bd0aa185209cc3a4554fa7ee2538",
                              inStock: 1,
                              price: 54000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60883669",
                              name: "Chicken Chilli Garlic Noodles",
                              category: "Chinese Starters",
                              description: "Serves 1",
                              imageId: "3b0c49b1036dacc7ff13262dd6faef4e",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.9",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60883670",
                              name: "Chicken Noodles",
                              category: "Chinese Starters",
                              description: "Serves 1",
                              imageId: "ihp13zm3h9u12ymq7fti",
                              inStock: 1,
                              price: 36000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.7",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388374",
                              name: "Chilli Chicken Dry",
                              category: "Chinese Starters",
                              description: "Serves 1",
                              imageId: "xz4ex3t6g1ayctqkcmwz",
                              inStock: 1,
                              price: 56000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "39 ratings",
                                  ratingCountV2: "39",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388382",
                              name: "Chicken Hakka Noodles",
                              category: "Chinese Starters",
                              description: "Serves 1",
                              imageId: "b76c266831fe664e59abc336ad0fd53b",
                              inStock: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.9",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806171",
                              name: "Chicken Manchurian ",
                              category: "Chinese Starters",
                              description: "Serves 1",
                              imageId: "1fc87fae326ff5045b5cdfdcb179644e",
                              inStock: 1,
                              price: 54000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806172",
                              name: "Chicken Fried Rice",
                              category: "Chinese Starters",
                              description: "Serves 1",
                              imageId: "500a042557200e6298984c363fbd92a0",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Baked Paninis",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "131044302",
                              name: "Paneer Mushroom Panini",
                              category: "Baked Paninis",
                              inStock: 1,
                              isVeg: 1,
                              price: 45000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563585",
                              name: "Grilled Veg Panini",
                              category: "Baked Paninis",
                              inStock: 1,
                              isVeg: 1,
                              price: 36200,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.4",
                                  ratingCount: "56 ratings",
                                  ratingCountV2: "56",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563587",
                              name: "Grilled Veg Saucy Panini",
                              category: "Baked Paninis",
                              inStock: 1,
                              isVeg: 1,
                              price: 38000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "22 ratings",
                                  ratingCountV2: "22",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563588",
                              name: "Cottage Cheese Panini",
                              category: "Baked Paninis",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "20 ratings",
                                  ratingCountV2: "20",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "19021798",
                              name: "Mushroom Olive Panini",
                              category: "Baked Paninis",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "6 ratings",
                                  ratingCountV2: "6",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443776",
                              name: "Chicken Salami Sausage Panini",
                              category: "Baked Paninis",
                              inStock: 1,
                              price: 52000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443777",
                              name: "Chicken Seekh Kabab Panini",
                              category: "Baked Paninis",
                              inStock: 1,
                              price: 52000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443778",
                              name: "Mutton Seekh Kabab Panini",
                              category: "Baked Paninis",
                              inStock: 1,
                              price: 59900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27388423",
                              name: "Grilled Chicken Panini",
                              category: "Baked Paninis",
                              imageId: "e3224242c38d62a225bd1037ba7d4abc",
                              inStock: 1,
                              price: 52000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Tacos",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563589",
                              name: "Paneer Tacos",
                              category: "Tacos",
                              description:
                                "Serves 1 | Paneer, bell pepper, capsicum, onion, cabbage, creamy mayonnaise sauce.",
                              imageId: "12a8e7d99eab6f95536f7f08cf4af076",
                              inStock: 1,
                              isVeg: 1,
                              price: 31000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "51 ratings",
                                  ratingCountV2: "51",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563591",
                              name: "Super Classic Tacos",
                              category: "Tacos",
                              description:
                                "Serves 1 | Bell pepper, capsicum, onion, cabbage, zucchini, cheesy creamy mayonnaise.",
                              imageId: "f56606366c2db184f6a262591e2c419f",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.9",
                                  ratingCount: "45 ratings",
                                  ratingCountV2: "45",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806109",
                              name: "Grilled Veg. Tacos",
                              category: "Tacos",
                              description: "Serves 1",
                              imageId: "ff5a15c4ce8b1c59a23d441f871a9190",
                              inStock: 1,
                              isVeg: 1,
                              price: 28000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.7",
                                  ratingCount: "65 ratings",
                                  ratingCountV2: "65",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Bagel",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60859014",
                              name: "Pesto Chicken Bagel",
                              category: "Bagel",
                              description: "Serves 1",
                              imageId: "5a89357a633d22b5693ba921d898c8d9",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "60859013",
                              name: "Chicken Tikki Bagel",
                              category: "Bagel",
                              description: "Serves 1",
                              imageId: "edc69ad93120c06f55266dc8fe0e4035",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "57916185",
                              name: "Grilled Chicken Bagel",
                              category: "Bagel",
                              description: "Serves 1",
                              imageId: "25e3c34c7af8c524eaa64c12d01522b9",
                              inStock: 1,
                              price: 29900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806110",
                              name: "Aloo Tikki Bagel",
                              category: "Bagel",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806112",
                              name: "Herbs Chilli Bagel",
                              category: "Bagel",
                              description: "Serves 1",
                              imageId: "b8bcb318f382123eec1172928a8320e9",
                              inStock: 1,
                              isVeg: 1,
                              price: 24000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806115",
                              name: "Paneer Bagel",
                              category: "Bagel",
                              description: "Serves 1",
                              imageId: "fb1f4a69f486d3ef31c1fafad7543145",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "14 ratings",
                                  ratingCountV2: "14",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806156",
                              name: "Mutton Tikki Bagel",
                              category: "Bagel",
                              description: "Serves 1",
                              inStock: 1,
                              price: 38000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806157",
                              name: "Fish And Chips Bagel",
                              category: "Bagel",
                              description: "Serves 1",
                              inStock: 1,
                              price: 34000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Lasagne",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000930",
                              name: "Mix Veg Lasagne",
                              category: "Lasagne",
                              description: "Serves 1",
                              imageId: "44783dba22554b9ff18845d8fe922de0",
                              inStock: 1,
                              isVeg: 1,
                              price: 49000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.5",
                                  ratingCount: "41 ratings",
                                  ratingCountV2: "41",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "25000932",
                              name: "Lasagne Au Gratin",
                              category: "Lasagne",
                              description: "Serves 1",
                              imageId: "c861891be6cc3fa64f67365e84163c92",
                              inStock: 1,
                              isVeg: 1,
                              price: 51000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "9 ratings",
                                  ratingCountV2: "9",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443779",
                              name: "Chicken Lasagne",
                              category: "Lasagne",
                              description: "Serves 1",
                              imageId: "60173f4337a1c98baf3c3f938e379cbc",
                              inStock: 1,
                              price: 65000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "26 ratings",
                                  ratingCountV2: "26",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443780",
                              name: "Bolognese Lasagne",
                              category: "Lasagne",
                              description: "Serves 1",
                              inStock: 1,
                              price: 65000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.3",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806132",
                              name: "Spinach & Mushroom Lasagne",
                              category: "Lasagne",
                              description: "Serves 1",
                              imageId: "d1cc2859dd50af644da76c84eb510461",
                              inStock: 1,
                              isVeg: 1,
                              price: 49000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Pizza",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443763",
                              name: "Mutton Seekh Kabab Pizza [Thin Crust, 10 Inches]",
                              category: "Pizza",
                              description: "(Mutton Seekh kabab & mutton keema)",
                              inStock: 1,
                              price: 71900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806164",
                              name: "Dark Brown Special Pizza",
                              category: "Pizza",
                              description:
                                "( Onion, Bell pepper, Green capsicum, Chicken Salami, Sausage, Cherry tomato )",
                              inStock: 1,
                              price: 78000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "27443764",
                              name: "Roast Chicken Pizza",
                              category: "Pizza",
                              description: "(Roast Chicken & Onion)",
                              inStock: 1,
                              price: 78000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806120",
                              name: "Farmhouse Pizza",
                              category: "Pizza",
                              description:
                                "Serves 1 | ( Red Capsicum, yellow Capsicum, Green capsicum , Zucchini, Mushroom, Broccoli, onion, Black olive & jalapeno )",
                              imageId: "018ad788525ec67d39c1e8597a0b0122",
                              inStock: 1,
                              isVeg: 1,
                              price: 52000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806121",
                              name: "Dark Brown Special Pizza ",
                              category: "Pizza",
                              description:
                                "Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, onion, Cherry Tomato, paneer, Black olive, jalapeno)",
                              inStock: 1,
                              isVeg: 1,
                              price: 52000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.9",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806122",
                              name: "Spicy Corn Pizza",
                              category: "Pizza",
                              description: "Green capsicum, onion, Corn, black olive, jalapeno)",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806124",
                              name: "Paneer Pizza",
                              category: "Pizza",
                              description:
                                "Red Capsicum, yellow Capsicum, Green capsicum, Paneer, Onion, black Olive, jalapeno  )",
                              imageId: "5b09fbb51bd0f2a0d0784fe17a66bdc1",
                              inStock: 1,
                              isVeg: 1,
                              price: 52000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806125",
                              name: "Margarita Pizza",
                              category: "Pizza",
                              imageId: "5b1ee7b75a9b6b041ab45b9c1f95b22d",
                              inStock: 1,
                              isVeg: 1,
                              price: 35000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.1",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806126",
                              name: "Four Season Pizza",
                              category: "Pizza",
                              description:
                                "( Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, Mushroom, zucchini, Onion, black Olive, jalapeno  )",
                              inStock: 1,
                              isVeg: 1,
                              price: 46000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806129",
                              name: "Simply English Vegetable Pizza",
                              category: "Pizza",
                              description:
                                "( Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, zucchini, Cherry tomato, black Olive, jalapeno  )",
                              inStock: 1,
                              isVeg: 1,
                              price: 45000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806131",
                              name: "Grilled Vegetable Pizza",
                              category: "Pizza",
                              description:
                                "Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, zucchini, Onion, black Olive, jalapeno  )",
                              imageId: "018ad788525ec67d39c1e8597a0b0122",
                              inStock: 1,
                              isVeg: 1,
                              price: 43000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.1",
                                  ratingCount: "8 ratings",
                                  ratingCountV2: "8",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806158",
                              name: "BBQ Chicken Pizza",
                              category: "Pizza",
                              description:
                                "( Onion, Bell pepper, Green capsicum, jalapeno & Grilled chicken )",
                              inStock: 1,
                              price: 71900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806159",
                              name: "Chicken Sausage Salami Pizza ",
                              category: "Pizza",
                              description: "chicken sausage & chicken salami)",
                              inStock: 1,
                              price: 71900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806161",
                              name: "Chicken Seekh Kabab Pizza ",
                              category: "Pizza",
                              description: "Chicken Seekh Kabab & chicken Keema)",
                              inStock: 1,
                              price: 71900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806163",
                              name: "Bolognese Pizza",
                              category: "Pizza",
                              description: "(Bolognese Sauce)",
                              inStock: 1,
                              price: 78000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806165",
                              name: "Pepperoni Pizza Chicken ",
                              category: "Pizza",
                              inStock: 1,
                              price: 71900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "NONVEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      title: "Pastas",
                      categories: [
                        {
                          title: "Others",
                          itemCards: [
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "27388442",
                                  name: "Fusilli Chicken Peri Peri Pasta",
                                  category: "Pastas",
                                  inStock: 1,
                                  price: 59900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "1.1",
                                      ratingCount: "5 ratings",
                                      ratingCountV2: "5",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "27388445",
                                  name: "Angry Chicken Pasta",
                                  category: "Pastas",
                                  imageId: "c0bfda4a4b0dbb1fa4125334cf2c854d",
                                  inStock: 1,
                                  price: 59900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "5.0",
                                      ratingCount: "6 ratings",
                                      ratingCountV2: "6",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806087",
                                  name: "Spaghetti Agli -E- Olio With Chicken Sausage",
                                  category: "Pastas",
                                  inStock: 1,
                                  price: 62000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "96806088",
                                  name: "Chicken Special Pasta",
                                  category: "Pastas",
                                  imageId: "40db6ecddd849b636b32e4085a40eec7",
                                  inStock: 1,
                                  price: 59900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "NONVEG",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                          ],
                        },
                        {
                          title: "veg",
                          itemCards: [
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100949071",
                                  name: "Red Sauce Pasta (penne)",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "536e15c646ffd0f83a2e8eadd604d54d",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.3",
                                      ratingCount: "15 ratings",
                                      ratingCountV2: "15",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100949072",
                                  name: "White Sauce Pasta (penne)",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "5c04c7cb43b0568e32214f49a53dbd30",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 29000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.8",
                                      ratingCount: "84 ratings",
                                      ratingCountV2: "84",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100949073",
                                  name: "Mix Sauce Pasta (Penne)",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "59a99f7eee5a4656b7b6d82490857463",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 29000,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.1",
                                      ratingCount: "193 ratings",
                                      ratingCountV2: "193",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100949074",
                                  name: "Cheese Red Pasta (Penne)",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "536e15c646ffd0f83a2e8eadd604d54d",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "2.5",
                                      ratingCount: "3 ratings",
                                      ratingCountV2: "3",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100949075",
                                  name: "Cheese White Pasta (Penne)",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "5c04c7cb43b0568e32214f49a53dbd30",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.1",
                                      ratingCount: "28 ratings",
                                      ratingCountV2: "28",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100949078",
                                  name: "Cheese Mix Pasta  (Penne)",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "59a99f7eee5a4656b7b6d82490857463",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 28900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.2",
                                      ratingCount: "35 ratings",
                                      ratingCountV2: "35",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "19021816",
                                  name: "Penne Arrabiata",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "40ba0ede04a674f12e64b09029be1345",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 34900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.2",
                                      ratingCount: "12 ratings",
                                      ratingCountV2: "12",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100893292",
                                  name: "Fusili Mushroom White Sauce Pasta",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "d5df473cf89e89a7f0cae44553ae9fea",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 39900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "4.2",
                                      ratingCount: "6 ratings",
                                      ratingCountV2: "6",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100893295",
                                  name: "Penne Al Pesto",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 39900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100893347",
                                  name: "Fusili Mushroom Mix Sauce Pasta",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 39900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "2.4",
                                      ratingCount: "3 ratings",
                                      ratingCountV2: "3",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100893450",
                                  name: "Spaghetti Agli e olio",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 39900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "12563580",
                                  name: "Penne Veg White Sauce Creamy Pasta",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "96820e37b9482a60aca119d095cf729b",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 39900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "2.9",
                                      ratingCount: "21 ratings",
                                      ratingCountV2: "21",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100893523",
                                  name: "Penne Veg Peri Peri",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 39900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {},
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                            {
                              card: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                info: {
                                  id: "100893530",
                                  name: "Spaghetti Mix Sauce Pasta",
                                  category: "Pastas",
                                  description: "Serves 1",
                                  imageId: "9dcee1b5913aae284ffd57c00627bf35",
                                  inStock: 1,
                                  isVeg: 1,
                                  price: 39900,
                                  variants: {},
                                  variantsV2: {},
                                  itemAttribute: {
                                    vegClassifier: "VEG",
                                    portionSize: "Serves 1",
                                  },
                                  ribbon: {},
                                  type: "ITEM",
                                  itemBadge: {},
                                  badgesV2: {},
                                  ratings: {
                                    aggregatedRating: {
                                      rating: "3.4",
                                      ratingCount: "13 ratings",
                                      ratingCountV2: "13",
                                    },
                                  },
                                },
                                analytics: {},
                                hideRestaurantDetails: true,
                              },
                            },
                          ],
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Mocktails",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "7056301",
                              name: "Virgin Mojito",
                              category: "Mocktails",
                              description: "Serves 1",
                              imageId: "d0jjfnhf4t4brhchlw4b",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "183 ratings",
                                  ratingCountV2: "183",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "7056311",
                              name: "Green Apple Mojito",
                              category: "Mocktails",
                              description: "Serves 1",
                              imageId: "776a4a120fbce02806951ade1b97ded0",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.7",
                                  ratingCount: "50 ratings",
                                  ratingCountV2: "50",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805942",
                              name: "Blue Curacao",
                              category: "Mocktails",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805945",
                              name: "Passion Fruit",
                              category: "Mocktails",
                              description: "Serves 1",
                              imageId: "a134dc0225e7ca4b8e4b853a6b65407a",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "116447672",
                              name: "Spiced Jamun",
                              category: "Mocktails",
                              description: "Spicy flavour blended with special jamun flavour",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Iced Tea",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "73170623",
                              name: "Rose Ice Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "8271207",
                              name: "Lemon Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              imageId: "52a616fff6521fcb4c28570bb91b84e5",
                              inStock: 1,
                              isVeg: 1,
                              price: 16000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "57 ratings",
                                  ratingCountV2: "57",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "8271209",
                              name: "Passion Fruit Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.6",
                                  ratingCount: "12 ratings",
                                  ratingCountV2: "12",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "12563606",
                              name: "Peach Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              imageId: "r6g0oromxk8kkjqqrkrx",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.9",
                                  ratingCount: "19 ratings",
                                  ratingCountV2: "19",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "8271208",
                              name: "Green Apple Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              imageId: "e49efb6c2db991b1b01fcea12a9980e4",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.0",
                                  ratingCount: "11 ratings",
                                  ratingCountV2: "11",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806000",
                              name: "Black Berry Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "14 ratings",
                                  ratingCountV2: "14",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806004",
                              name: "Pomegranate Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806012",
                              name: "Paan Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806015",
                              name: "Grenadine Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806016",
                              name: "Saffron Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806019",
                              name: "Watermelon Iced Tea",
                              category: "Iced Tea",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "117181217",
                              name: "Strawberry Iced Tea",
                              category: "Iced Tea",
                              inStock: 1,
                              isVeg: 1,
                              price: 18000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Waffle",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805928",
                              name: "Double Banana Toffee Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805930",
                              name: "Single classic Waffle",
                              category: "Waffle",
                              description: "Serves 1 | (Maple Syrup, Butter & Ice-cream)",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805932",
                              name: "Double Classic Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 27000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805933",
                              name: "Single Strawberry Waffle With Nutella",
                              category: "Waffle",
                              description: "Serves 1 | (real Strawberries, maple Syrup & Nutella)",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "1.8",
                                  ratingCount: "3 ratings",
                                  ratingCountV2: "3",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805935",
                              name: "Double Strawberry Waffle With Nutella",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805938",
                              name: "Single Kitkat Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | Nutella, Maple Syrup, Crushed Nuts, KitKat & Vanilla Ice-cream)",
                              imageId: "5d4d64797a3e4c43409eb3b79b826420",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "75 ratings",
                                  ratingCountV2: "75",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805940",
                              name: "Double Kitkat Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.4",
                                  ratingCount: "14 ratings",
                                  ratingCountV2: "14",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805941",
                              name: "Single Oreo Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | Maple Syrup, Nutella, Vanilla Ice-cream, Crushed Nuts & Oreo)",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.8",
                                  ratingCount: "22 ratings",
                                  ratingCountV2: "22",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805943",
                              name: "Double Oreo Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805950",
                              name: "Single Fresh Fruits Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | (Fresh Fruits, Maple Syrup, Whip cream, Vanilla ice-cream)",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.5",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805953",
                              name: "Double Fresh Fruits Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805963",
                              name: "Single Pineapple Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | ( Real pineapple with Maple Syrup & vanilla Ice-cream)",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805965",
                              name: "Double Pineapple Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805968",
                              name: "Single Ferrero Rocher Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | ( Ferrero Rocher Chocolate with Nutella Topping & vanilla Ice-cream )",
                              inStock: 1,
                              isVeg: 1,
                              price: 26000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "17 ratings",
                                  ratingCountV2: "17",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805970",
                              name: "Double Ferrero Rocher Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 48000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.4",
                                  ratingCount: "4 ratings",
                                  ratingCountV2: "4",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806051",
                              name: "Single Nutella Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | Maple syrup, Nutella, Crushed Nuts & Vanilla Ice-cream)",
                              imageId: "1deeb6515010bf8158f3f9359f330951",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.2",
                                  ratingCount: "125 ratings",
                                  ratingCountV2: "125",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806055",
                              name: "Single Peanut Butter",
                              category: "Waffle",
                              description:
                                "Serves 1 | ( Maple Syrup, Peanut Butter with Crushed nuts, Whip Cream & Vanilla Ice-cream)",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806057",
                              name: "Double Peanut Butter",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806059",
                              name: "Single Blueberry Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | Maple Syrup, Whip Cream, Blueberry jam, Vanilla Ice-cream)",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "15 ratings",
                                  ratingCountV2: "15",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806061",
                              name: "Double Blueberry Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806063",
                              name: "Single Chocolate Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | (maple Syrup, Dark Chocolate, Crushed Nuts & Chocolate Ice-cream)",
                              imageId: "5d6f3edb647b154304beedd932887dbb",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "11 ratings",
                                  ratingCountV2: "11",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806065",
                              name: "Double Chocolate Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              imageId: "1deeb6515010bf8158f3f9359f330951",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "2.8",
                                  ratingCount: "7 ratings",
                                  ratingCountV2: "7",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806067",
                              name: "Single Strawberry Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | Maple Syrup, Whip Cream, Strawberry jam, Vanilla Ice-cream)",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806068",
                              name: "Double Strawberry Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806069",
                              name: "Single Banana Toffee Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | Fresh banana, maple Syrup, Whip Topping Cream, toffee Caramel)",
                              inStock: 1,
                              isVeg: 1,
                              price: 17000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "5.0",
                                  ratingCount: "5 ratings",
                                  ratingCountV2: "5",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96806053",
                              name: "Double Nutella Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              imageId: "1deeb6515010bf8158f3f9359f330951",
                              inStock: 1,
                              isVeg: 1,
                              price: 32000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "4.0",
                                  ratingCount: "75 ratings",
                                  ratingCountV2: "75",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805957",
                              name: "Single Real Mango Waffle",
                              category: "Waffle",
                              description:
                                "Serves 1 | Real Mangoes with Maple Syrup & vanilla Ice-cream)",
                              inStock: 1,
                              isVeg: 1,
                              price: 22000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "96805959",
                              name: "Double Real Mango Waffle",
                              category: "Waffle",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 42000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      title: "Ice Teas",
                      itemCards: [
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "101310298",
                              name: "Rose Ice Tea     ",
                              category: "Ice Teas",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "101310299",
                              name: "Lemon Iced Tea     ",
                              category: "Ice Teas",
                              description: "Serves 1",
                              imageId: "52a616fff6521fcb4c28570bb91b84e5",
                              inStock: 1,
                              isVeg: 1,
                              price: 14000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {
                                  rating: "3.6",
                                  ratingCount: "57 ratings",
                                  ratingCountV2: "57",
                                },
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "101310300",
                              name: "Passion Fruit Iced Tea     ",
                              category: "Ice Teas",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "101310301",
                              name: "Peach Iced Tea     ",
                              category: "Ice Teas",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "101310302",
                              name: "Green Apple Iced Tea     ",
                              category: "Ice Teas",
                              description: "Serves 1",
                              imageId: "e49efb6c2db991b1b01fcea12a9980e4",
                              inStock: 1,
                              isVeg: 1,
                              price: 15000,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                        {
                          card: {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            info: {
                              id: "124109210",
                              name: "Passion Fruit Mango Shake",
                              category: "Ice Teas",
                              description: "Serves 1",
                              inStock: 1,
                              isVeg: 1,
                              price: 19900,
                              variants: {},
                              variantsV2: {},
                              itemAttribute: {
                                vegClassifier: "VEG",
                                portionSize: "Serves 1",
                              },
                              ribbon: {},
                              type: "ITEM",
                              itemBadge: {},
                              badgesV2: {},
                              ratings: {
                                aggregatedRating: {},
                              },
                            },
                            analytics: {},
                            hideRestaurantDetails: true,
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type":
                        "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      type: "FSSAI",
                      imageId: "fssai_final_edss9i",
                      text: ["License No. 20821003000690"],
                    },
                  },
                },
                {
                  card: {
                    card: {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      name: "Lorem, ipsum",
                      area: "Sector 15",
                      completeAddress: "Shop - 144, booth no.163, Huda Market, sec15, faridabad",
                    },
                  },
                },
              ],
            },
          },
        },
      },
    ],
    firstOffsetRequest: true,
    isQCLink: false,
  },
  tid: "77533f11-5e8d-4b54-a4a7-1c92985210c7",
  sid: "d3bd968b-8262-4755-a5c0-d4ee42f09309",
  deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
  csrfToken: "QrzNyc0FD7FG-mWnJKo-_NXJdT_1A8Z2tGSo8wHQ",
};
